var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/theme/stitches.config.ts
import { createStitches, defaultThemeMap } from "@stitches/react";

// src/theme/theme-files/empty-theme-definition.js
var emptyThemeDefinition = {
  colors: {
    surfaceBackgroundPrimary: "",
    surfaceBackgroundSecondary: "",
    surfaceBackgroundTertiary: "",
    surfaceCardPrimary: "",
    surfaceCardSecondary: "",
    surfaceCardDisabled: "",
    onSurfaceTextPrimary: "",
    onSurfaceTextSubdued: "",
    onSurfaceTextCritical: "",
    onSurfaceTextSuccess: "",
    onSurfaceTextWarning: "",
    onSurfaceTextReversed: "",
    onSurfaceBorderSubdued: "",
    onSurfaceBorderDefault: "",
    onSurfaceIconPrimary: "",
    interactiveActionPrimary: "",
    interactiveActionHovered: "",
    interactiveActionPressed: "",
    interactiveActionSubdued: "",
    interactiveActionDisabled: "",
    interactiveBackgroundDefault: "",
    interactiveBackgroundDisabled: "",
    interactiveBackgroundHovered: "",
    interactiveBackgroundPressed: "",
    interactiveBorderDefault: "",
    interactiveBorderHovered: "",
    interactiveBorderDisabled: "",
    interactiveBorderCriticalDefault: "",
    interactiveFocusInner: "",
    interactiveFocusOuter: "",
    interactiveIconDefault: "",
    interactiveIconDisabled: "",
    criticalBackgroundSubdued: "",
    criticalBackgroundSecondary: "",
    criticalBorderDefault: "",
    criticalIcon: "",
    warningBackgroundSubdued: "",
    warningBackgroundSecondary: "",
    warningBorderDefault: "",
    warningIcon: "",
    successBackgroundSubdued: "",
    successBackgroundSecondary: "",
    successBorderDefault: "",
    successIcon: "",
    highlightBackgroundSubdued: "",
    highlightBackgroundSecondary: "",
    highlightBorderDefault: "",
    highlightIcon: "",
    decorativeBrandPrimaryDarkest: "",
    decorativeBrandPrimaryDark: "",
    decorativeBrandPrimaryDefault: "",
    decorativeBrandPrimaryBright: "",
    decorativeBrandPrimaryBrightest: "",
    decorativeBrandPrimaryPastel: "",
    decorativeBrandSecondaryDarkest: "",
    decorativeBrandSecondaryDark: "",
    decorativeBrandSecondaryDefault: "",
    decorativeBrandSecondaryBright: "",
    decorativeBrandSecondaryBrightest: "",
    decorativeBrandSecondaryPastel: "",
    decorativeBrandTertiaryDarkest: "",
    decorativeBrandTertiaryDark: "",
    decorativeBrandTertiaryDefault: "",
    decorativeBrandTertiaryBright: "",
    decorativeBrandTertiaryBrightest: "",
    decorativeBrandTertiaryPastel: "",
    primaryBackgroundDefault: "",
    primaryBackgroundHovered: "",
    primaryBackgroundPressed: "",
    primaryTextDefault: "",
    primaryBackgroundCriticalDefault: "",
    primaryBackgroundCriticalHovered: "",
    primaryBackgroundCriticalPressed: "",
    primaryTextCriticalDefault: "",
    secondaryBackgroundDefault: "",
    secondaryBackgroundHovered: "",
    secondaryBackgroundPressed: "",
    secondaryTextDefault: "",
    secondaryTextHovered: "",
    secondaryBorderDefault: "",
    tertiaryBackgroundDefault: "",
    tertiaryBackgroundHovered: "",
    tertiaryBackgroundPressed: "",
    tertiaryTextDefault: "",
    tertiaryTextHovered: "",
    tertiaryBorderDefault: "",
    inputBackgroundDefault: "",
    inputBackgroundDisabled: "",
    inputBackgroundHovered: "",
    inputBackgroundPressed: "",
    inputBorderDefault: "",
    inputBorderHovered: "",
    inputBorderDisabled: "",
    inputBorderCritical: "",
    inputBorderSuccess: "",
    inputBorderWarning: ""
  },
  space: {
    none: "",
    quarter: "",
    half: "",
    threeQuarters: "",
    one: "",
    oneAndHalf: "",
    two: "",
    twoAndHalf: "",
    three: "",
    four: "",
    five: ""
  },
  sizes: {
    none: "",
    quarter: "",
    half: "",
    threeQuarters: "",
    one: "",
    oneAndHalf: "",
    two: "",
    twoAndHalf: "",
    three: "",
    four: "",
    five: ""
  },
  fonts: {
    headings: "",
    body: "",
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    subtitleOne: "",
    subtitleTwo: "",
    bodyOne: "",
    bodyTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  fontSizes: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    subtitleOne: "",
    subtitleTwo: "",
    bodyOne: "",
    bodyTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  fontWeights: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  lineHeights: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    subtitleOne: "",
    subtitleTwo: "",
    bodyOne: "",
    bodyTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  letterSpacings: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  textDecorations: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  textTransforms: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  borderWidths: {
    thin: "",
    thick: ""
  },
  zIndices: {
    default: "",
    sticky: "",
    dropdown: "",
    tooltip: "",
    modal: "",
    toast: ""
  },
  transitions: {
    defaultTime: ""
  },
  radii: {
    none: "",
    thin: "",
    thick: "",
    small: "",
    medium: "",
    large: "",
    extraLarge: "",
    huge: "",
    pill: "",
    circle: "",
    button: "",
    inputField: ""
  },
  shadows: {
    card: "",
    dropdown: ""
  }
};

// src/theme/utils/typography.ts
var typography = (token) => ({
  fontSize: token,
  fontWeight: token,
  fontFamily: token,
  lineHeight: token,
  letterSpacing: token,
  textTransform: token,
  textDecoration: token
});

// src/theme/utils/margins.ts
var marginX = (value) => ({
  marginLeft: value,
  marginRight: value
});
var marginY = (value) => ({
  marginTop: value,
  marginBottom: value
});

// src/theme/utils/padding.ts
var paddingX = (value) => ({
  paddingLeft: value,
  paddingRight: value
});
var paddingY = (value) => ({
  paddingTop: value,
  paddingBottom: value
});

// src/breakpoints/constants.ts
var breakpoints = {
  mobile: 0,
  mobileLandscape: 641,
  tablet: 768,
  laptop: 1024,
  desktop: 1280
};

// src/theme/stitches.config.ts
var themeDefinition = {
  theme: emptyThemeDefinition,
  // Empty theme to be overwritten with a client theme
  media: {
    mobile: `(max-width:${breakpoints.mobileLandscape - 1}px)`,
    mobileLandscape: `(min-width:${breakpoints.mobileLandscape}px) and (max-width:${breakpoints.tablet - 1}px)`,
    tablet: `(min-width:${breakpoints.tablet}px) and (max-width:${breakpoints.laptop - 1}px)`,
    laptop: `(min-width:${breakpoints.laptop}px) and (max-width:${breakpoints.desktop - 1}px)`,
    desktop: `(min-width:${breakpoints.desktop}px)`
  },
  utils: {
    typography,
    marginX,
    marginY,
    paddingX,
    paddingY
  },
  themeMap: __spreadProps(__spreadValues({}, defaultThemeMap), {
    textTransform: "textTransforms",
    textDecoration: "textDecorations",
    marginX: "space",
    marginY: "space",
    paddingX: "space",
    paddingY: "space",
    borderStartStartRadius: "radii",
    borderStartEndRadius: "radii",
    borderEndStartRadius: "radii",
    borderEndEndRadius: "radii"
  }),
  prefix: "GDS"
};
var { styled, theme, createTheme, config, css, keyframes } = createStitches(themeDefinition);

// src/theme/GDSThemeProvider.tsx
import React2, { createContext } from "react";

// src/theme/theme-container.tsx
import React, { forwardRef } from "react";
import * as RadixTooltipPrimitive from "@radix-ui/react-tooltip";

// src/theme/utils/focus-outline.ts
var focusOutlineOuter = {
  outline: "$borderWidths$outerFocus solid $colors$interactiveFocusOuter",
  outlineOffset: "$borderWidths$outerFocus"
};
var focusOutlineInner = {
  boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
  // Visible in Windows high-contrast themes
  outline: "$borderWidths$innerFocus  solid transparent"
};

// src/theme/theme-container.tsx
var ThemeContainerBase = styled("div", {
  '[class*="GDS"]:focus': __spreadValues({}, focusOutlineOuter),
  "*, *:before, *:after": {
    boxSizing: "border-box"
  }
});
var ThemeContainer = forwardRef(
  (_a, ref) => {
    var _b = _a, { theme: theme2, children } = _b, props = __objRest(_b, ["theme", "children"]);
    return /* @__PURE__ */ React.createElement(ThemeContainerBase, __spreadValues({ ref, className: theme2 }, props), /* @__PURE__ */ React.createElement(RadixTooltipPrimitive.Provider, null, children));
  }
);

// src/theme/GDSThemeProvider.tsx
var ThemeContext = createContext(void 0);
var GDSThemeProvider = ({ theme: theme2, children }) => {
  if (theme2 === void 0) {
    throw new Error("GDSThemeProvider requires a theme object.");
  }
  return /* @__PURE__ */ React2.createElement(ThemeContext.Provider, { value: theme2 }, /* @__PURE__ */ React2.createElement(ThemeContainer, { theme: theme2 }, children));
};

// src/theme/theme-files/archetype-light-theme.ts
var archetypeLightTheme = {
  colors: {
    surface: {
      background: {
        primary: "#FFFFFFFF",
        secondary: "#F5F5F5FF",
        tertiary: "#19A7E9FF"
      },
      card: {
        primary: "#FFFFFFFF",
        secondary: "#F8F7F6FF",
        disabled: "#D7D7D7FF"
      }
    },
    onSurface: {
      text: {
        primary: "#333333FF",
        subdued: "#888888FF",
        reversed: "#FFFFFFFF",
        critical: "#BA1B3BFF",
        success: "#627D32FF",
        warning: "#333333FF"
      },
      border: { subdued: "#E0E3E6FF", default: "#959595FF" },
      icon: { primary: "#636363FF" }
    },
    interactive: {
      action: {
        primary: "#006594FF",
        hovered: "#208BBDFF",
        pressed: "#005075FF",
        subdued: "#66686BFF",
        disabled: "#D6D6D6FF"
      },
      icon: { default: "#FFFFFFFF", disabled: "#949494FF" },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      },
      border: {
        default: "#949494FF",
        hovered: "#005696FF",
        disabled: "#D6D6D6FF",
        critical: { default: "#A12127FF" }
      },
      focus: { inner: "#11398AFF", outer: "#11398AFF" }
    },
    critical: {
      background: { subdued: "#F9E1E2FF", secondary: "#FFFFFFFF" },
      border: { default: "#A12127FF" },
      icon: "#CB2A32FF"
    },
    warning: {
      background: { subdued: "#FAE8D6FF", secondary: "#FFFFFFFF" },
      border: { default: "#DE6F12FF" },
      icon: "#DE6F12FF"
    },
    success: {
      background: { subdued: "#E3F7F0FF", secondary: "#FFFFFFFF" },
      border: { default: "#159369FF" },
      icon: "#159369FF"
    },
    highlight: {
      background: { subdued: "#E8F8FFFF", secondary: "#FFFFFFFF" },
      border: { default: "#2E5CDFFF" },
      icon: "#19A7E9FF"
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#074664FF",
          dark: "#00699AFF",
          default: "#008BCCFF",
          bright: "#6BC5EFFF",
          brightest: "#BBE9FFFF",
          pastel: "#F1FBFFFF"
        },
        secondary: {
          darkest: "#074E7AFF",
          dark: "#1C7EBBFF",
          default: "#9BC8E4FF",
          bright: "#9BD9FFFF",
          brightest: "#C0E7FFFF",
          pastel: "#F1FAFFFF"
        },
        tertiary: {
          darkest: "#845A09FF",
          dark: "#C2891BFF",
          default: "#F2A818FF",
          bright: "#F5C464FF",
          brightest: "#FFE4B0FF",
          pastel: "#FFF8EAFF"
        }
      }
    },
    primary: {
      background: {
        default: "#006594FF",
        hovered: "#208BBDFF",
        pressed: "#005075FF",
        critical: {
          default: "#CB2A32FF",
          hovered: "#A51834FF",
          pressed: "#711124FF"
        }
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } }
    },
    secondary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#208BBDFF",
        pressed: "#F0F0F0FF"
      },
      text: { default: "#006594FF", hovered: "#FFFFFFFF" },
      border: { default: "#006594FF" }
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#208BBDFF",
        pressed: "#F0F0F0FF"
      },
      text: { default: "#006594FF", hovered: "#FFFFFFFF" },
      border: { default: "#707E89FF" }
    },
    input: {
      border: {
        success: "#159369FF",
        warning: "#DE6F12FF",
        default: "#949494FF",
        hovered: "#005696FF",
        disabled: "#D6D6D6FF",
        critical: "#A12127FF"
      },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      }
    }
  },
  shadows: {
    card: { x: 0, y: 2, blur: 6, spread: 0, color: "#00000014" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#0000001A" }
  },
  typography: {
    headingOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingThree: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingFour: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOneSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwoSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    buttonOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    buttonTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    label: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    overline: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "UPPER",
      textDecoration: "none"
    },
    caption: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    tab: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    }
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4e3,
    tooltip: 5e3,
    modal: 8e3,
    toast: 9e3
  },
  transitions: {
    defaultTime: "200ms"
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75
    },
    baseSize: 16
  },
  fonts: {
    headings: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  }
};

// src/theme/theme-files/archetype-dark-theme.ts
var archetypeDarkTheme = {
  colors: {
    surface: {
      background: {
        primary: "#111111FF",
        secondary: "#333333FF",
        tertiary: "#555555FF"
      },
      card: {
        primary: "#000000FF",
        secondary: "#3D3D3DFF",
        disabled: "#585858FF"
      }
    },
    onSurface: {
      text: {
        primary: "#F9F9F9FF",
        subdued: "#CECECEFF",
        reversed: "#000000FF",
        critical: "#EF6782FF",
        success: "#BCF5E2FF",
        warning: "#F9F9F9FF"
      },
      border: { subdued: "#515B66FF", default: "#ADADADFF" },
      icon: { primary: "#CACACAFF" }
    },
    interactive: {
      action: {
        primary: "#72D1FEFF",
        hovered: "#99D3EEFF",
        pressed: "#28BBFFFF",
        subdued: "#D3D3D3FF",
        disabled: "#A8A8A8FF"
      },
      icon: { default: "#171717FF", disabled: "#474747FF" },
      background: {
        default: "#000000FF",
        disabled: "#1A1D22FF",
        hovered: "#070707FF",
        pressed: "#101010FF"
      },
      border: {
        default: "#ADADADFF",
        hovered: "#72D1FEFF",
        disabled: "#474747FF",
        critical: { default: "#EF6782FF" }
      },
      focus: { inner: "#A3BDF3FF", outer: "#9AB5EDFF" }
    },
    critical: {
      background: { subdued: "#5E0407FF", secondary: "#000000FF" },
      border: { default: "#F8D7D9FF" },
      icon: "#F491A5FF"
    },
    warning: {
      background: { subdued: "#443D00FF", secondary: "#000000FF" },
      border: { default: "#FFF0A2FF" },
      icon: "#FFF0A2FF"
    },
    success: {
      background: { subdued: "#0E6932FF", secondary: "#000000FF" },
      border: { default: "#9AEFD3FF" },
      icon: "#9AEFD3FF"
    },
    highlight: {
      background: { subdued: "#00374FFF", secondary: "#000000FF" },
      border: { default: "#94ACEFFF" },
      icon: "#C6EAFAFF"
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#F1FAFFFF",
          dark: "#C0E7FFFF",
          default: "#6BC5EFFF",
          bright: "#1C7EBBFF",
          brightest: "#074E7AFF",
          pastel: "#03253AFF"
        },
        secondary: {
          darkest: "#FFF8EAFF",
          dark: "#FFE4B0FF",
          default: "#F5C464FF",
          bright: "#F2A818FF",
          brightest: "#C2891BFF",
          pastel: "#845A09FF"
        },
        tertiary: {
          darkest: "#CCFF9AFF",
          dark: "#56FE64FF",
          default: "#18F2A4FF",
          bright: "#12B67BFF",
          brightest: "#0C7952FF",
          pastel: "#063D29FF"
        }
      }
    },
    primary: {
      background: {
        default: "#0F80B4FF",
        hovered: "#36A7DCFF",
        pressed: "#06A4EFFF",
        critical: {
          default: "#CB2A32FF",
          hovered: "#E13557FF",
          pressed: "#E75A76FF"
        }
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } }
    },
    secondary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#333333FF",
        pressed: "#1B1B1BFF"
      },
      text: { default: "#06A4EFFF", hovered: "#FFFFFFFF" },
      border: { default: "#06A4EFFF" }
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#F0F0F0FF",
        pressed: "#E1E1E1FF"
      },
      text: { default: "#C1C1C1FF", hovered: "#1E1E1EFF" },
      border: { default: "#C1C1C1FF" }
    },
    input: {
      border: {
        success: "#B3CE84FF",
        warning: "#FFF0A2FF",
        default: "#ADADADFF",
        hovered: "#72D1FEFF",
        disabled: "#474747FF",
        critical: "#EF6782FF"
      },
      background: {
        default: "#000000FF",
        disabled: "#1A1D22FF",
        hovered: "#070707FF",
        pressed: "#101010FF"
      }
    }
  },
  shadows: {
    card: { x: 0, y: 2, blur: 6, spread: 0, color: "#FFFFFF14" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#FFFFFF1A" }
  },
  typography: {
    headingOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingThree: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingFour: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOneSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwoSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    buttonOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    buttonTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    label: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    overline: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "UPPER",
      textDecoration: "none"
    },
    caption: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    tab: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    }
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4e3,
    tooltip: 5e3,
    modal: 8e3,
    toast: 9e3
  },
  transitions: {
    defaultTime: "200ms"
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75
    },
    baseSize: 16
  },
  fonts: {
    headings: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  }
};

// src/theme/formatters/utils.ts
var lowercaseFirstLetter = (string) => string.slice(0, 1).toLowerCase() + string.slice(1);
var uppercaseFirstLetter = (string) => string.slice(0, 1).toUpperCase() + string.slice(1);
var toUnit = (input, unit2) => {
  const converted = {};
  Object.keys(input).forEach((key) => {
    if (typeof input[key] === "string") {
      const valueAsString = String(input[key]);
      converted[key] = valueAsString.indexOf("$") === 0 ? valueAsString : `${input[key]}${unit2}`;
    } else {
      const valueAsNumber = Number(input[key]);
      converted[key] = valueAsNumber === 0 ? valueAsNumber : `${input[key]}${unit2}`;
    }
  });
  return converted;
};
var toPx = (input) => toUnit(input, "px");
var toRem = (input) => toUnit(input, "rem");
var flattenNestedTokens = (input = {}) => {
  const result = {};
  function getTokenPath(haystack, path = []) {
    Object.keys(haystack).forEach((key) => {
      const value = haystack[key];
      if (typeof value === "string" || Number.isFinite(value)) {
        const nestedKey = [...path, key].map(
          (part, index) => index === 0 ? lowercaseFirstLetter(part) : uppercaseFirstLetter(part)
        ).join("");
        result[nestedKey] = value;
      } else {
        getTokenPath(value, [...path, key]);
      }
    });
  }
  getTokenPath(input);
  return result;
};
var getNegativeSpacing = (spacing) => {
  const negativeSpacing = {};
  Object.keys(spacing).forEach((spacingKey) => {
    const spacingValue = spacing[spacingKey];
    if (spacingValue !== 0 && !`${spacingValue}`.includes("$")) {
      negativeSpacing[`minus${uppercaseFirstLetter(spacingKey)}`] = spacingValue * -1;
    }
  });
  return negativeSpacing;
};
var fontWeightsByName = {
  thin: 100,
  extralight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
  extrablack: 950
};
var fontWeightNameAliases = {
  normal: "regular",
  heavy: "black",
  ultraheavy: "extrablack"
};
var getFontWeightNumberByName = (name) => {
  const formattedName = name.replace(/[^a-zA-Z]*/gi, "").toLowerCase();
  const fontWeightToken = formattedName in fontWeightsByName ? formattedName : fontWeightNameAliases[formattedName];
  return fontWeightsByName[fontWeightToken];
};
var getFontWeightTokenByNumber = (fontWeight) => {
  let fontWeightToken = "regular";
  Object.entries(fontWeightsByName).forEach(
    ([fontWeightKey, fontWeightValue]) => {
      if (fontWeightValue === fontWeight) {
        fontWeightToken = fontWeightKey;
      }
    }
  );
  return fontWeightToken;
};

// src/theme/formatters/format-theme-for-stitches.ts
var getColors = (themeInput) => {
  const result = flattenNestedTokens(themeInput == null ? void 0 : themeInput.colors);
  return result;
};
var getRemSpacing = (rawSpacing, baseSize) => Object.entries(rawSpacing).reduce(
  (remSpacing, [spacingKey, spacingValue]) => __spreadProps(__spreadValues({}, remSpacing), {
    [spacingKey]: spacingValue / baseSize
  }),
  {}
);
var getSpacing = ({ spacing: rawSpacing, typography: typography2, rem: { baseSize } }, useRems) => {
  const spacing = useRems ? getRemSpacing(rawSpacing, baseSize) : __spreadValues({}, rawSpacing);
  if (typography2) {
    const themeSpace = __spreadValues({}, spacing);
    Object.entries(typography2).forEach(
      ([typographyKey, { paragraphSpacing }]) => {
        Object.keys(themeSpace).forEach((spacingKey) => {
          if (themeSpace[spacingKey] === paragraphSpacing) {
            spacing[typographyKey] = `$${spacingKey}`;
          }
        });
      }
    );
  }
  return spacing;
};
var getFonts = (themeInput) => {
  const fonts = {};
  if (themeInput == null ? void 0 : themeInput.fonts) {
    Object.entries(themeInput.fonts).forEach(
      ([font, value]) => {
        fonts[font] = value;
      }
    );
  }
  if (themeInput == null ? void 0 : themeInput.typography) {
    const themeFonts = __spreadValues({}, fonts);
    Object.entries(themeInput.typography).forEach(
      ([typographyKey, { fontFamily }]) => {
        Object.keys(themeFonts).forEach((fontKey) => {
          if (themeFonts[fontKey] === fontFamily) {
            fonts[typographyKey] = `$${fontKey}`;
          }
        });
      }
    );
  }
  return fonts;
};
var getRemForProperty = (themeInput, property) => {
  var _a;
  const remValues = {};
  if ((_a = themeInput == null ? void 0 : themeInput.rem) == null ? void 0 : _a[property]) {
    Object.entries(themeInput.rem[property]).forEach(
      ([propertySize, value]) => {
        remValues[propertySize] = value;
      }
    );
  }
  Object.keys(themeInput.typography).forEach((typographyKey) => {
    if (!remValues[typographyKey]) {
      Object.keys(remValues).forEach((propertySizeKey) => {
        if (typographyKey.indexOf(propertySizeKey) > -1) {
          remValues[typographyKey] = `$${propertySizeKey}`;
        }
      });
    }
  });
  return toRem(remValues);
};
var getValuesForProperty = ({ typography: typography2 }, property) => {
  const tokenValues = {};
  if (typography2) {
    Object.entries(typography2).forEach(
      ([typographyKey, typographyToken]) => {
        const tokenValue = typographyToken[property];
        const aliasKey = Object.keys(tokenValues).find(
          (key) => typographyKey.indexOf(key) > -1 && typographyKey.length > key.length
        );
        tokenValues[typographyKey] = aliasKey ? `$${aliasKey}` : tokenValue;
      }
    );
  }
  return tokenValues;
};
var getPxValuesForProperty = (themeInput, property) => toPx(getValuesForProperty(themeInput, property));
var getRemFontSizes = (themeInput) => getRemForProperty(themeInput, "fontSizes");
var getPxFontSizes = (themeInput) => getPxValuesForProperty(themeInput, "fontSize");
var getRemLineHeights = (themeInput) => getRemForProperty(themeInput, "lineHeights");
var getPxLineHeights = (themeInput) => getPxValuesForProperty(themeInput, "lineHeight");
var getLetterSpacings = (themeInput) => getPxValuesForProperty(themeInput, "letterSpacing");
var getFontWeights = (themeInput) => {
  const fontWeights = {};
  if (themeInput == null ? void 0 : themeInput.fontWeights) {
    Object.entries(themeInput.fontWeights).forEach(
      ([font, value]) => {
        fontWeights[font] = value;
      }
    );
  }
  if (themeInput == null ? void 0 : themeInput.typography) {
    Object.entries(themeInput.typography).forEach(
      ([typographyKey, { fontWeight }]) => {
        if (typeof fontWeight === "string") {
          const fontWeightValue = getFontWeightNumberByName(
            fontWeight
          );
          const fontWeightToken = getFontWeightTokenByNumber(fontWeightValue);
          if (!fontWeights[fontWeightToken]) {
            fontWeights[fontWeightToken] = fontWeightValue;
          }
          fontWeights[typographyKey] = `$${fontWeightToken}`;
        } else {
          fontWeights[typographyKey] = fontWeight;
        }
      }
    );
  }
  return fontWeights;
};
var getTextTransforms = (themeInput) => getValuesForProperty(themeInput, "textCase");
var getTextDecorations = (themeInput) => getValuesForProperty(themeInput, "textDecoration");
var getBorderWidths = (themeInput) => {
  const borderWidths = {};
  if (themeInput == null ? void 0 : themeInput.borderWidths) {
    Object.entries(themeInput.borderWidths).forEach(
      ([borderWidth, value]) => {
        borderWidths[borderWidth] = value;
      }
    );
  }
  return toPx(borderWidths);
};
var getBorderRadii = (themeInput) => {
  const borderRadii = {};
  if (themeInput == null ? void 0 : themeInput.borderRadii) {
    Object.entries(themeInput.borderRadii).forEach(
      ([borderWidth, value]) => {
        borderRadii[borderWidth] = value;
      }
    );
  }
  return toPx(borderRadii);
};
var getShadows = (themeInput) => {
  const shadows = {};
  if (themeInput == null ? void 0 : themeInput.shadows) {
    Object.entries(themeInput.shadows).forEach(
      ([shadowKey, { x, y, blur, spread, color }]) => {
        shadows[shadowKey] = `${x}px ${y}px ${blur}px ${spread}px ${color}`;
      }
    );
  }
  return shadows;
};
var getZIndices = (themeInput) => {
  const zIndices = {};
  if (themeInput == null ? void 0 : themeInput.zIndices) {
    Object.entries(themeInput.zIndices).forEach(
      ([zIndex, value]) => {
        zIndices[zIndex] = value;
      }
    );
  }
  return zIndices;
};
var getTransitions = (themeInput) => {
  const transitions = {};
  if (themeInput == null ? void 0 : themeInput.transitions) {
    Object.entries(themeInput.transitions).forEach(
      ([transition2, value]) => {
        transitions[transition2] = value;
      }
    );
  }
  return transitions;
};
var formatThemeForStitches = (theme2) => {
  const remSpacing = getSpacing(theme2, true);
  const pxSpacing = getSpacing(theme2, false);
  const rem = {
    space: toRem(__spreadValues(__spreadValues({}, remSpacing), getNegativeSpacing(remSpacing))),
    sizes: toRem(remSpacing),
    fontSizes: getRemFontSizes(theme2),
    lineHeights: getRemLineHeights(theme2)
  };
  const px = {
    space: toPx(__spreadValues(__spreadValues({}, pxSpacing), getNegativeSpacing(pxSpacing))),
    sizes: toPx(pxSpacing),
    fontSizes: getPxFontSizes(theme2),
    lineHeights: getPxLineHeights(theme2)
  };
  return {
    rem,
    px,
    colors: getColors(theme2),
    fonts: getFonts(theme2),
    fontWeights: getFontWeights(theme2),
    letterSpacings: getLetterSpacings(theme2),
    textTransforms: getTextTransforms(theme2),
    textDecorations: getTextDecorations(theme2),
    borderWidths: getBorderWidths(theme2),
    radii: getBorderRadii(theme2),
    shadows: getShadows(theme2),
    zIndices: getZIndices(theme2),
    transitions: getTransitions(theme2)
  };
};

// src/theme/icons/base-icon-map.ts
import tinyCircleStar from "./assets/base-icons/tinyCircleStar.svg";
import interfaceMinus from "./assets/base-icons/interfaceMinus.svg";
import illustrativePersonalInfo from "./assets/base-icons/illustrativePersonalInfo.svg";
import interfaceMeatballs from "./assets/base-icons/interfaceMeatballs.svg";
import illustrativeWebsite from "./assets/base-icons/illustrativeWebsite.svg";
import illustrativePhone from "./assets/base-icons/illustrativePhone.svg";
import interfaceArrowLeft from "./assets/base-icons/interfaceArrowLeft.svg";
import illustrativePillFilled from "./assets/base-icons/illustrativePillFilled.svg";
import illustrativeClock from "./assets/base-icons/illustrativeClock.svg";
import illustrativeCompose from "./assets/base-icons/illustrativeCompose.svg";
import illustrativeTouchID from "./assets/base-icons/illustrativeTouchID.svg";
import illustrativeLockTree from "./assets/base-icons/illustrativeLockTree.svg";
import interfaceChevronDown from "./assets/base-icons/interfaceChevronDown.svg";
import illustrativeAlarmClock from "./assets/base-icons/illustrativeAlarmClock.svg";
import illustrativeHeartFilled from "./assets/base-icons/illustrativeHeartFilled.svg";
import illustrativeUmbrella from "./assets/base-icons/illustrativeUmbrella.svg";
import statusErrorStatusFilled from "./assets/base-icons/statusErrorStatusFilled.svg";
import illustrativePill from "./assets/base-icons/illustrativePill.svg";
import illustrativeLockPerson from "./assets/base-icons/illustrativeLockPerson.svg";
import illustrativePerson from "./assets/base-icons/illustrativePerson.svg";
import capabilityJourney from "./assets/base-icons/capabilityJourney.svg";
import illustrativeShopFilled from "./assets/base-icons/illustrativeShopFilled.svg";
import interfaceStar from "./assets/base-icons/interfaceStar.svg";
import capabilityWallet from "./assets/base-icons/capabilityWallet.svg";
import capabilityWalletFilled from "./assets/base-icons/capabilityWalletFilled.svg";
import illustrativeNotifications from "./assets/base-icons/illustrativeNotifications.svg";
import statusInformationCircle2Filled from "./assets/base-icons/statusInformationCircle2Filled.svg";
import illustrativeQuestionBox from "./assets/base-icons/illustrativeQuestionBox.svg";
import interfaceQuestionCircleFilled from "./assets/base-icons/interfaceQuestionCircleFilled.svg";
import illustrativeInsurance from "./assets/base-icons/illustrativeInsurance.svg";
import illustrativeHeart from "./assets/base-icons/illustrativeHeart.svg";
import illustrativePaymentCard from "./assets/base-icons/illustrativePaymentCard.svg";
import illustrativeHeartRateUp from "./assets/base-icons/illustrativeHeartRateUp.svg";
import interfaceChevronUp from "./assets/base-icons/interfaceChevronUp.svg";
import illustrativeSecurityLock from "./assets/base-icons/illustrativeSecurityLock.svg";
import capabilityMarketplace from "./assets/base-icons/capabilityMarketplace.svg";
import tinyValidationCheck from "./assets/base-icons/tinyValidationCheck.svg";
import statusSuccessStatusFilled from "./assets/base-icons/statusSuccessStatusFilled.svg";
import illustrativeStarRibbon from "./assets/base-icons/illustrativeStarRibbon.svg";
import illustrativeHomeFilled from "./assets/base-icons/illustrativeHomeFilled.svg";
import illustrativeInformationDesk from "./assets/base-icons/illustrativeInformationDesk.svg";
import interfaceVisible from "./assets/base-icons/interfaceVisible.svg";
import illustrativePersonFilled from "./assets/base-icons/illustrativePersonFilled.svg";
import capabilityJourneyFilled from "./assets/base-icons/capabilityJourneyFilled.svg";
import illustrativeSettings from "./assets/base-icons/illustrativeSettings.svg";
import interfaceChevronRight from "./assets/base-icons/interfaceChevronRight.svg";
import tinyClose from "./assets/base-icons/tinyClose.svg";
import statusInformationCircle from "./assets/base-icons/statusInformationCircle.svg";
import illustrativeLockShield from "./assets/base-icons/illustrativeLockShield.svg";
import illustrativeGraphTrendingUp from "./assets/base-icons/illustrativeGraphTrendingUp.svg";
import interfaceQuestionCircle from "./assets/base-icons/interfaceQuestionCircle.svg";
import interfaceMenu from "./assets/base-icons/interfaceMenu.svg";
import statusAlert from "./assets/base-icons/statusAlert.svg";
import tinyHelper from "./assets/base-icons/tinyHelper.svg";
import statusSuccessStatus from "./assets/base-icons/statusSuccessStatus.svg";
import illustrativeMobileAlertUser from "./assets/base-icons/illustrativeMobileAlertUser.svg";
import illustrativeDocument from "./assets/base-icons/illustrativeDocument.svg";
import tinyHelperFilled from "./assets/base-icons/tinyHelperFilled.svg";
import illustrativeCheckBadge from "./assets/base-icons/illustrativeCheckBadge.svg";
import tinyDisclosureIndicator from "./assets/base-icons/tinyDisclosureIndicator.svg";
import interfaceURL from "./assets/base-icons/interfaceURL.svg";
import illustrativeHome2 from "./assets/base-icons/illustrativeHome2.svg";
import tinyStar from "./assets/base-icons/tinyStar.svg";
import interfaceExternalLink from "./assets/base-icons/interfaceExternalLink.svg";
import illustrativeMail from "./assets/base-icons/illustrativeMail.svg";
import illustrativeMoneyBill from "./assets/base-icons/illustrativeMoneyBill.svg";
import tinyExternalLink from "./assets/base-icons/tinyExternalLink.svg";
import interfaceHomeKey from "./assets/base-icons/interfaceHomeKey.svg";
import illustrativeSupportQuestionChat from "./assets/base-icons/illustrativeSupportQuestionChat.svg";
import interfaceEndKey from "./assets/base-icons/interfaceEndKey.svg";
import statusErrorStatus from "./assets/base-icons/statusErrorStatus.svg";
import tinyNewWindowInternal from "./assets/base-icons/tinyNewWindowInternal.svg";
import illustrativeBuildings from "./assets/base-icons/illustrativeBuildings.svg";
import interfaceArrowRight from "./assets/base-icons/interfaceArrowRight.svg";
import illustrativeFaceID from "./assets/base-icons/illustrativeFaceID.svg";
import illustrativeTransitBus from "./assets/base-icons/illustrativeTransitBus.svg";
import illustrativeParking from "./assets/base-icons/illustrativeParking.svg";
import illustrativePeople from "./assets/base-icons/illustrativePeople.svg";
import illustrativeAmbulance from "./assets/base-icons/illustrativeAmbulance.svg";
import illustrativeChatHistory from "./assets/base-icons/illustrativeChatHistory.svg";
import illustrativeCreditCardPayment from "./assets/base-icons/illustrativeCreditCardPayment.svg";
import interfaceHidden from "./assets/base-icons/interfaceHidden.svg";
import interfaceExternalShare from "./assets/base-icons/interfaceExternalShare.svg";
import illustrativeShop from "./assets/base-icons/illustrativeShop.svg";
import illustrativeHome from "./assets/base-icons/illustrativeHome.svg";
import statusInformationCircle2 from "./assets/base-icons/statusInformationCircle2.svg";
import interfaceChevronLeft from "./assets/base-icons/interfaceChevronLeft.svg";
import illustrativeCalendar from "./assets/base-icons/illustrativeCalendar.svg";
import illustrativeHealthClipboard from "./assets/base-icons/illustrativeHealthClipboard.svg";
import tinyBackButton from "./assets/base-icons/tinyBackButton.svg";
import interfaceRefresh from "./assets/base-icons/interfaceRefresh.svg";
import illustrativeFilter from "./assets/base-icons/illustrativeFilter.svg";
import tinyClear from "./assets/base-icons/tinyClear.svg";
import illustrativeWheelchairAccessibility from "./assets/base-icons/illustrativeWheelchairAccessibility.svg";
import interfaceCheckmark from "./assets/base-icons/interfaceCheckmark.svg";
import interfaceSearch from "./assets/base-icons/interfaceSearch.svg";
import interfacePlus from "./assets/base-icons/interfacePlus.svg";
import statusAlertFill from "./assets/base-icons/statusAlertFill.svg";
import tinyAlert from "./assets/base-icons/tinyAlert.svg";
import statusInformationCircleFill from "./assets/base-icons/statusInformationCircleFill.svg";
import interfaceDelete from "./assets/base-icons/interfaceDelete.svg";
import interfaceDownload from "./assets/base-icons/interfaceDownload.svg";
import interfaceEdit from "./assets/base-icons/interfaceEdit.svg";
import interfaceSignOut from "./assets/base-icons/interfaceSignOut.svg";
import capabilityGroupChallenges from "./assets/base-icons/capabilityGroupChallenges.svg";
import illustrativeStudentRecertification from "./assets/base-icons/illustrativeStudentRecertification.svg";
var CAPABILITY_ICONS = {
  capabilityGroupChallenges,
  capabilityJourney,
  capabilityJourneyFilled,
  capabilityMarketplace,
  capabilityWallet,
  capabilityWalletFilled
};
var ILLUSTRATIVE_ICONS = {
  illustrativeAlarmClock,
  illustrativeAmbulance,
  illustrativeBuildings,
  illustrativeCalendar,
  illustrativeChatHistory,
  illustrativeCheckBadge,
  illustrativeClock,
  illustrativeCompose,
  illustrativeCreditCardPayment,
  illustrativeDocument,
  illustrativeFaceID,
  illustrativeFilter,
  illustrativeGraphTrendingUp,
  illustrativeHealthClipboard,
  illustrativeHeart,
  illustrativeHeartFilled,
  illustrativeHeartRateUp,
  illustrativeHome,
  illustrativeHome2,
  illustrativeHomeFilled,
  illustrativeInformationDesk,
  illustrativeInsurance,
  illustrativeLockPerson,
  illustrativeLockShield,
  illustrativeLockTree,
  illustrativeMail,
  illustrativeMobileAlertUser,
  illustrativeMoneyBill,
  illustrativeNotifications,
  illustrativeParking,
  illustrativePaymentCard,
  illustrativePeople,
  illustrativePerson,
  illustrativePersonFilled,
  illustrativePersonalInfo,
  illustrativePhone,
  illustrativePill,
  illustrativePillFilled,
  illustrativeQuestionBox,
  illustrativeSecurityLock,
  illustrativeSettings,
  illustrativeShop,
  illustrativeShopFilled,
  illustrativeStarRibbon,
  illustrativeSupportQuestionChat,
  illustrativeTouchID,
  illustrativeTransitBus,
  illustrativeUmbrella,
  illustrativeWebsite,
  illustrativeWheelchairAccessibility,
  illustrativeStudentRecertification
};
var INTERFACE_ICONS = {
  interfaceArrowLeft,
  interfaceArrowRight,
  interfaceCheckmark,
  interfaceChevronDown,
  interfaceChevronLeft,
  interfaceChevronRight,
  interfaceChevronUp,
  interfaceDelete,
  interfaceDownload,
  interfaceEdit,
  interfaceEndKey,
  interfaceExternalLink,
  interfaceExternalShare,
  interfaceHidden,
  interfaceHomeKey,
  interfaceMeatballs,
  interfaceMenu,
  interfaceMinus,
  interfacePlus,
  interfaceQuestionCircle,
  interfaceQuestionCircleFilled,
  interfaceRefresh,
  interfaceSearch,
  interfaceSignOut,
  interfaceStar,
  interfaceURL,
  interfaceVisible
};
var STATUS_ICONS = {
  statusAlert,
  statusAlertFill,
  statusErrorStatus,
  statusErrorStatusFilled,
  statusInformationCircle,
  statusInformationCircle2,
  statusInformationCircle2Filled,
  statusInformationCircleFill,
  statusSuccessStatus,
  statusSuccessStatusFilled
};
var TINY_ICONS = {
  tinyAlert,
  tinyBackButton,
  tinyCircleStar,
  tinyClear,
  tinyClose,
  tinyDisclosureIndicator,
  tinyExternalLink,
  tinyHelper,
  tinyHelperFilled,
  tinyNewWindowInternal,
  tinyStar,
  tinyValidationCheck
};
var BASE_ICON_MAP = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, CAPABILITY_ICONS), ILLUSTRATIVE_ICONS), INTERFACE_ICONS), STATUS_ICONS), TINY_ICONS);

// src/theme/icons/get-theme-icons.ts
var getThemeIcons = (customIcons) => __spreadValues(__spreadValues({}, BASE_ICON_MAP), customIcons);

// src/theme/global-strings.ts
var GDS_STRINGS = {
  clear: "Clear",
  close: "Close",
  disclosure: "",
  dismiss: "Dismiss",
  externalLink: "opens an external link",
  loadingText: "Loading",
  newTabInternal: "opens in a new tab",
  next: "Next",
  optional: "optional",
  previous: "Previous"
};
var getThemeStrings = (customStrings) => __spreadValues(__spreadValues({}, GDS_STRINGS), customStrings);

// src/theme/utils/get-fallback-values.ts
import { has, get, set } from "lodash";
import { isNodeTestEnv } from "@leagueplatform/app-environment";

// src/theme/utils/theme-fallback-values.ts
var fallbackTokens = {
  "colors.input.background.default": "colors.interactive.background.default",
  "colors.input.background.disabled": "colors.interactive.background.disabled",
  "colors.input.background.hovered": "colors.interactive.background.hovered",
  "colors.input.background.pressed": "colors.interactive.background.pressed",
  "colors.input.border.critical": "colors.interactive.border.critical.default",
  "colors.input.border.default": "colors.interactive.border.default",
  "colors.input.border.disabled": "colors.interactive.border.disabled",
  "colors.input.border.hovered": "colors.interactive.border.hovered",
  "colors.input.border.success": "colors.success.border.default",
  "colors.input.border.warning": "colors.warning.border.default",
  "colors.onSurface.skeleton.background": "colors.input.background.disabled",
  "colors.onSurface.skeleton.highlight": "linear-gradient(87deg, rgba(255, 255, 255, 0) 3.38%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0) 94.72%)"
};

// src/theme/utils/get-fallback-values.ts
var diffMessageTemplate = (diffList, themeName) => `Genesis Design System: Following tokens have been added to your ${themeName || ""} theme with fallback values. For all fallback color tokens please ensure they meet WCAG 2.2 color contrast requirements when used in combination with other colors in your theme. You can update your theme if you wish to provide custom values for these tokens.

${diffList.join(`
`)}
`;
var getFallbackValues = (clientTheme, themeName) => {
  const fallbackTokensAdded = [];
  const themeWithFallbacks = Object.entries(fallbackTokens).forEach(
    ([key, value]) => {
      if (!has(clientTheme, key)) {
        const fallbackValue = get(clientTheme, fallbackTokens[key]);
        if (fallbackValue) {
          fallbackTokensAdded.push(`- ${key}: ${fallbackValue}`);
          set(clientTheme, key, fallbackValue);
        } else {
          fallbackTokensAdded.push(`- ${key}: ${value}`);
          set(clientTheme, key, value);
        }
      }
    }
  );
  const diffMessage = diffMessageTemplate(fallbackTokensAdded, themeName);
  if (!isNodeTestEnv()) {
    console.warn(diffMessage);
  }
  return themeWithFallbacks;
};

// src/theme/load-theme.ts
var scalesWithNumberValues = [
  "radii",
  "sizes",
  "space",
  "borderWidths"
];
var extractRawValue = (tokenScale) => Object.entries(tokenScale).reduce(
  (newTokenScale, [token, tokenValue]) => {
    const rawValue = parseInt(tokenValue.value, 10);
    return Number.isFinite(rawValue) ? __spreadProps(__spreadValues({}, newTokenScale), {
      [token]: rawValue
    }) : newTokenScale;
  },
  {}
);
var extractRawPxValue = (tokenScale) => Object.entries(tokenScale).reduce(
  (newTokenScale, [token, tokenValue]) => {
    const rawValue = parseInt(tokenValue, 10);
    return Number.isFinite(rawValue) ? __spreadProps(__spreadValues({}, newTokenScale), {
      [token]: rawValue
    }) : newTokenScale;
  },
  {}
);
var extractRawValues = (theme2, px) => {
  const extractedValues = Object.entries(theme2).filter(
    ([tokenScale]) => scalesWithNumberValues.includes(tokenScale)
  ).reduce(
    (rawTokenValues, [themeKey, tokenScale]) => __spreadProps(__spreadValues({}, rawTokenValues), {
      [themeKey]: ["space", "sizes"].includes(themeKey) ? extractRawPxValue(px[themeKey]) : extractRawValue(tokenScale)
    }),
    {}
  );
  return extractedValues;
};
var loadTheme = (theme2, {
  themeName,
  customIcons,
  customStrings,
  useRems = true
} = {
  useRems: true
}) => {
  getFallbackValues(theme2, themeName);
  const _a = formatThemeForStitches(theme2), { rem, px } = _a, formatted = __objRest(_a, ["rem", "px"]);
  const relativeOrStaticProperties = useRems ? rem : px;
  const formattedTheme = __spreadValues(__spreadValues({}, relativeOrStaticProperties), formatted);
  const stitchesTheme = themeName ? createTheme(themeName, formattedTheme) : createTheme(formattedTheme);
  const rawValues = extractRawValues(stitchesTheme, px);
  return __spreadProps(__spreadValues({}, stitchesTheme), {
    icons: getThemeIcons(customIcons),
    strings: getThemeStrings(customStrings),
    rawValues
  });
};

// src/components/typography/heading-text/heading-text.tsx
import React3, { forwardRef as forwardRef2, useMemo } from "react";

// src/components/typography/typography-base/typography-base.tsx
var TypographyBase = styled("span", {
  margin: 0,
  "& a, a&": {
    color: "$interactiveActionPrimary",
    fontWeight: "$buttonOne"
  },
  variants: {
    emphasis: {
      base: {
        color: "$onSurfaceTextPrimary"
      },
      subtle: {
        color: "$onSurfaceTextSubdued"
      }
    }
  }
});

// src/components/typography/heading-text/heading-text.tsx
var BaseHeading = styled(TypographyBase, {
  display: "block",
  variants: {
    size: {
      xxl: {
        typography: "$headingOne"
      },
      xl: {
        typography: "$headingTwo"
      },
      lg: {
        typography: "$headingThree"
      },
      md: {
        typography: "$headingFour"
      },
      sm: {
        typography: "$subtitleOne"
      },
      xs: {
        typography: "$subtitleTwo"
      }
    }
  }
});
var spanStyles = css({
  display: "block"
});
var elementByLevel = {
  "1": "h1",
  "2": "h2",
  "3": "h3",
  "4": "h4",
  "5": "h5",
  "6": "h6",
  display: "span"
};
var getElementByLevel = (level) => elementByLevel[level];
var HeadingText = forwardRef2(
  (_a, ref) => {
    var _b = _a, {
      as,
      children,
      className,
      css: css2,
      emphasis = "base",
      id,
      level,
      size
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "className",
      "css",
      "emphasis",
      "id",
      "level",
      "size"
    ]);
    const asSpan = level === "display";
    const element = useMemo(
      () => getElementByLevel(level),
      [level]
    );
    return /* @__PURE__ */ React3.createElement(
      BaseHeading,
      __spreadValues({
        as: as || element,
        className: ["GDS-heading-text", asSpan ? spanStyles() : void 0].join(
          " "
        ),
        css: css2,
        emphasis,
        id,
        ref,
        size
      }, props),
      children
    );
  }
);
HeadingText.displayName = "HeadingText";

// src/components/typography/utility-text/utility-text.tsx
import React4, { forwardRef as forwardRef3 } from "react";

// src/hooks/use-responsive-prop.ts
import { useCallback as useCallback2 } from "react";

// src/hooks/use-theme-media-queries.ts
import { useEffect, useCallback, useState, useRef } from "react";
function useThemeMediaQueries(media) {
  const queryItemsRef = useRef({});
  const [queryItems, setQueryItems] = useState({});
  const createHandler = useCallback(
    (breakpoint) => (event) => {
      const matches = Boolean(event.matches);
      const queryItem = queryItemsRef.current[breakpoint];
      if (queryItem && matches !== queryItem.active) {
        setQueryItems({});
      }
    },
    [queryItemsRef]
  );
  useEffect(() => {
    const newQueryItems = {};
    const hasQueryItems = Object.keys(queryItems).length > 0;
    if (!hasQueryItems) {
      Object.entries(media).forEach(([breakpoint, query]) => {
        const mediaQuery = window.matchMedia(query);
        const handler = createHandler(breakpoint);
        mediaQuery.addEventListener("change", handler);
        newQueryItems[breakpoint] = {
          active: mediaQuery.matches,
          mediaQuery,
          handler,
          query
        };
      });
      queryItemsRef.current = newQueryItems;
      setQueryItems(newQueryItems);
    }
    const queryItemsCopy = queryItems;
    const onDestroy = () => {
      if (hasQueryItems) {
        Object.values(queryItemsCopy).forEach(({ mediaQuery, handler }) => {
          if (mediaQuery && handler)
            mediaQuery.removeEventListener("change", handler);
        });
      }
    };
    return onDestroy;
  }, [media, createHandler, queryItems]);
  return queryItems;
}

// src/hooks/use-active-breakpoint.ts
var useActiveBreakpoint = (media) => {
  const queries = useThemeMediaQueries(media);
  const activeBreakpointItem = Object.entries(
    queries
  ).find(([, query]) => query.active);
  if (activeBreakpointItem) {
    const [activeBreakpoint] = activeBreakpointItem;
    return activeBreakpoint;
  }
  return null;
};

// src/hooks/use-responsive-prop.ts
function isResponsiveProp(arg) {
  return (arg == null ? void 0 : arg["@initial"]) !== void 0;
}
function getResponsivePropValue(prop, activeBreakpoint) {
  var _a;
  if (!isResponsiveProp(prop)) {
    return prop;
  }
  const initialBreakpointValue = prop["@initial"];
  return (_a = prop == null ? void 0 : prop[`@${activeBreakpoint}`]) != null ? _a : initialBreakpointValue;
}
var useResponsiveProp = (prop) => {
  const activeBreakpoint = useActiveBreakpoint(config.media);
  return getResponsivePropValue(prop, activeBreakpoint);
};
var useResponsivePropCallback = () => {
  const activeBreakpoint = useActiveBreakpoint(config.media);
  return useCallback2(
    (prop) => getResponsivePropValue(prop, activeBreakpoint),
    [activeBreakpoint]
  );
};
var mapResponsiveProp = (prop, valueMap) => {
  if (!valueMap)
    return prop;
  if (!isResponsiveProp(prop)) {
    return valueMap[prop];
  }
  const result = {};
  Object.keys(prop).forEach((key) => {
    const originalValue = prop[key];
    const newValue = valueMap[originalValue];
    result[key] = newValue;
  });
  return result;
};

// src/components/typography/utility-text/utility-text.tsx
var StyledUtilityText = styled(TypographyBase, {
  color: "$onSurfaceTextPrimary",
  variants: {
    size: {
      base: {
        typography: "$bodyOne"
      },
      sm: {
        typography: "$bodyTwo"
      },
      xs: {
        typography: "$caption"
      },
      eyebrow: {
        typography: "$overline"
      }
    },
    // Even though the emphasis variant exists on TypographyBase, TS fails without repeating it here
    emphasis: {
      base: {
        color: "$onSurfaceTextPrimary"
      },
      subtle: {
        color: "$onSurfaceTextSubdued"
      },
      emphasized: {
        color: "$onSurfaceTextPrimary"
      }
    }
  },
  compoundVariants: [
    {
      size: "base",
      emphasis: "emphasized",
      css: { typography: "$subtitleOne" }
    },
    {
      size: "base",
      emphasis: "subtle",
      css: { typography: "$bodyOneSecondary" }
    },
    {
      size: "sm",
      emphasis: "emphasized",
      css: { typography: "$subtitleTwo" }
    },
    {
      size: "sm",
      emphasis: "subtle",
      css: { typography: "$bodyTwoSecondary" }
    },
    {
      size: "xs",
      emphasis: "base",
      css: { color: "$onSurfaceTextPrimary" }
    },
    {
      size: "eyebrow",
      emphasis: "base",
      css: { color: "$onSurfaceTextSubdued" }
    }
  ]
});
var defaultEmphasisBySize = {
  base: "base",
  sm: "base",
  xs: "subtle",
  eyebrow: "base"
};
var UtilityText = forwardRef3(
  (_a, ref) => {
    var _b = _a, {
      as,
      children,
      className,
      css: css2,
      emphasis,
      id,
      size = "base"
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "className",
      "css",
      "emphasis",
      "id",
      "size"
    ]);
    const emphasisBySize = mapResponsiveProp(
      size,
      defaultEmphasisBySize
    );
    const responsiveSize = useResponsiveProp(size);
    if (size === "xs" && emphasis === "emphasized")
      console.error(
        `Size is ${size} and emphasis is ${emphasis}. An extra small emphasized variant does not exist.`
      );
    if (size === "eyebrow" && emphasis === "subtle")
      console.error(
        `Size is ${size} and emphasis is ${emphasis}. An eyebrow subtle variant does not exist.`
      );
    return /* @__PURE__ */ React4.createElement(
      StyledUtilityText,
      __spreadValues({
        as,
        className: ["GDS-utility-text", className].join(" "),
        css: css2,
        emphasis: emphasis != null ? emphasis : emphasisBySize,
        id,
        ref,
        size: responsiveSize
      }, props),
      children
    );
  }
);
UtilityText.displayName = "UtilityText";

// src/components/typography/paragraph-text/paragraph-text.tsx
import React11, { forwardRef as forwardRef6 } from "react";

// src/components/html-to-react/html-to-react.tsx
import React10 from "react";
import DOMPurify from "dompurify";
import parse, {
  domToReact,
  attributesToProps
} from "html-react-parser";

// src/components/html-to-react/html-to-react.utils.ts
import { cloneDeep } from "lodash";

// src/components/text-action/text-action.tsx
import React8, { forwardRef as forwardRef4 } from "react";

// src/components/icon/icon.tsx
import React5 from "react";

// src/hooks/use-theme.ts
import { useContext } from "react";
var useTheme = () => {
  const theme2 = useContext(ThemeContext);
  if (theme2 === void 0) {
    throw new Error(
      "No theme found in context. Check that your component is nested within a GDSThemeProvider."
    );
  }
  return theme2;
};
var useThemeRawValues = () => {
  const { rawValues } = useTheme();
  return rawValues;
};
var useThemeIcons = () => {
  const { icons: icons2 } = useTheme();
  return icons2;
};
var useThemeStrings = () => {
  const { strings } = useTheme();
  return strings;
};

// src/components/forms/utilities.ts
import { isValidElement } from "react";
var labelLegendStyles = {
  typography: "$label",
  color: "$onSurfaceTextSubdued",
  marginBottom: "$quarter",
  display: "flex",
  alignItems: "center",
  padding: 0
};
var isReactElement = (element) => isValidElement(element) && (typeof element.type === "object" || typeof element.type === "function");

// src/components/icon/icon.tsx
var IconBase = styled("div", { display: "inline-block" });
var isGDSIconToken = (iconToken, iconMap) => iconToken in iconMap;
var Icon = (_a) => {
  var _b = _a, {
    icon,
    tint,
    size = "$oneAndHalf",
    label,
    css: css2,
    className
  } = _b, props = __objRest(_b, [
    "icon",
    "tint",
    "size",
    "label",
    "css",
    "className"
  ]);
  const iconSize = useResponsiveProp(size);
  const iconMap = useThemeIcons();
  const iconClassName = ["GDS-icon", className].join(" ");
  if (typeof icon === "string" && isGDSIconToken(icon, iconMap)) {
    return /* @__PURE__ */ React5.createElement(
      IconBase,
      __spreadValues({
        as: "svg",
        className: iconClassName,
        "aria-hidden": !label,
        "aria-label": label,
        css: __spreadValues({ color: tint, width: iconSize, height: iconSize }, css2),
        "data-testid": "svg-icon"
      }, props),
      /* @__PURE__ */ React5.createElement("use", { href: `${iconMap[icon]}#${icon}` })
    );
  }
  if (isReactElement(icon)) {
    return /* @__PURE__ */ React5.createElement(
      IconBase,
      __spreadValues({
        as: "div",
        className: iconClassName,
        "aria-hidden": !label,
        "aria-label": label,
        css: __spreadValues({ color: tint, width: iconSize, height: iconSize }, css2),
        "data-testid": "custom-svg-icon"
      }, props),
      icon
    );
  }
  return /* @__PURE__ */ React5.createElement(
    IconBase,
    __spreadValues({
      as: "img",
      className: iconClassName,
      src: icon,
      alt: label || "",
      css: __spreadValues({ width: iconSize, height: iconSize }, css2),
      "data-testid": "img-icon"
    }, props)
  );
};
Icon.displayName = "Icon";

// src/components/spinner/spinner.tsx
import { keyframes as keyframes2 } from "@stitches/react";
import React7 from "react";

// src/components/visually-hidden/visually-hidden.tsx
var visuallyHiddenStyle = {
  position: "absolute",
  height: 1,
  width: 1,
  overflow: "hidden",
  clip: "rect(1px,1px, 1px, 1px)",
  whiteSpace: "nowrap"
};
var VisuallyHidden = styled("span", {
  "&:not(:focus):not(:active)": visuallyHiddenStyle
});
VisuallyHidden.displayName = "VisuallyHidden";

// src/components/spinner/circle.tsx
import * as React6 from "react";
function Circle({ className }) {
  return /* @__PURE__ */ React6.createElement(
    "svg",
    {
      "aria-hidden": "true",
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        opacity: ".1",
        d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1",
        stroke: "currentColor",
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "M1 12C1 5.925 5.925 1 12 1",
        stroke: "currentColor",
        strokeWidth: "1.5"
      }
    )
  );
}

// src/components/spinner/spinner.tsx
var rotate = keyframes2({
  to: { transform: "rotate(360deg)" }
});
var StyledCircle = styled(Circle, {
  display: "inline-block",
  fill: "transparent",
  borderRadius: "$circle",
  path: {
    strokeWidth: "$$thickness"
  },
  animation: `${rotate} 1s linear infinite forwards`
});
var Span = styled("span", {
  lineHeight: 0,
  position: "relative"
});
Span.displayName = "Span";
var SpinnerPositioner = styled("span", {
  variants: {
    replaceContent: {
      true: {
        display: "flex",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        alignItems: "center",
        justifyContent: "center"
      }
    }
  }
});
var Spinner = (_a) => {
  var _b = _a, {
    children,
    loading,
    loadingText,
    replaceContent = false,
    renderLoadingText = true,
    size,
    tint,
    className,
    thickness,
    css: css2
  } = _b, props = __objRest(_b, [
    "children",
    "loading",
    "loadingText",
    "replaceContent",
    "renderLoadingText",
    "size",
    "tint",
    "className",
    "thickness",
    "css"
  ]);
  const stringsMap = useThemeStrings();
  const spinnerSize = useResponsiveProp(size);
  return /* @__PURE__ */ React7.createElement(Span, __spreadValues({ className: ["GDS-spinner", className].join(" "), css: css2 }, props), loading && /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(SpinnerPositioner, { replaceContent }, /* @__PURE__ */ React7.createElement(
    StyledCircle,
    {
      css: {
        width: spinnerSize,
        height: spinnerSize,
        color: tint,
        $$thickness: thickness
      }
    }
  )), renderLoadingText && /* @__PURE__ */ React7.createElement(VisuallyHidden, null, loadingText || stringsMap.loadingText)), children && /* @__PURE__ */ React7.createElement(Span, { css: __spreadValues({}, loading && { opacity: 0 }) }, children));
};
Spinner.displayName = "Spinner";

// src/components/text-action/text-action.tsx
var BaseTextAction = styled("a", {
  display: "inline-flex",
  alignItems: "center",
  textDecoration: "none",
  position: "relative",
  outline: "none",
  background: "none",
  border: "none",
  borderRadius: "$small",
  cursor: "pointer",
  padding: 0,
  "&:hover": {
    textDecoration: "underline"
  },
  variants: {
    size: {
      medium: {
        typography: "$buttonTwo"
      },
      large: {
        typography: "$buttonOne"
      }
    },
    emphasis: {
      base: {
        color: "$interactiveActionPrimary"
      },
      subtle: {
        color: "$interactiveActionSubdued"
      }
    },
    destructive: {
      true: {
        color: "$onSurfaceTextCritical"
      }
    },
    loading: {
      true: {
        pointerEvents: "none"
      }
    }
  }
});
var iconBySize = {
  medium: "20px",
  large: "24px"
};
var indicatorByString = {
  disclosure: "tinyDisclosureIndicator",
  newTabInternal: "tinyNewWindowInternal",
  externalLink: "tinyExternalLink"
};
var getIconByIndicator = (indicator) => indicatorByString[indicator];
var TextAction = forwardRef4(
  (_a, ref) => {
    var _b = _a, {
      as: asElement,
      children,
      className,
      css: css2,
      destructive,
      emphasis = "base",
      icon,
      iconLabel,
      indicator,
      loading,
      loadingText,
      size = "large",
      type
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "className",
      "css",
      "destructive",
      "emphasis",
      "icon",
      "iconLabel",
      "indicator",
      "loading",
      "loadingText",
      "size",
      "type"
    ]);
    const iconSize = mapResponsiveProp(size, iconBySize);
    const stringsMap = useThemeStrings();
    const labelByIndicator = {
      disclosure: stringsMap.disclosure,
      newTabInternal: stringsMap.newTabInternal,
      externalLink: stringsMap.externalLink
    };
    const getLabelByIndicator = (indicatorIcon) => labelByIndicator[indicatorIcon];
    if (emphasis === "subtle" && destructive) {
      console.error(
        `Destructive is ${destructive} and emphasis is ${emphasis}. TextAction can only be either subtle or destructive.`
      );
    }
    const defaultType = !type && asElement === "button" ? "button" : void 0;
    return /* @__PURE__ */ React8.createElement(
      BaseTextAction,
      __spreadValues({
        as: asElement,
        className: ["GDS-text-action", className].join(" "),
        css: css2,
        destructive,
        emphasis,
        loading,
        ref,
        size: useResponsiveProp(size),
        type: type || defaultType
      }, props),
      loading && /* @__PURE__ */ React8.createElement(
        Spinner,
        {
          loading,
          loadingText,
          size: iconSize,
          css: { marginRight: "$quarter" }
        }
      ),
      icon && !loading && /* @__PURE__ */ React8.createElement(
        Icon,
        {
          icon,
          size: iconSize,
          label: iconLabel,
          css: { marginRight: "$quarter" }
        }
      ),
      children,
      indicator && /* @__PURE__ */ React8.createElement(
        Icon,
        {
          icon: getIconByIndicator(indicator),
          size: "$one",
          css: { marginLeft: "$quarter" },
          label: getLabelByIndicator(indicator)
        }
      )
    );
  }
);
TextAction.displayName = "TextAction";

// src/components/button/button.tsx
import React9, { forwardRef as forwardRef5, useMemo as useMemo2 } from "react";
var ButtonBase = styled("button", {
  display: "inline-flex",
  flexWrap: "nowrap",
  alignItems: "center",
  borderRadius: "$button",
  borderWidth: "$thin",
  borderStyle: "solid",
  maxWidth: "100%",
  cursor: "pointer",
  variants: {
    width: {
      hugContents: { width: "unset" },
      fillContainer: { width: "100%", justifyContent: "center" }
    },
    size: {
      large: {
        typography: "$buttonOne",
        paddingTop: "$threeQuarters",
        paddingBottom: "$threeQuarters",
        paddingLeft: "$two",
        paddingRight: "$two"
      },
      medium: {
        typography: "$buttonTwo",
        paddingTop: "$half",
        paddingBottom: "$half",
        paddingLeft: "$one",
        paddingRight: "$one"
      },
      small: {
        typography: "$label",
        paddingTop: "$quarter",
        paddingBottom: "$quarter",
        paddingLeft: "$threeQuarters",
        paddingRight: "$threeQuarters"
      },
      toolbar: {
        paddingTop: "$half",
        paddingBottom: "$half",
        paddingLeft: "$threeQuarters",
        paddingRight: "$threeQuarters",
        typography: "$label"
      }
    },
    loading: {
      true: { pointerEvents: "none" }
    }
  }
});
var destructiveLoadingStyle = {
  backgroundColor: "$primaryBackgroundCriticalDefault",
  color: "$primaryTextCriticalDefault",
  borderColor: "transparent"
};
var destructiveHoverAndActiveStyle = {
  "&:hover": {
    backgroundColor: "$primaryBackgroundCriticalHovered",
    color: "$primaryTextCriticalDefault",
    borderColor: "transparent"
  },
  "&:active": {
    backgroundColor: "$primaryBackgroundCriticalPressed",
    color: "$primaryTextCriticalDefault",
    borderColor: "transparent"
  }
};
var disabledStyle = {
  backgroundColor: "$interactiveBackgroundDisabled",
  color: "$onSurfaceTextSubdued",
  borderColor: "transparent",
  pointerEvents: "none"
};
var loadingStyle = {
  backgroundColor: "$primaryBackgroundDefault",
  color: "$secondaryTextHovered",
  borderColor: "transparent"
};
var StandardButton = styled(ButtonBase, {
  variants: {
    priority: {
      primary: {
        backgroundColor: "$primaryBackgroundDefault",
        color: "$primaryTextDefault",
        borderColor: "transparent",
        // Transparent border maintains border width
        '&[aria-disabled="true"], &:disabled': disabledStyle,
        "&:hover": {
          backgroundColor: "$primaryBackgroundHovered"
        },
        "&:active": {
          backgroundColor: "$primaryBackgroundPressed"
        }
      },
      secondary: {
        backgroundColor: "$secondaryBackgroundDefault",
        color: "$secondaryTextDefault",
        borderColor: "$secondaryBorderDefault",
        '&[aria-disabled="true"], &:disabled': disabledStyle,
        "&:hover": {
          backgroundColor: "$secondaryBackgroundHovered",
          color: "$secondaryTextHovered",
          borderColor: "transparent"
        },
        "&:active": {
          backgroundColor: "$secondaryBackgroundPressed",
          color: "$secondaryTextHovered",
          borderColor: "transparent"
        }
      },
      tertiary: {
        backgroundColor: "$tertiaryBackgroundDefault",
        color: "$tertiaryTextDefault",
        borderColor: "$tertiaryBorderDefault",
        '&[aria-disabled="true"], &:disabled': disabledStyle,
        "&:hover": {
          backgroundColor: "$tertiaryBackgroundHovered",
          color: "$tertiaryTextHovered",
          borderColor: "transparent"
        },
        "&:active": {
          backgroundColor: "$tertiaryBackgroundPressed",
          color: "$tertiaryTextHovered",
          borderColor: "transparent"
        }
      }
    },
    destructive: {
      true: destructiveHoverAndActiveStyle
    },
    quiet: {
      true: { borderColor: "transparent" }
    },
    // These variants don't have a shared style - they are only used in compound variants, so the default value is an empty object
    iconOnly: {
      true: {}
    },
    reducePadding: {
      true: {}
    },
    size: {
      small: {},
      medium: {},
      large: {},
      toolbar: {}
    },
    loading: {
      true: {}
    }
  },
  compoundVariants: [
    // Icon only
    {
      size: "large",
      iconOnly: true,
      css: {
        padding: "$threeQuarters"
      }
    },
    {
      size: "medium",
      iconOnly: true,
      css: {
        padding: "$half"
      }
    },
    {
      size: "small",
      iconOnly: true,
      css: {
        padding: "$half"
      }
    },
    // Destructive
    {
      priority: "primary",
      destructive: true,
      css: {
        backgroundColor: "$primaryBackgroundCriticalDefault",
        color: "$primaryTextCriticalDefault"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      quiet: false,
      css: {
        color: "$onSurfaceTextCritical",
        borderColor: "$onSurfaceTextCritical"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      quiet: true,
      css: {
        color: "$onSurfaceTextCritical",
        borderColor: "transparent"
      }
    },
    // Loading
    {
      loading: true,
      destructive: false,
      css: loadingStyle
    },
    // Destructive loading
    {
      loading: true,
      destructive: true,
      css: destructiveLoadingStyle
    },
    {
      size: "large",
      reducePadding: true,
      css: { paddingLeft: "$oneAndHalf", paddingRight: "$oneAndHalf" }
    },
    {
      size: "medium",
      reducePadding: true,
      css: { paddingLeft: "$threeQuarters", paddingRight: "$threeQuarters" }
    },
    {
      size: "small",
      reducePadding: true,
      css: { paddingLeft: "$half", paddingRight: "$half" }
    }
  ]
});
var toolbarQuietStyle = {
  borderColor: "transparent",
  backgroundColor: "transparent",
  "&:hover": {
    borderColor: "transparent",
    backgroundColor: "transparent"
  }
};
var ToolbarButton = styled(ButtonBase, {
  variants: {
    priority: {
      primary: {
        backgroundColor: "$primaryBackgroundDefault",
        color: "$primaryTextDefault",
        borderColor: "transparent",
        // Transparent border maintains border width
        "&:hover": {
          backgroundColor: "$primaryBackgroundHovered"
        },
        "&:active": {
          backgroundColor: "$primaryBackgroundPressed"
        },
        '&[aria-disabled="true"], &:disabled': disabledStyle
      },
      secondary: {
        backgroundColor: "$surfaceBackgroundPrimary",
        color: "$interactiveActionPrimary",
        borderColor: "$interactiveActionPrimary",
        "&:hover": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionHovered",
          borderColor: "$interactiveActionHovered"
        },
        "&:active": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionPressed",
          borderColor: "$interactiveActionPressed"
        },
        '&[aria-disabled="true"], &:disabled': disabledStyle
      },
      tertiary: {
        backgroundColor: "$surfaceBackgroundPrimary",
        color: "$interactiveActionSubdued",
        borderColor: "$interactiveActionSubdued",
        "&:hover": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionSubdued",
          borderColor: "$interactiveActionSubdued"
        },
        "&:active": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionPrimary",
          borderColor: "$interactiveActionPrimary"
        },
        '&[aria-disabled="true"], &:disabled': disabledStyle
      }
    },
    destructive: {
      true: destructiveHoverAndActiveStyle
    },
    loading: {
      true: {}
    },
    iconOnly: {
      true: {
        padding: "$quarter"
      }
    },
    reducePadding: {
      true: { padding: "$half" }
    },
    quiet: { true: toolbarQuietStyle }
  },
  compoundVariants: [
    // Destructive
    {
      priority: "primary",
      destructive: true,
      quiet: false,
      loading: false,
      css: {
        backgroundColor: "$primaryBackgroundCriticalDefault",
        color: "$primaryTextCriticalDefault"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      loading: false,
      quiet: false,
      css: {
        color: "$onSurfaceTextCritical",
        borderColor: "$onSurfaceTextCritical"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      loading: false,
      quiet: true,
      css: __spreadProps(__spreadValues({}, destructiveHoverAndActiveStyle), {
        color: "$onSurfaceTextCritical",
        borderColor: "transparent"
      })
    },
    {
      destructive: true,
      loading: true,
      css: destructiveLoadingStyle
    },
    {
      priority: "tertiary",
      quiet: true,
      css: toolbarQuietStyle
    }
  ]
});
var IconWrapper = styled("div", {
  display: "flex",
  alignItems: "center",
  variants: {
    paddingRight: {
      large: { paddingRight: "$half" },
      medium: { paddingRight: "$half" },
      small: { paddingRight: "$quarter" },
      toolbar: { paddingRight: "$quarter" },
      none: { paddingRight: "$none" }
    },
    paddingLeft: {
      large: { paddingLeft: "$half" },
      medium: { paddingLeft: "$half" },
      small: { paddingLeft: "$quarter" },
      toolbar: { paddingLeft: "$quarter" },
      none: { paddingLeft: "$none" }
    }
  }
});
var LabelWrapper = styled("span", {
  variants: {
    truncateLabel: {
      true: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }
  }
});
var iconSizes = {
  large: 24,
  medium: 20,
  small: 16,
  toolbar: 16
};
function useIndicatorProps() {
  const stringsMap = useThemeStrings();
  return useMemo2(
    () => ({
      size: {
        large: 16,
        medium: 14,
        small: 12,
        toolbar: 16
      },
      icon: {
        newTabInternal: "tinyNewWindowInternal",
        externalLink: "tinyExternalLink"
      },
      label: {
        newTabInternal: stringsMap.newTabInternal,
        externalLink: stringsMap.externalLink
      }
    }),
    [stringsMap]
  );
}
var Button = forwardRef5(
  (_a, ref) => {
    var _b = _a, {
      as: asElement,
      children,
      icon,
      hideLabel,
      truncateLabel,
      size = "large",
      priority = "primary",
      width = "hugContents",
      destructive,
      quiet = false,
      disabled = false,
      "aria-disabled": ariaDisabled,
      loading = false,
      loadingText,
      indicator,
      type,
      className
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "icon",
      "hideLabel",
      "truncateLabel",
      "size",
      "priority",
      "width",
      "destructive",
      "quiet",
      "disabled",
      "aria-disabled",
      "loading",
      "loadingText",
      "indicator",
      "type",
      "className"
    ]);
    if (!icon && hideLabel)
      console.error(
        `Icon is ${icon} and hideLabel is ${hideLabel}. You can hide the label only if you provide an icon. Otherwise, the button appears to be empty.`
      );
    if (priority === "tertiary" && destructive)
      console.error(
        `Priority is ${priority} and destructive is ${destructive}. Only primary and secondary buttons can be destructive.`
      );
    if (priority === "primary" && quiet)
      console.error(
        `Priority is ${priority} and quiet is ${quiet}. Only secondary and tertiary buttons can be quiet.`
      );
    if (indicator && hideLabel)
      console.error(
        `Indicator is ${indicator} and hideLabel is ${hideLabel}. Only buttons with visible text can have the indicator icon.`
      );
    const responsiveSize = useResponsiveProp(size);
    const responsiveHideLabel = useResponsiveProp(hideLabel);
    const spaceBetweenIconAndLabel = responsiveHideLabel ? "none" : responsiveSize;
    const responsiveIconSize = mapResponsiveProp(size, iconSizes);
    const responsiveWidth = useResponsiveProp(width);
    const indicatorProps = useIndicatorProps();
    const iconOnly = icon && responsiveHideLabel;
    const reducePadding = !icon && responsiveHideLabel;
    const ButtonComponent = responsiveSize === "toolbar" ? ToolbarButton : StandardButton;
    const defaultType = !type && !asElement ? "button" : void 0;
    return /* @__PURE__ */ React9.createElement(
      ButtonComponent,
      __spreadValues({
        as: asElement,
        className: ["GDS-button", className].join(" "),
        size: responsiveSize,
        width: responsiveWidth,
        priority,
        destructive,
        quiet,
        disabled,
        "aria-disabled": ariaDisabled,
        loading,
        ref,
        iconOnly,
        reducePadding,
        type: type || defaultType
      }, props),
      loading && /* @__PURE__ */ React9.createElement(IconWrapper, { paddingRight: spaceBetweenIconAndLabel }, /* @__PURE__ */ React9.createElement(
        Spinner,
        {
          loading: true,
          loadingText,
          size: `${responsiveIconSize}px`
        }
      )),
      icon && !loading && /* @__PURE__ */ React9.createElement(IconWrapper, { paddingRight: spaceBetweenIconAndLabel }, /* @__PURE__ */ React9.createElement(Icon, { icon, size: responsiveIconSize })),
      responsiveHideLabel ? /* @__PURE__ */ React9.createElement(VisuallyHidden, null, children) : /* @__PURE__ */ React9.createElement(LabelWrapper, { truncateLabel }, children),
      indicator && !hideLabel && /* @__PURE__ */ React9.createElement(IconWrapper, { paddingLeft: spaceBetweenIconAndLabel }, /* @__PURE__ */ React9.createElement(
        Icon,
        {
          icon: indicatorProps.icon[indicator],
          size: indicatorProps.size[responsiveSize],
          label: indicatorProps.label[indicator]
        }
      ))
    );
  }
);
Button.displayName = "Button";

// src/components/html-to-react/html-to-react.config.ts
var defaultHTMLTagOptions = {
  a: {
    component: TextAction
  },
  b: {
    component: "span",
    props: {
      as: "strong",
      css: {
        fontWeight: "bold"
      }
    }
  },
  p: {
    component: UtilityText,
    props: {
      css: {
        "> a": {
          textDecoration: "underline"
        }
      }
    }
  },
  h1: {
    component: HeadingText,
    props: { level: "1", size: "xxl" }
  },
  h2: {
    component: HeadingText,
    props: { level: "2", size: "xl" }
  },
  h3: {
    component: HeadingText,
    props: { level: "3", size: "lg" }
  },
  h4: {
    component: HeadingText,
    props: { level: "4", size: "md" }
  },
  h5: {
    component: HeadingText,
    props: { level: "5", size: "sm" }
  },
  h6: {
    component: HeadingText,
    props: { level: "6", size: "xs" }
  },
  button: {
    component: Button
  },
  ul: {
    component: "p",
    props: {
      as: "ul",
      css: {
        listStyle: "revert",
        marginBottom: "$oneAndHalf",
        padding: "0 0 0 18px"
      }
    }
  },
  ol: {
    component: UtilityText,
    props: {
      as: "ol",
      css: {
        typography: "$bodyOne",
        listStyle: "revert",
        marginBottom: "$oneAndHalf",
        padding: "0 0 0 18px"
      }
    }
  },
  em: {
    component: "em",
    props: { style: { fontStyle: "italic" } }
  },
  i: {
    component: "em",
    props: { style: { fontStyle: "italic" } }
  },
  sup: {
    component: UtilityText,
    props: {
      as: "sup",
      color: "$onSurfaceTextSubdued",
      size: "eyebrow"
    }
  },
  sub: {
    component: UtilityText,
    props: {
      as: "sub",
      color: "$onSurfaceTextSubdued",
      size: "eyebrow"
    }
  }
};

// src/components/html-to-react/html-to-react.utils.ts
var applyOptionsWithDefaults = (newOptions, defaultOptions = cloneDeep(defaultHTMLTagOptions)) => newOptions && typeof newOptions === "object" ? Object.entries(newOptions).reduce(
  (acc, [tag, { component, props = {} }]) => {
    var _a;
    if (!acc[tag]) {
      if (!component)
        return acc;
      acc[tag] = {
        component,
        props: __spreadValues({}, props)
      };
      return acc;
    }
    if (component) {
      acc[tag].component = component;
    }
    acc[tag].props = __spreadValues(__spreadValues({}, (_a = acc[tag]) == null ? void 0 : _a.props), props);
    return acc;
  },
  defaultOptions
) : defaultOptions;

// src/components/html-to-react/html-to-react.tsx
var curateOptions = (options) => {
  const allOptions = applyOptionsWithDefaults(options);
  return {
    trim: true,
    replace({
      name,
      attribs,
      children
    }) {
      if (!attribs)
        return void 0;
      const attributeProps = attributesToProps(attribs);
      if (name in allOptions) {
        const { component: Component, props } = allOptions[name];
        return /* @__PURE__ */ React10.createElement(Component, __spreadValues(__spreadValues({}, props), attributeProps), children && children.length ? domToReact(children, this) : void 0);
      }
      return void 0;
    }
  };
};
var HtmlToReact = ({
  htmlString,
  options
}) => {
  if (!htmlString)
    return null;
  const sanitizedHtml = DOMPurify.sanitize(htmlString, {
    FORCE_BODY: true
  });
  const derivedOptions = options ? curateOptions(options) : curateOptions({});
  const reactElement = parse(
    sanitizedHtml,
    derivedOptions
  );
  return /* @__PURE__ */ React10.createElement(React10.Fragment, null, reactElement);
};

// src/components/typography/paragraph-text/paragraph-text.tsx
var StyledParagraphText = styled(TypographyBase, {
  variants: {
    size: {
      base: {
        typography: "$bodyOne",
        "&:not(:last-child)": {
          marginBlockEnd: "$bodyOne"
        }
      },
      sm: {
        typography: "$bodyTwo",
        "&:not(:last-child)": {
          marginBlockEnd: "$bodyTwo"
        }
      },
      xs: {
        typography: "$caption",
        "&:not(:last-child)": {
          marginBlockEnd: "$quarter"
        }
      }
    }
  }
});
var ParagraphText = forwardRef6(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      emphasis = "base",
      id,
      size = "base",
      htmlStringOptions = {},
      as
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "emphasis",
      "id",
      "size",
      "htmlStringOptions",
      "as"
    ]);
    return /* @__PURE__ */ React11.createElement(
      StyledParagraphText,
      __spreadValues({
        as: as || "p",
        className: ["GDS-paragraph-text", className].join(" "),
        css: css2,
        emphasis,
        id,
        ref,
        size
      }, props),
      typeof children === "string" ? /* @__PURE__ */ React11.createElement(HtmlToReact, { htmlString: children, options: htmlStringOptions }) : children
    );
  }
);
ParagraphText.displayName = "ParagraphText";

// src/components/heading-bar/heading-bar.tsx
import React12, {
  forwardRef as forwardRef7,
  isValidElement as isValidElement2,
  useRef as useRef2,
  useState as useState2,
  useLayoutEffect
} from "react";
var HeadingBarWrapper = styled("div", {
  variants: {
    transparency: {
      none: {
        background: "$$backgroundColor"
      },
      transparent: {
        background: "transparent"
      },
      gradient: {
        background: "linear-gradient(180deg, rgba(0, 0, 0, 0.7) 5.8%, rgba(0, 0, 0, 0) 99.68%)"
      },
      withBackgrounds: {
        background: "transparent"
      }
    }
  }
});
var HeadingBarBase = styled("div", {
  display: "flex",
  position: "relative",
  padding: "$threeQuarters",
  minHeight: "$three"
});
var ActionWrapper = styled("div", {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  zIndex: 1
});
var ActionBackground = styled("div", {
  display: "flex",
  alignItems: "center",
  borderRadius: "$pill",
  variants: {
    hasBackgrounds: {
      true: {
        backgroundColor: "$surfaceBackgroundPrimary"
      }
    }
  }
});
var TitleWrapper = styled("div", {
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  paddingTop: "$threeQuarters",
  paddingBottom: "$threeQuarters",
  paddingLeft: "calc($$padding + $threeQuarters)",
  paddingRight: "calc($$padding + $threeQuarters)"
});
var Title = styled(HeadingText, {
  padding: "$quarter $half",
  borderRadius: "$pill",
  textAlign: "center",
  variants: {
    hasBackgrounds: {
      true: {
        backgroundColor: "$surfaceBackgroundPrimary"
      }
    },
    gradient: {
      true: {
        color: "$onSurfaceTextReversed"
      }
    }
  }
});
var HeadingBar = forwardRef7(
  (_a, ref) => {
    var _b = _a, {
      title,
      leftAction,
      rightAction,
      headingLevel = "display",
      largeTitle,
      backgroundColor = "$surfaceBackgroundPrimary",
      transparency = "none",
      css: css2
    } = _b, props = __objRest(_b, [
      "title",
      "leftAction",
      "rightAction",
      "headingLevel",
      "largeTitle",
      "backgroundColor",
      "transparency",
      "css"
    ]);
    var _a2, _b2, _c, _d;
    const leftRef = useRef2(null);
    const rightRef = useRef2(null);
    const [sidePadding, setSidePadding] = useState2(null);
    const leftWidth = (_b2 = (_a2 = leftRef == null ? void 0 : leftRef.current) == null ? void 0 : _a2.offsetWidth) != null ? _b2 : 0;
    const rightWidth = (_d = (_c = rightRef == null ? void 0 : rightRef.current) == null ? void 0 : _c.offsetWidth) != null ? _d : 0;
    useLayoutEffect(() => {
      if (leftWidth > rightWidth) {
        setSidePadding(leftWidth);
      } else
        setSidePadding(rightWidth);
    }, [leftWidth, rightWidth]);
    const hasBackgrounds = transparency === "withBackgrounds";
    const titleComponent = isValidElement2(title) ? title : /* @__PURE__ */ React12.createElement(
      Title,
      {
        level: headingLevel,
        size: largeTitle ? "xl" : "sm",
        hasBackgrounds,
        gradient: transparency === "gradient",
        className: "GDS-heading-bar-title"
      },
      title
    );
    const getJustifyContent = () => {
      if (leftAction && rightAction)
        return "space-between";
      if (rightAction)
        return "flex-end";
      return "flex-start";
    };
    return /* @__PURE__ */ React12.createElement(
      HeadingBarWrapper,
      {
        className: "GDS-heading-bar-wrapper",
        transparency,
        css: __spreadProps(__spreadValues({}, css2), {
          $$backgroundColor: `$colors${backgroundColor}`
        })
      },
      /* @__PURE__ */ React12.createElement(
        HeadingBarBase,
        __spreadValues({
          className: "GDS-heading-bar-base",
          ref,
          css: {
            justifyContent: getJustifyContent()
          }
        }, props),
        leftAction && /* @__PURE__ */ React12.createElement(
          ActionWrapper,
          {
            ref: leftRef,
            className: "GDS-heading-bar-left-action"
          },
          /* @__PURE__ */ React12.createElement(ActionBackground, { hasBackgrounds }, leftAction)
        ),
        title && sidePadding !== null && /* @__PURE__ */ React12.createElement(
          TitleWrapper,
          {
            css: { $$padding: `${sidePadding}px` },
            className: "GDS-heading-bar-title-wrapper"
          },
          titleComponent
        ),
        rightAction && /* @__PURE__ */ React12.createElement(
          ActionWrapper,
          {
            ref: rightRef,
            className: "GDS-heading-bar-right-action"
          },
          /* @__PURE__ */ React12.createElement(ActionBackground, { hasBackgrounds }, rightAction)
        )
      )
    );
  }
);
HeadingBar.displayName = "HeadingBar";

// src/components/divider/divider.tsx
import React13 from "react";
var BaseDivider = styled("hr", {
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  height: "auto",
  variants: {
    orientation: {
      vertical: {
        margin: "0px",
        flexShrink: "0",
        borderWidth: "0px $thin 0px 0px",
        alignSelf: "stretch"
      },
      horizontal: {
        width: "100%",
        borderWidth: "0px 0px $thin"
      }
    }
  }
});
var getMarginCss = (orientation, margin) => {
  if (typeof margin === "string") {
    return { [orientation === "horizontal" ? "marginX" : "marginY"]: margin };
  }
  const responsiveMargins = Object.entries(margin).reduce(
    (obj, [key, value]) => __spreadProps(__spreadValues({}, obj), {
      [key]: { [orientation === "horizontal" ? "marginX" : "marginY"]: value }
    }),
    {}
  );
  return responsiveMargins;
};
var Divider = (_a) => {
  var _b = _a, {
    "aria-hidden": ariaHidden = true,
    className,
    css: css2,
    margin,
    orientation = "horizontal"
  } = _b, props = __objRest(_b, [
    "aria-hidden",
    "className",
    "css",
    "margin",
    "orientation"
  ]);
  const ariaOrientation = useResponsiveProp(orientation);
  return /* @__PURE__ */ React13.createElement(
    BaseDivider,
    __spreadValues({
      "aria-hidden": ariaHidden,
      "aria-orientation": ariaOrientation,
      className: ["GDS-divider", className].join(" "),
      css: __spreadValues(__spreadValues({}, css2), margin && getMarginCss(orientation, margin)),
      "data-testid": "divider",
      orientation
    }, props)
  );
};
Divider.displayName = "Divider";

// src/components/stack-layout/stack-layout.tsx
import React16, { forwardRef as forwardRef10 } from "react";

// src/components/stack-layout/vertical-stack-layout/vertical-stack-layout.tsx
import React14, { forwardRef as forwardRef8, Children } from "react";
var BaseVerticalStack = styled("div", {
  display: "flex",
  flex: "1",
  flexDirection: "column",
  height: "100%",
  variants: {
    horizontalAlignment: {
      start: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      end: {
        alignItems: "flex-end"
      },
      stretch: {
        alignItems: "stretch"
      }
    },
    verticalAlignment: {
      top: {
        justifyContent: "flex-start"
      },
      center: {
        justifyContent: "center"
      },
      bottom: {
        justifyContent: "flex-end"
      },
      spaceAround: {
        justifyContent: "space-around"
      },
      spaceBetween: {
        justifyContent: "space-between"
      },
      spaceEvenly: {
        justifyContent: "space-evenly"
      },
      stretch: {
        justifyContent: "stretch",
        "& > *": {
          flex: "1 1 0"
        }
      }
    }
  }
});
var VerticalStackLayout = forwardRef8(
  (_a, ref) => {
    var _b = _a, {
      horizontalAlignment = "start",
      verticalAlignment = "top",
      spacing,
      divider,
      children,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "horizontalAlignment",
      "verticalAlignment",
      "spacing",
      "divider",
      "children",
      "className",
      "css"
    ]);
    const responsiveSpacing = useResponsiveProp(spacing);
    const responsiveDivider = useResponsiveProp(divider);
    const arrayChildren = Children.toArray(children);
    return /* @__PURE__ */ React14.createElement(
      BaseVerticalStack,
      __spreadValues({
        horizontalAlignment,
        verticalAlignment,
        ref,
        className: ["GDS-vertical-stack-layout", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), spacing && { gap: `$space${responsiveSpacing}` })
      }, props),
      React14.Children.map(arrayChildren, (child, index) => {
        const isLast = index === arrayChildren.length - 1;
        return /* @__PURE__ */ React14.createElement(React14.Fragment, null, child, !isLast && responsiveDivider ? responsiveDivider : null);
      })
    );
  }
);

// src/components/stack-layout/horizontal-stack-layout/horizontal-stack-layout.tsx
import React15, { forwardRef as forwardRef9, Children as Children2 } from "react";
var BaseStack = styled("div", {
  display: "flex",
  flex: "1",
  variants: {
    horizontalAlignment: {
      start: {
        justifyContent: "flex-start"
      },
      center: {
        justifyContent: "center"
      },
      end: {
        justifyContent: "flex-end"
      },
      spaceBetween: {
        justifyContent: "space-between"
      },
      spaceAround: {
        justifyContent: "space-around"
      },
      spaceEvenly: {
        justifyContent: "space-evenly"
      },
      stretch: {
        justifyContent: "stretch",
        "& > *": {
          flex: "1 1 0"
        }
      }
    },
    verticalAlignment: {
      top: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      bottom: {
        alignItems: "flex-end"
      },
      stretch: {
        alignItems: "stretch"
      }
    }
  }
});
var HorizontalStackLayout = forwardRef9(
  (_a, ref) => {
    var _b = _a, {
      horizontalAlignment = "start",
      verticalAlignment = "top",
      spacing,
      divider,
      children,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "horizontalAlignment",
      "verticalAlignment",
      "spacing",
      "divider",
      "children",
      "className",
      "css"
    ]);
    const responsiveSpacing = useResponsiveProp(spacing);
    const responsiveDivider = useResponsiveProp(divider);
    const arrayChildren = Children2.toArray(children);
    return /* @__PURE__ */ React15.createElement(
      BaseStack,
      __spreadValues({
        horizontalAlignment,
        verticalAlignment,
        ref,
        className: ["GDS-horizontal-stack-layout", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), spacing && { gap: `$space${responsiveSpacing}` })
      }, props),
      React15.Children.map(arrayChildren, (child, index) => {
        const isLast = index === arrayChildren.length - 1;
        return /* @__PURE__ */ React15.createElement(React15.Fragment, null, child, !isLast && responsiveDivider ? responsiveDivider : null);
      })
    );
  }
);

// src/components/stack-layout/stack-layout.tsx
var StackLayout = forwardRef10(
  (_a, ref) => {
    var _b = _a, { orientation = "vertical" } = _b, props = __objRest(_b, ["orientation"]);
    const responsiveOrientation = useResponsiveProp(orientation);
    return responsiveOrientation === "horizontal" ? /* @__PURE__ */ React16.createElement(
      HorizontalStackLayout,
      __spreadValues({
        ref
      }, props)
    ) : /* @__PURE__ */ React16.createElement(
      VerticalStackLayout,
      __spreadValues({
        ref
      }, props)
    );
  }
);
StackLayout.displayName = "StackLayout";

// src/components/stack-layout/stack-item/stack-item.tsx
import React17, { forwardRef as forwardRef11 } from "react";
var BaseStackItem = styled("div", {
  display: "flex",
  flexDirection: "column",
  variants: {
    horizontalAlignment: {
      fillContainer: {
        alignItems: "stretch"
      },
      start: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      end: {
        alignItems: "flex-end"
      }
    },
    verticalAlignment: {
      fillContainer: {
        justifyContent: "stretch",
        "& > *": {
          flexGrow: 1
        }
      },
      top: {
        justifyContent: "flex-start"
      },
      center: {
        justifyContent: "center"
      },
      bottom: {
        justifyContent: "flex-end"
      }
    }
  }
});
var setFlexBasis = (baseWidth) => baseWidth === "hugContents" ? "fit-content" : baseWidth;
var StackItem = forwardRef11(
  (_a, ref) => {
    var _b = _a, {
      horizontalAlignment = "fillContainer",
      verticalAlignment = "fillContainer",
      growFactor,
      shrinkFactor,
      baseWidth,
      itemOrder,
      children,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "horizontalAlignment",
      "verticalAlignment",
      "growFactor",
      "shrinkFactor",
      "baseWidth",
      "itemOrder",
      "children",
      "className",
      "css"
    ]);
    return /* @__PURE__ */ React17.createElement(
      BaseStackItem,
      __spreadValues({
        horizontalAlignment,
        verticalAlignment,
        ref,
        className: ["GDS-stack-item", className].join(" "),
        css: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, css2), { flexGrow: growFactor, flexShrink: shrinkFactor }), baseWidth && { flexBasis: setFlexBasis(baseWidth) }), itemOrder && { order: itemOrder })
      }, props),
      children
    );
  }
);

// src/components/column-layout/column-layout.tsx
import React19, { useEffect as useEffect2, forwardRef as forwardRef13, useMemo as useMemo3 } from "react";

// src/components/column-layout/column.tsx
import React18, { forwardRef as forwardRef12 } from "react";
var ColumnBase = styled("div", {
  alignSelf: "stretch"
});
var isColumn = (column) => {
  const columnProps = column == null ? void 0 : column.props;
  return (columnProps == null ? void 0 : columnProps.width) !== void 0;
};
var Column = forwardRef12(
  (_a, ref) => {
    var _b = _a, {
      width: responsiveWidth,
      offset: responsiveOffset,
      order: responsiveOrder,
      as: asElement,
      index,
      css: css2,
      className,
      children,
      startColumn
    } = _b, props = __objRest(_b, [
      "width",
      "offset",
      "order",
      "as",
      "index",
      "css",
      "className",
      "children",
      "startColumn"
    ]);
    const width = useResponsiveProp(responsiveWidth);
    const offset = useResponsiveProp(responsiveOffset);
    const order = useResponsiveProp(responsiveOrder);
    const gridColumnStart = offset && offset > 0 ? startColumn != null ? startColumn : 0 : "auto";
    const gridColumnEnd = `span ${width}`;
    return /* @__PURE__ */ React18.createElement(
      ColumnBase,
      __spreadValues({
        ref,
        className: ["GDS-column", className].join(" "),
        css: __spreadValues({
          gridColumnStart,
          gridColumnEnd,
          order
        }, css2)
      }, props),
      children
    );
  }
);
Column.displayName = "Column";

// src/components/column-layout/column-layout.tsx
var ColumnCount = /* @__PURE__ */ ((ColumnCount2) => {
  ColumnCount2[ColumnCount2["mobile"] = 4] = "mobile";
  ColumnCount2[ColumnCount2["mobileLandscape"] = 8] = "mobileLandscape";
  ColumnCount2[ColumnCount2["tablet"] = 8] = "tablet";
  ColumnCount2[ColumnCount2["laptop"] = 12] = "laptop";
  ColumnCount2[ColumnCount2["desktop"] = 12] = "desktop";
  return ColumnCount2;
})(ColumnCount || {});
var ColumnLayoutBase = styled("div", {
  display: "grid",
  gap: "$oneAndHalf",
  "@mobile": {
    gridTemplateColumns: `repeat(${4 /* mobile */}, 1fr)`,
    gap: "$one",
    paddingLeft: "$oneAndHalf",
    paddingRight: "$oneAndHalf"
  },
  "@mobileLandscape": {
    gridTemplateColumns: `repeat(${8 /* mobileLandscape */}, 1fr)`,
    paddingLeft: "$two",
    paddingRight: "$two"
  },
  "@tablet": {
    gridTemplateColumns: `repeat(${8 /* tablet */}, 1fr)`,
    paddingLeft: "$two",
    paddingRight: "$two"
  },
  "@laptop": {
    gridTemplateColumns: `repeat(${12 /* laptop */}, 1fr)`,
    paddingLeft: "$twoAndHalf",
    paddingRight: "$twoAndHalf"
  },
  "@desktop": {
    gridTemplateColumns: `repeat(${12 /* desktop */}, 1fr)`,
    paddingLeft: "$twoAndHalf",
    paddingRight: "$twoAndHalf",
    maxWidth: breakpoints.desktop
  },
  variants: {
    background: {
      primary: {
        backgroundColor: "$surfaceBackgroundPrimary"
      },
      secondary: {
        backgroundColor: "$surfaceBackgroundSecondary"
      },
      highlight: {
        backgroundColor: "$surfaceBackgroundTertiary"
      },
      transparent: {
        backgroundColor: "transparent"
      }
    }
  }
});
var ColumnLayout = forwardRef13(
  (_a, ref) => {
    var _b = _a, {
      onBreakpointChange,
      className,
      css: css2,
      children,
      background = "primary"
    } = _b, props = __objRest(_b, [
      "onBreakpointChange",
      "className",
      "css",
      "children",
      "background"
    ]);
    const activeBreakpoint = useActiveBreakpoint(config.media);
    const getResponsivePropValue2 = useResponsivePropCallback();
    const enhancedChildren = useMemo3(() => {
      let currentColumn = 1;
      return React19.Children.map(children, (child) => {
        var _a2, _b2, _c, _d;
        if (React19.isValidElement(child) && isColumn(child)) {
          const width = (_b2 = getResponsivePropValue2((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.width)) != null ? _b2 : 0;
          const offset = (_d = getResponsivePropValue2((_c = child == null ? void 0 : child.props) == null ? void 0 : _c.offset)) != null ? _d : 0;
          const startColumn = currentColumn + offset;
          currentColumn = startColumn + width;
          return React19.cloneElement(child, {
            startColumn
          });
        }
        return null;
      });
    }, [children, getResponsivePropValue2]);
    useEffect2(() => {
      if (activeBreakpoint)
        onBreakpointChange == null ? void 0 : onBreakpointChange({
          breakpoint: activeBreakpoint,
          columns: ColumnCount[activeBreakpoint]
        });
    }, [activeBreakpoint, onBreakpointChange]);
    return /* @__PURE__ */ React19.createElement(
      ColumnLayoutBase,
      __spreadValues({
        ref,
        background,
        className: ["GDS-column-layout", className].join(" "),
        css: css2
      }, props),
      enhancedChildren
    );
  }
);
ColumnLayout.displayName = "ColumnLayout";

// src/components/skeleton/skeleton-rectangle.tsx
import React21 from "react";

// src/components/skeleton/skeleton-base.tsx
import React20 from "react";
import { keyframes as keyframes3 } from "@stitches/react";
var slide = keyframes3({
  "0%": {
    transform: "translateX(-100%)"
  },
  "100%": {
    transform: "translateX(100%)"
  }
});
var BaseSkeleton = styled("div", {
  backgroundColor: "#E7E7E7",
  // $onSurfaceShimmerBackground
  height: "100%",
  width: "100%",
  position: "relative",
  overflow: "hidden",
  "&:after": {
    content: "",
    top: 0,
    transform: "translateX(100%)",
    width: " 100%",
    height: "100%",
    position: "absolute",
    animation: `${slide} 2s infinite`,
    backgroundImage: "linear-gradient( to right, transparent 0%, rgba(255, 255, 255, 0.9) 50%, transparent 99%, transparent 100%)"
    // $onSurfaceShimmerHighlight
  }
});
var SkeletonBase = (_a) => {
  var _b = _a, {
    height = "100%",
    width,
    borderRadius = "$small",
    css: css2
  } = _b, props = __objRest(_b, [
    "height",
    "width",
    "borderRadius",
    "css"
  ]);
  const responsiveWidth = useResponsiveProp(width);
  const responsiveHeight = useResponsiveProp(height);
  return /* @__PURE__ */ React20.createElement(
    BaseSkeleton,
    __spreadValues({
      "aria-hidden": "true",
      css: __spreadValues({
        width: responsiveWidth,
        height: responsiveHeight,
        borderRadius
      }, css2)
    }, props)
  );
};

// src/components/skeleton/skeleton-rectangle.tsx
var ASPECT_RATIOS = {
  square: 1 / 1,
  standard: 4 / 3,
  tall: 3 / 4,
  wide: 16 / 9,
  panoramic: 11 / 4
};
var isGDSRatioToken = (ratioToken) => ratioToken in ASPECT_RATIOS;
var getAspectRatio = (aspectRatio) => {
  if (isGDSRatioToken(aspectRatio))
    return ASPECT_RATIOS[aspectRatio];
  return aspectRatio;
};
var SkeletonRectangle = (_a) => {
  var _b = _a, {
    aspectRatio = "square",
    borderRadius,
    height,
    width,
    css: css2,
    className
  } = _b, props = __objRest(_b, [
    "aspectRatio",
    "borderRadius",
    "height",
    "width",
    "css",
    "className"
  ]);
  return /* @__PURE__ */ React21.createElement(
    SkeletonBase,
    __spreadValues({
      className: ["GDS-skeleton-rectangle", className].join(" "),
      height,
      width,
      borderRadius,
      css: __spreadProps(__spreadValues({}, css2), {
        "aspect-ratio": getAspectRatio(aspectRatio)
      })
    }, props)
  );
};
SkeletonRectangle.displayName = "SkeletonRectangle";

// src/components/skeleton/skeleton-circle.tsx
import React22 from "react";
var SkeletonCircle = (_a) => {
  var _b = _a, {
    size = "100%",
    css: css2,
    className
  } = _b, props = __objRest(_b, [
    "size",
    "css",
    "className"
  ]);
  return /* @__PURE__ */ React22.createElement(
    SkeletonBase,
    __spreadValues({
      className: ["GDS-skeleton-circle", className].join(" "),
      height: size,
      width: size,
      borderRadius: "$circle",
      css: __spreadValues({}, css2)
    }, props)
  );
};
SkeletonCircle.displayName = "SkeletonCircle";

// src/components/skeleton/skeleton-text.tsx
import React23 from "react";
var LINE_WIDTHS = [100, 93, 81, 55, 66, 99, 88];
var LAST_LINE = 35;
var generateLines = ({
  lines = 1,
  header,
  width,
  borderRadius,
  css: css2
}) => {
  const result = [];
  for (let index = 0; index < lines; index += 1) {
    const lineWidth = width || (lines > 1 && index === lines - 1 ? LAST_LINE : LINE_WIDTHS[index % LINE_WIDTHS.length]);
    result.push(
      /* @__PURE__ */ React23.createElement(
        SkeletonBase,
        {
          css: css2,
          key: index,
          height: header ? "$two" : "$one",
          width: width || `${lineWidth}%`,
          borderRadius
        }
      )
    );
  }
  return result;
};
var SkeletonTextWrapper = styled("div", {
  textAlign: "$$alignment",
  display: "flex",
  gap: "$half",
  width: "100%",
  flexDirection: "column",
  variants: {
    alignment: {
      left: { alignItems: "start" },
      right: { alignItems: "end" },
      center: { alignItems: "center" }
    }
  }
});
var SkeletonText = (_a) => {
  var _b = _a, {
    lines = 1,
    header = false,
    alignment = "left",
    borderRadius,
    width,
    css: css2
  } = _b, props = __objRest(_b, [
    "lines",
    "header",
    "alignment",
    "borderRadius",
    "width",
    "css"
  ]);
  return /* @__PURE__ */ React23.createElement(SkeletonTextWrapper, __spreadValues({ alignment: useResponsiveProp(alignment) }, props), generateLines({
    lines,
    header,
    width: useResponsiveProp(width),
    borderRadius,
    css: css2
  }));
};
SkeletonText.displayName = "SkeletonText";

// src/components/image-message/image-message.tsx
import React24 from "react";
var ImageMessageBase = styled("div", {
  display: "flex",
  img: {
    maxWidth: "100%",
    maxHeight: "100%"
  },
  variants: {
    imagePosition: {
      top: {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      },
      end: { flexDirection: "row-reverse" },
      start: { flexDirection: "row" }
    }
  }
});
var ImageWrapper = styled("div", {
  display: "flex",
  variants: {
    imagePosition: {
      top: {
        width: "100%",
        marginBottom: "$$imageGap"
      },
      start: {
        marginRight: "$$imageGap"
      },
      end: {
        marginLeft: "$$imageGap"
      }
    },
    imageHorizontalAlignment: {
      center: {
        justifyContent: "center"
      },
      start: {
        justifyContent: "start"
      },
      end: {
        justifyContent: "end"
      }
    },
    imageVerticalAlignment: {
      center: {
        alignItems: "center"
      },
      top: {
        alignItems: "start"
      },
      bottom: {
        alignItems: "end"
      }
    }
  }
});
var ContentWrapper = styled("div", {
  width: "100%"
});
var ImageMessage = (_a) => {
  var _b = _a, {
    children,
    image,
    imageGap = "$oneAndHalf",
    imageAlt = "",
    imagePosition = "top",
    imageHorizontalAlignment = "center",
    imageVerticalAlignment = "center",
    imageWidth = "auto",
    imageHeight = "auto",
    className,
    css: css2
  } = _b, props = __objRest(_b, [
    "children",
    "image",
    "imageGap",
    "imageAlt",
    "imagePosition",
    "imageHorizontalAlignment",
    "imageVerticalAlignment",
    "imageWidth",
    "imageHeight",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ React24.createElement(
    ImageMessageBase,
    __spreadValues({
      imagePosition: useResponsiveProp(imagePosition),
      className: ["GDS-image-message", className].join(" "),
      css: css2
    }, props),
    /* @__PURE__ */ React24.createElement(
      ImageWrapper,
      {
        css: { $$imageGap: `$space${useResponsiveProp(imageGap)}` },
        imageHorizontalAlignment: useResponsiveProp(imageHorizontalAlignment),
        imageVerticalAlignment: useResponsiveProp(imageVerticalAlignment),
        imagePosition: useResponsiveProp(imagePosition)
      },
      /* @__PURE__ */ React24.createElement("img", { width: imageWidth, height: imageHeight, src: image, alt: imageAlt })
    ),
    children && /* @__PURE__ */ React24.createElement(ContentWrapper, null, children)
  );
};
ImageMessage.displayName = "ImageMessage";

// src/components/status/status-banner/status-banner.tsx
import React25, { forwardRef as forwardRef14 } from "react";

// src/components/status/status-color-tokens.ts
var backgroundColorByStatus = {
  success: "$successBackgroundSubdued",
  error: "$criticalBackgroundSubdued",
  info: "$highlightBackgroundSubdued",
  warning: "$warningBackgroundSubdued",
  neutral: "$inputBackgroundDisabled",
  brand: "$decorativeBrandPrimaryPastel"
};
var iconTintByStatus = {
  success: "$successIcon",
  error: "$criticalIcon",
  info: "$highlightIcon",
  warning: "$warningIcon",
  neutral: "$onSurfaceIconPrimary",
  brand: "$decorativeBrandPrimaryDefault"
};

// src/utilities.ts
import {
  createElement as createElement2
} from "react";
var isIcon = (icon) => {
  const iconProps = icon == null ? void 0 : icon.props;
  return (iconProps == null ? void 0 : iconProps.icon) !== void 0;
};
var withClassName = (component, ...classes) => {
  const name = `${typeof component === "string" ? component : ""}_${classes[0]}`;
  return {
    [name](props) {
      return createElement2(component, __spreadProps(__spreadValues({}, props), {
        className: `${props.className} ${classes}`
      }));
    }
  }[name];
};

// src/components/status/status-banner/status-banner.tsx
var iconByStatus = {
  success: "statusSuccessStatusFilled",
  error: "statusErrorStatusFilled",
  info: "statusInformationCircleFill",
  warning: "statusAlertFill",
  neutral: "statusInformationCircleFill",
  brand: "illustrativePerson"
};
var StatusBannerBase = styled(StackLayout, {
  borderRadius: "$small",
  padding: "$one",
  variants: {
    status: {
      info: {
        backgroundColor: backgroundColorByStatus.info
      },
      success: {
        backgroundColor: backgroundColorByStatus.success
      },
      warning: {
        backgroundColor: backgroundColorByStatus.warning
      },
      error: {
        backgroundColor: backgroundColorByStatus.error
      },
      brand: {
        backgroundColor: backgroundColorByStatus.brand
      },
      neutral: {
        backgroundColor: backgroundColorByStatus.neutral
      }
    }
  }
});
var StatusBannerIcon = ({
  icons: icons2,
  icon,
  status,
  className
}) => {
  var _a;
  const defaultTint = iconTintByStatus[status];
  const defaultIcon = iconByStatus[status];
  if (!icon)
    return /* @__PURE__ */ React25.createElement(Icon, { icon: defaultIcon, tint: defaultTint, className });
  if (isGDSIconToken(icon, icons2))
    return /* @__PURE__ */ React25.createElement(Icon, { icon, tint: defaultTint });
  if (React25.isValidElement(icon)) {
    if (isIcon(icon)) {
      const iconProps = icon == null ? void 0 : icon.props;
      const iconTint = (_a = iconProps.tint) != null ? _a : defaultTint;
      return React25.cloneElement(icon, __spreadProps(__spreadValues({}, iconProps), {
        className,
        tint: iconTint
      }));
    }
    return React25.cloneElement(icon, {
      className
    });
  }
  return null;
};
var StatusBanner = forwardRef14(
  (_a, ref) => {
    var _b = _a, {
      status,
      title,
      showIcon = true,
      icon,
      onDismissClick,
      css: css2,
      children,
      className
    } = _b, props = __objRest(_b, [
      "status",
      "title",
      "showIcon",
      "icon",
      "onDismissClick",
      "css",
      "children",
      "className"
    ]);
    const hasChildren = Boolean(children);
    const strings = useThemeStrings();
    const icons2 = useThemeIcons();
    return /* @__PURE__ */ React25.createElement(
      StatusBannerBase,
      __spreadValues({
        className: ["GDS-status-banner", className].join(" "),
        orientation: "horizontal",
        spacing: "$half",
        verticalAlignment: hasChildren ? void 0 : "center",
        status,
        ref,
        css: css2
      }, props),
      showIcon ? /* @__PURE__ */ React25.createElement(StackItem, null, /* @__PURE__ */ React25.createElement(
        StatusBannerIcon,
        {
          icons: icons2,
          icon,
          status,
          className: "GDS-status-banner-icon"
        }
      )) : null,
      /* @__PURE__ */ React25.createElement(StackItem, { growFactor: 1 }, /* @__PURE__ */ React25.createElement(StackLayout, null, title ? /* @__PURE__ */ React25.createElement(StackItem, null, React25.isValidElement(title) ? title : /* @__PURE__ */ React25.createElement(
        UtilityText,
        {
          emphasis: "emphasized",
          className: "GDS-status-banner-title",
          as: "p"
        },
        title
      )) : null, children ? /* @__PURE__ */ React25.createElement(StackItem, null, children) : null)),
      onDismissClick ? /* @__PURE__ */ React25.createElement(StackItem, null, /* @__PURE__ */ React25.createElement(
        Button,
        {
          className: "GDS-status-banner-dismiss-button",
          onClick: onDismissClick,
          priority: "secondary",
          quiet: true,
          hideLabel: true,
          icon: "tinyClose",
          size: "small"
        },
        strings == null ? void 0 : strings.dismiss
      )) : null
    );
  }
);
StatusBanner.displayName = "StatusBanner";

// src/components/status/status-banner/status-banner-emoji.tsx
import React26 from "react";
var StatusBannerEmoji = ({
  label,
  children
}) => {
  if (!label) {
    console.error(
      "StatusBannerEmoji is missing a descriptive label. To be accessible, [role='img'] elements must have an alternative text."
    );
  }
  return /* @__PURE__ */ React26.createElement("span", { role: "img", "aria-label": label }, children);
};

// src/components/status/status-badge/status-badge.tsx
import React27 from "react";
var StatusBadgeLight = styled("div", {
  width: 10,
  height: 10,
  borderRadius: "$circle",
  variants: {
    status: {
      info: {
        backgroundColor: iconTintByStatus.info
      },
      success: {
        backgroundColor: iconTintByStatus.success
      },
      warning: {
        backgroundColor: iconTintByStatus.warning
      },
      error: {
        backgroundColor: iconTintByStatus.error
      },
      brand: {
        backgroundColor: iconTintByStatus.brand
      },
      neutral: {
        backgroundColor: iconTintByStatus.neutral
      }
    }
  }
});
var StatusBadgeBase = styled("div", {
  display: "inline-block",
  borderRadius: "$pill",
  variants: {
    status: {
      info: {
        backgroundColor: backgroundColorByStatus.info
      },
      success: {
        backgroundColor: backgroundColorByStatus.success
      },
      warning: {
        backgroundColor: backgroundColorByStatus.warning
      },
      error: {
        backgroundColor: backgroundColorByStatus.error
      },
      brand: {
        backgroundColor: backgroundColorByStatus.brand
      },
      neutral: {
        backgroundColor: backgroundColorByStatus.neutral
      }
    }
  }
});
var StatusBadge = (_a) => {
  var _b = _a, {
    status,
    label,
    showLight = true,
    className,
    css: css2
  } = _b, props = __objRest(_b, [
    "status",
    "label",
    "showLight",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ React27.createElement(
    StatusBadgeBase,
    __spreadProps(__spreadValues({
      className: ["GDS-status-badge", className].join(" "),
      status
    }, props), {
      css: css2
    }),
    /* @__PURE__ */ React27.createElement(
      StackLayout,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$quarter",
        css: { paddingLeft: "$half", paddingRight: "$half" }
      },
      showLight ? /* @__PURE__ */ React27.createElement(StatusBadgeLight, { className: "GDS-status-badge-light", status }) : null,
      /* @__PURE__ */ React27.createElement(UtilityText, { size: "sm", emphasis: "emphasized" }, label)
    )
  );
};
StatusBadge.displayName = "StatusBadge";

// src/components/card/card.tsx
import React31, { forwardRef as forwardRef16 } from "react";

// src/components/card/card-section.tsx
import React28 from "react";
var BaseCardPart = styled("div", {
  padding: "$oneAndHalf",
  position: "relative",
  flex: 1
});
var CardSection = ({
  children,
  className,
  css: css2,
  padding
}) => {
  const cardPadding = useResponsiveProp(padding);
  return /* @__PURE__ */ React28.createElement(
    BaseCardPart,
    {
      className: ["GDS-card-section", className].join(" "),
      css: __spreadValues(__spreadValues({}, css2), padding && {
        padding: `${cardPadding}`
      })
    },
    children
  );
};

// src/components/card/card-image.tsx
import React29 from "react";
var BaseImage = styled("img", {
  width: "100%",
  objectFit: "cover"
});
var CardImage = (_a) => {
  var _b = _a, {
    className,
    css: css2,
    image,
    imageAlt = ""
  } = _b, props = __objRest(_b, [
    "className",
    "css",
    "image",
    "imageAlt"
  ]);
  return /* @__PURE__ */ React29.createElement(
    BaseImage,
    __spreadValues({
      src: image,
      alt: imageAlt,
      css: css2,
      className: ["GDS-card-image", className].join(" ")
    }, props)
  );
};

// src/components/card/card-click-area.tsx
import React30, { forwardRef as forwardRef15 } from "react";
var IMAGE_MAX_WIDTH = "350px";
var ImagePositionWrapper = styled("div", {
  borderRadius: "$medium",
  display: "flex",
  overflow: "hidden",
  variants: {
    imagePosition: {
      top: {
        flexDirection: "column",
        alignItems: "stretch"
      },
      start: {
        flexDirection: "row",
        "& img": {
          maxWidth: IMAGE_MAX_WIDTH
        }
      },
      end: {
        flexDirection: "row-reverse",
        "& img": {
          maxWidth: IMAGE_MAX_WIDTH
        }
      }
    }
  }
});
var BaseClickArea = styled(ImagePositionWrapper, {
  border: "$borderWidths$thin solid transparent",
  borderRadius: "$medium",
  overflow: "hidden",
  flex: "1",
  "&:hover": {
    cursor: "pointer",
    border: "$borderWidths$thin solid $colors$interactiveFocusOuter",
    "a:hover, button:hover": {
      textDecoration: "none"
    }
  },
  '& [class*="GDS"]:focus': {
    outline: "none"
  },
  '& [class*="GDS"]:focus-visible': __spreadValues({}, focusOutlineOuter)
});
var CardClickArea = forwardRef15(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      imagePosition = "top",
      onCardMouseDown,
      onCardMouseUp
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "imagePosition",
      "onCardMouseDown",
      "onCardMouseUp"
    ]);
    const cardImagePosition = useResponsiveProp(imagePosition);
    return /* @__PURE__ */ React30.createElement(
      BaseClickArea,
      __spreadValues({
        ref,
        className: ["GDS-card-click-area", className].join(" "),
        onMouseDown: onCardMouseDown,
        onMouseUp: onCardMouseUp,
        imagePosition: cardImagePosition,
        css: css2
      }, props),
      children
    );
  }
);

// src/components/card/card.tsx
var overlayStyles = {
  backgroundOverlay: {
    true: {
      "&:before": {
        content: "",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        opacity: "40%"
      }
    }
  }
};
var BaseCardContainer = styled(ImagePositionWrapper, {
  position: "relative"
});
var ElevatedCardBase = styled(BaseCardContainer, {
  border: "$borderWidths$thin solid $onSurfaceBorderSubdued",
  boxShadow: "$card",
  variants: __spreadProps(__spreadValues({}, overlayStyles), {
    backgroundColor: {
      primary: {
        backgroundColor: "$surfaceCardPrimary"
      },
      secondary: {
        backgroundColor: "$surfaceCardSecondary"
      },
      highlight: {
        backgroundColor: "$surfaceBackgroundTertiary"
      }
    }
  }),
  compoundVariants: [
    {
      backgroundColor: "primary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceCardPrimary"
        }
      }
    },
    {
      backgroundColor: "secondary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceCardSecondary"
        }
      }
    },
    {
      backgroundColor: "highlight",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundTertiary"
        }
      }
    }
  ]
});
var FlatCardBase = styled(BaseCardContainer, {
  variants: __spreadProps(__spreadValues({}, overlayStyles), {
    backgroundColor: {
      transparent: {
        backgroundColor: "transparent"
      },
      primary: {
        backgroundColor: "$surfaceBackgroundPrimary"
      },
      secondary: {
        backgroundColor: "$surfaceBackgroundSecondary"
      },
      highlight: {
        backgroundColor: "$surfaceBackgroundTertiary"
      }
    }
  }),
  compoundVariants: [
    {
      backgroundColor: "primary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundPrimary"
        }
      }
    },
    {
      backgroundColor: "secondary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundSecondary"
        }
      }
    },
    {
      backgroundColor: "highlight",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundTertiary"
        }
      }
    }
  ]
});
var ElevatedCardContainer = forwardRef16(
  (_a, ref) => {
    var _b = _a, {
      backgroundColor = "primary",
      backgroundImage,
      backgroundOverlay,
      children,
      className,
      css: css2,
      imagePosition = "top"
    } = _b, props = __objRest(_b, [
      "backgroundColor",
      "backgroundImage",
      "backgroundOverlay",
      "children",
      "className",
      "css",
      "imagePosition"
    ]);
    const cardImagePosition = useResponsiveProp(imagePosition);
    return /* @__PURE__ */ React31.createElement(
      ElevatedCardBase,
      __spreadValues({
        backgroundColor,
        backgroundOverlay,
        className: ["GDS-elevated-card", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), backgroundImage && {
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }),
        imagePosition: cardImagePosition,
        ref
      }, props),
      children
    );
  }
);
var FlatCardContainer = forwardRef16(
  (_a, ref) => {
    var _b = _a, {
      backgroundColor = "primary",
      backgroundImage,
      backgroundOverlay,
      children,
      css: css2,
      className,
      imagePosition = "top"
    } = _b, props = __objRest(_b, [
      "backgroundColor",
      "backgroundImage",
      "backgroundOverlay",
      "children",
      "css",
      "className",
      "imagePosition"
    ]);
    const cardImagePosition = useResponsiveProp(imagePosition);
    return /* @__PURE__ */ React31.createElement(
      FlatCardBase,
      __spreadValues({
        backgroundColor,
        backgroundOverlay,
        className: ["GDS-flat-card", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), backgroundImage && {
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }),
        imagePosition: cardImagePosition,
        ref
      }, props),
      children
    );
  }
);
var Card = {
  Flat: FlatCardContainer,
  Elevated: ElevatedCardContainer,
  Section: CardSection,
  Image: CardImage,
  ClickArea: CardClickArea
};
Card.Flat.displayName = "Card.Flat";
Card.Elevated.displayName = "Card.Elevated";
Card.Section.displayName = "Card.Section";
Card.Image.displayName = "Card.Image";
Card.ClickArea.displayName = "Card.ClickArea";

// src/components/card/use-clickable-card.ts
import { useRef as useRef3, useEffect as useEffect3, useState as useState3, useCallback as useCallback3 } from "react";
var useClickableCard = () => {
  const primaryActionRef = useRef3(null);
  const clickAreaRef = useRef3(null);
  const [up2, setUp] = useState3(0);
  const [down2, setDown] = useState3(0);
  const onCardMouseDown = useCallback3(() => setDown(+/* @__PURE__ */ new Date()), []);
  const onCardMouseUp = useCallback3((event) => {
    event.preventDefault();
    return setUp(+/* @__PURE__ */ new Date());
  }, []);
  useEffect3(() => {
    const clickDuration = up2 - down2;
    const isWithinClickThreshold = clickDuration > 0 && clickDuration < 200;
    const isPrimaryActionClicked = primaryActionRef.current === document.activeElement;
    if (primaryActionRef.current && isWithinClickThreshold && !isPrimaryActionClicked) {
      primaryActionRef.current.click();
    }
  }, [up2, down2]);
  return {
    primaryActionRef,
    clickAreaRef,
    onCardMouseUp,
    onCardMouseDown
  };
};

// src/components/portal/portal.tsx
import React33, { forwardRef as forwardRef17 } from "react";
import * as RadixPortal from "@radix-ui/react-portal";
var Portal = forwardRef17(
  (_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
    const theme2 = useTheme();
    return /* @__PURE__ */ React33.createElement(RadixPortal.Root, __spreadProps(__spreadValues({}, props), { className: "GDS-portal" }), /* @__PURE__ */ React33.createElement(ThemeContainer, { theme: theme2, ref }, children));
  }
);

// src/components/responsive/responsive.tsx
import React34 from "react";

// src/hooks/use-media-query.ts
import { useState as useState4, useEffect as useEffect4 } from "react";
var useMediaQuery = (query) => {
  const [matches, setMatches] = useState4(window.matchMedia(query).matches);
  useEffect4(() => {
    const eventListener = (e) => setMatches(e.matches);
    const matchedMediaList = window.matchMedia(query);
    matchedMediaList.addEventListener("change", eventListener);
    return () => matchedMediaList.removeEventListener("change", eventListener);
  }, [query]);
  return matches;
};

// src/breakpoints/query-helpers.ts
var sortBreakpointsValues = (values) => {
  const keys = Object.keys(values);
  const breakpointsAsArray = keys.map((key) => ({ key, val: values[key] })) || [];
  breakpointsAsArray.sort(
    (breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val
  );
  return breakpointsAsArray.reduce(
    (acc, obj) => __spreadProps(__spreadValues({}, acc), { [obj.key]: obj.val }),
    {}
  );
};
var sortedBreakpointValues = sortBreakpointsValues(breakpoints);
var breakpointKeys = Object.keys(sortedBreakpointValues);
var unit = "px";
var isBreakpointToken = (token) => token in breakpoints;
var getValue = (breakpoint) => {
  if (isBreakpointToken(breakpoint))
    return breakpoints[breakpoint];
  return breakpoint;
};
var up = (breakpoint) => {
  const value = getValue(breakpoint);
  return `(min-width:${value}${unit})`;
};
var down = (breakpoint) => {
  const value = getValue(breakpoint);
  return `(max-width:${value - 1}${unit})`;
};
var between = (rangeValues) => {
  const startValue = getValue(rangeValues == null ? void 0 : rangeValues[0]);
  const endValue = getValue(rangeValues == null ? void 0 : rangeValues[1]);
  return `(min-width:${startValue}${unit}) and (max-width:${endValue - 1}${unit})`;
};
var only = (breakpoint) => {
  if (breakpointKeys.indexOf(breakpoint) + 1 < breakpointKeys.length) {
    return between([
      breakpoint,
      breakpointKeys[breakpointKeys.indexOf(breakpoint) + 1]
    ]);
  }
  return up(breakpoint);
};
var not = (breakpoint) => {
  const keyIndex = breakpointKeys.indexOf(breakpoint);
  if (keyIndex === 0) {
    return up(breakpointKeys[1]);
  }
  if (keyIndex === breakpointKeys.length - 1) {
    return down(breakpointKeys[keyIndex]);
  }
  const betweenQuery = between([
    breakpoint,
    breakpointKeys[breakpointKeys.indexOf(breakpoint) + 1]
  ]);
  return betweenQuery && `not all and ${betweenQuery}`;
};
var queryHelpers = { up, down, between, only, not };

// src/components/responsive/responsive.tsx
var getMediaQueryFromProps = (otherProps, query) => {
  if (query)
    return query;
  const queryHelperPropKeys = Object.keys(otherProps).filter((key) => Object.keys(queryHelpers).includes(key)).sort();
  const queryHelperProps = queryHelperPropKeys.reduce(
    (result, key) => __spreadProps(__spreadValues({}, result), { [key]: otherProps[key] }),
    {}
  );
  if (!query && queryHelperPropKeys.length === 0) {
    console.warn(
      "No prop passed. Please provide one of: up, down, between, only, not, query."
    );
    return "false";
  }
  if (query && queryHelperPropKeys.length > 0 || !query && queryHelperPropKeys.length > 1) {
    console.warn(
      "Too many props passed. Please provide only one of: up, down, between, only, not, query."
    );
    return "false";
  }
  const helperKey = queryHelperPropKeys[0];
  if (helperKey) {
    const helperFunction = queryHelpers[helperKey];
    const value = queryHelperProps[helperKey];
    return helperFunction(value);
  }
  return "false";
};
var Responsive = (_a) => {
  var _b = _a, {
    children,
    query
  } = _b, otherProps = __objRest(_b, [
    "children",
    "query"
  ]);
  const queryValue = getMediaQueryFromProps(otherProps, query);
  const matches = useMediaQuery(queryValue);
  return matches ? /* @__PURE__ */ React34.createElement("div", null, children) : null;
};
Responsive.displayName = "Responsive";

// src/components/box/box.tsx
import React35, { forwardRef as forwardRef18 } from "react";
var BaseBox = styled("div");
var Box = forwardRef18(
  (_a, ref) => {
    var _b = _a, { as: asElement, className, css: css2, children } = _b, props = __objRest(_b, ["as", "className", "css", "children"]);
    return /* @__PURE__ */ React35.createElement(
      BaseBox,
      __spreadValues({
        as: asElement,
        className: ["GDS-box", className].join(" "),
        css: __spreadValues({}, css2),
        ref
      }, props),
      children
    );
  }
);
Box.displayName = "Box";

// src/components/popover/popover.tsx
import * as RadixPopoverPrimitive3 from "@radix-ui/react-popover";

// src/components/popover/popover-trigger.tsx
import React36, { forwardRef as forwardRef19 } from "react";
import * as RadixPopoverPrimitive from "@radix-ui/react-popover";
var BaseTrigger = styled(RadixPopoverPrimitive.Trigger, {});
var PopoverTrigger = forwardRef19(
  (_a, ref) => {
    var _b = _a, {
      children,
      css: css2,
      hideLabel,
      icon,
      label,
      priority,
      quiet,
      size,
      className
    } = _b, props = __objRest(_b, [
      "children",
      "css",
      "hideLabel",
      "icon",
      "label",
      "priority",
      "quiet",
      "size",
      "className"
    ]);
    if (!label && !children)
      console.warn(
        "To show a Popover initiator, set the label on Popover.Trigger or provide a custom button element as a child of Popover.Trigger."
      );
    return /* @__PURE__ */ React36.createElement(
      BaseTrigger,
      {
        className: ["GDS-popover-trigger", className].join(" "),
        css: css2,
        ref,
        asChild: true
      },
      label ? /* @__PURE__ */ React36.createElement(
        Button,
        __spreadValues({
          hideLabel,
          icon,
          priority,
          quiet,
          size
        }, props),
        label
      ) : children
    );
  }
);

// src/components/popover/popover-content.tsx
import React37, { forwardRef as forwardRef20 } from "react";
import * as RadixPopoverPrimitive2 from "@radix-ui/react-popover";
var BasePopoverContent = styled(RadixPopoverPrimitive2.Content, {
  typography: "$bodyOne",
  color: "$onSurfaceTextPrimary",
  borderRadius: "$medium",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  backgroundColor: "$surfaceBackgroundPrimary",
  boxShadow: "$dropdown",
  zIndex: "$tooltip",
  '&[class*="GDS"]:focus, &[class*="GDS"]:active': {
    boxShadow: "$dropdown",
    outline: "none",
    position: "initial"
  }
});
var PopoverHeading = styled("div", {
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: "$one"
});
var PopoverContent = forwardRef20(
  (_a, ref) => {
    var _b = _a, {
      align,
      avoidCollisions,
      children,
      closeLabel,
      collisionPadding,
      css: css2,
      headingBar,
      padding = "$one",
      showCloseButton = true,
      side,
      sideOffset = 6,
      className
    } = _b, props = __objRest(_b, [
      "align",
      "avoidCollisions",
      "children",
      "closeLabel",
      "collisionPadding",
      "css",
      "headingBar",
      "padding",
      "showCloseButton",
      "side",
      "sideOffset",
      "className"
    ]);
    const contentPadding = useResponsiveProp(padding);
    const responsiveSide = useResponsiveProp(side);
    const responsiveAlign = useResponsiveProp(align);
    const stringsMap = useThemeStrings();
    return /* @__PURE__ */ React37.createElement(Portal, null, /* @__PURE__ */ React37.createElement(
      BasePopoverContent,
      __spreadValues({
        className: ["GDS-popover-content", className].join(" "),
        align: responsiveAlign,
        avoidCollisions,
        collisionPadding,
        css: __spreadValues(__spreadValues({}, css2), padding && {
          padding: `${contentPadding}`
        }),
        ref,
        side: responsiveSide,
        sideOffset
      }, props),
      headingBar || showCloseButton && /* @__PURE__ */ React37.createElement(PopoverHeading, { className: "GDS-popover-heading-bar" }, /* @__PURE__ */ React37.createElement(RadixPopoverPrimitive2.Close, { asChild: true }, /* @__PURE__ */ React37.createElement(
        Button,
        {
          type: "button",
          icon: "tinyClose",
          hideLabel: true,
          quiet: true,
          priority: "secondary",
          size: "small",
          className: "GDS-popover-close",
          css: {
            color: "$interactiveActionSubdued",
            svg: {
              width: "$threeQuarters",
              height: "$threeQuarters"
            }
          }
        },
        closeLabel || stringsMap.close
      ))),
      children
    ));
  }
);

// src/components/popover/popover.tsx
var GDSPopoverPrimitive = RadixPopoverPrimitive3;
var PopoverClose = withClassName(
  RadixPopoverPrimitive3.Close,
  "GDS-close-button"
);
var Popover = {
  Root: RadixPopoverPrimitive3.Root,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Close: PopoverClose
};
Popover.Root.displayName = "Popover.Root";
Popover.Trigger.displayName = "Popover.Trigger";
Popover.Content.displayName = "Popover.Content";
Popover.Close.displayName = "Popover.Close";

// src/components/modal/modal.tsx
import React40 from "react";
import * as Dialog2 from "@radix-ui/react-dialog";

// src/components/modal/modal-content.tsx
import React39, { forwardRef as forwardRef21, useRef as useRef4 } from "react";
import * as Dialog from "@radix-ui/react-dialog";

// src/hooks/use-composed-ref.ts
import * as React38 from "react";
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return React38.useCallback(composeRefs(...refs), refs);
}

// src/components/modal/animations.ts
import { keyframes as keyframes4 } from "@stitches/react";
var transition = "$transitions$defaultTime ease-in-out";
var animations = {
  overlayShow: {
    "0%": { opacity: 0 },
    "100%": { opacity: 1 }
  },
  overlayClose: {
    "0%": { opacity: 1 },
    "100%": { opacity: 0 }
  },
  contentShow: {
    "0%": { opacity: 0, transform: "translate(-50%, -48%) scale(.96)" },
    "100%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" }
  },
  contentClose: {
    "0%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" },
    "100%": { opacity: 0, transform: "translate(-50%, -48%) scale(.96)" }
  },
  leftOpen: {
    "0%": { transform: "translateX(-100%)" },
    "100%": { transform: "translateX(0)" }
  },
  leftClose: {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(-100%)" }
  },
  rightOpen: {
    "0%": { transform: "translateX(100%)" },
    "100%": { transform: "translateX(0)" }
  },
  rightClose: {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(100%)" }
  },
  bottomOpen: {
    "0%": { transform: "translateY(100%)" },
    "100%": { transform: "translateY(0)" }
  },
  bottomClose: {
    "0%": { transform: "translateY(0)" },
    "100%": { transform: "translateY(100%)" }
  }
};
var animate = (frames) => `${keyframes4(animations[frames])} ${transition}`;

// src/components/modal/modal-content.tsx
var applyModalAnimation = ({
  open,
  close
}) => ({
  animation: animate(open),
  "@media (prefers-reduced-motion)": { animation: "none" },
  '&[data-state="closed"]': {
    animation: animate(close),
    "@media (prefers-reduced-motion)": { animation: "none" }
  }
});
var DialogOverlay = styled(Dialog.Overlay, __spreadValues({
  backgroundColor: "rgba(136, 136, 136, 0.7)",
  position: "fixed",
  inset: 0,
  zIndex: "$modal"
}, applyModalAnimation({ open: "overlayShow", close: "overlayClose" })));
var distanceFromEdge = 40;
var DialogContainer = styled(Dialog.Content, {
  background: "$surfaceBackgroundPrimary",
  boxShadow: "$dropdown",
  position: "fixed",
  overflow: "auto",
  zIndex: "$modal",
  width: "33vw",
  "@tablet": { width: "66vw" },
  "@mobileLandscape": { width: "66vw" },
  "&:focus": { outline: "none !important" },
  variants: {
    layout: {
      standard: __spreadProps(__spreadValues({
        maxHeight: "100%",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "$large"
      }, applyModalAnimation({ open: "contentShow", close: "contentClose" })), {
        "@mobile": __spreadValues({
          transform: "unset",
          width: "100vw",
          bottom: 0,
          top: "unset",
          left: 0,
          right: 0,
          maxHeight: `calc(100% - ${distanceFromEdge}px)`,
          borderRadius: "$large $large 0 0"
        }, applyModalAnimation({ open: "bottomOpen", close: "bottomClose" }))
      }),
      fullscreen: __spreadProps(__spreadValues({
        bottom: 0,
        left: `${distanceFromEdge}px`,
        right: `${distanceFromEdge}px`,
        width: `calc(100vw - ${distanceFromEdge * 2}px)`,
        height: `calc(100% - ${distanceFromEdge}px)`,
        borderRadius: "$large $large 0 0"
      }, applyModalAnimation({ open: "bottomOpen", close: "bottomClose" })), {
        "@mobile": {
          width: "100vw",
          left: 0,
          right: 0,
          borderRadius: "$large $large 0 0"
        }
      }),
      left: __spreadProps(__spreadValues({
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: "0 $large $large 0"
      }, applyModalAnimation({ open: "leftOpen", close: "leftClose" })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      }),
      right: __spreadProps(__spreadValues({
        height: "100%",
        top: 0,
        right: 0,
        left: "unset",
        borderRadius: "$large 0 0 $large"
      }, applyModalAnimation({ open: "rightOpen", close: "rightClose" })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      })
    }
  }
});
var DialogContent = styled("div");
var ModalWrapper = styled("div");
var ModalContent = forwardRef21(
  (_a, ref) => {
    var _b = _a, {
      layout = "standard",
      padding = "$oneAndHalf",
      showCloseButton = true,
      forceModalFocus = true,
      onInteractOutside,
      width,
      className,
      children,
      css: css2,
      container
    } = _b, props = __objRest(_b, [
      "layout",
      "padding",
      "showCloseButton",
      "forceModalFocus",
      "onInteractOutside",
      "width",
      "className",
      "children",
      "css",
      "container"
    ]);
    const responsivePadding = useResponsiveProp(padding);
    const responsiveWidth = useResponsiveProp(width);
    const responsiveLayout = useResponsiveProp(layout);
    const strings = useThemeStrings();
    const internalRef = useRef4(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    return /* @__PURE__ */ React39.createElement(Portal, { container }, /* @__PURE__ */ React39.createElement(ModalWrapper, __spreadValues({ css: css2 }, props), /* @__PURE__ */ React39.createElement(DialogOverlay, { className: "GDS-modal-overlay", "data-testid": "overlay" }), /* @__PURE__ */ React39.createElement(
      DialogContainer,
      __spreadProps(__spreadValues(__spreadValues({
        className: ["GDS-modal", className].join(" ")
      }, forceModalFocus && {
        onOpenAutoFocus: (e) => {
          e.preventDefault();
          if (internalRef == null ? void 0 : internalRef.current)
            internalRef.current.focus();
        }
      }), width && {
        css: { width: responsiveWidth }
      }), {
        onInteractOutside,
        layout: responsiveLayout,
        ref: composedRefs
      }),
      showCloseButton && /* @__PURE__ */ React39.createElement(
        StackLayout,
        {
          orientation: "horizontal",
          horizontalAlignment: "end",
          css: { padding: "$half $half $none $half" },
          className: "GDS-modal-close-button-wrapper"
        },
        /* @__PURE__ */ React39.createElement(Dialog.Close, { asChild: true }, /* @__PURE__ */ React39.createElement(
          Button,
          {
            priority: "tertiary",
            quiet: true,
            icon: "tinyClose",
            hideLabel: true,
            size: "small",
            className: "GDS-modal-close-button"
          },
          strings.close
        ))
      ),
      /* @__PURE__ */ React39.createElement(
        DialogContent,
        {
          className: "GDS-modal-content",
          css: { padding: responsivePadding }
        },
        children
      )
    )));
  }
);

// src/components/modal/modal.tsx
var GDSModalPrimitive = Dialog2;
var ModalTrigger = ({ children }) => /* @__PURE__ */ React40.createElement(Dialog2.Trigger, { asChild: true }, children);
var ModalClose = ({ children }) => /* @__PURE__ */ React40.createElement(Dialog2.Close, { asChild: true }, children);
var ModalTitle = ({ children }) => /* @__PURE__ */ React40.createElement(Dialog2.Title, { asChild: true }, children);
var ModalDescription = ({ children }) => /* @__PURE__ */ React40.createElement(Dialog2.Description, { asChild: true }, children);
var Modal = {
  Root: Dialog2.Root,
  Trigger: ModalTrigger,
  Content: ModalContent,
  Close: ModalClose,
  Title: ModalTitle,
  Description: ModalDescription
};
Modal.Root.displayName = "Modal.Root";
Modal.Content.displayName = "Modal.Content";
Modal.Trigger.displayName = "Modal.Trigger";
Modal.Close.displayName = "Modal.Close";
Modal.Title.displayName = "Modal.Title";
Modal.Description.displayName = "Modal.Description";

// src/components/tooltip/tooltip.tsx
import React42, { forwardRef as forwardRef23 } from "react";
import * as RadixTooltipPrimitive3 from "@radix-ui/react-tooltip";

// src/components/tooltip/tooltip-content.tsx
import React41, { forwardRef as forwardRef22 } from "react";
import * as RadixTooltipPrimitive2 from "@radix-ui/react-tooltip";
var BaseTooltipContent = styled(RadixTooltipPrimitive2.Content, {
  typography: "$bodyTwo",
  color: "$onSurfaceTextPrimary",
  borderRadius: "$medium",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  backgroundColor: "$surfaceBackgroundPrimary",
  boxShadow: "$dropdown",
  zIndex: "$tooltip",
  '&[class*="GDS"]:focus, &[class*="GDS"]:active': {
    boxShadow: "$dropdown",
    outline: "none",
    position: "initial"
  }
});
var TooltipContent = forwardRef22(
  (_a, ref) => {
    var _b = _a, {
      align,
      avoidCollisions = true,
      children,
      className,
      collisionPadding,
      css: css2,
      padding = "$half",
      side,
      sideOffset = 6
    } = _b, props = __objRest(_b, [
      "align",
      "avoidCollisions",
      "children",
      "className",
      "collisionPadding",
      "css",
      "padding",
      "side",
      "sideOffset"
    ]);
    const contentPadding = useResponsiveProp(padding);
    const responsiveSide = useResponsiveProp(side);
    const responsiveAlign = useResponsiveProp(align);
    return /* @__PURE__ */ React41.createElement(Portal, null, /* @__PURE__ */ React41.createElement(
      BaseTooltipContent,
      __spreadValues({
        align: responsiveAlign,
        avoidCollisions,
        className: ["GDS-tooltip-content", className].join(" "),
        collisionPadding,
        css: __spreadValues(__spreadValues({}, css2), padding && {
          padding: `${contentPadding}`
        }),
        ref,
        side: responsiveSide,
        sideOffset
      }, props),
      children
    ));
  }
);

// src/components/tooltip/tooltip.tsx
var GDSTooltipPrimitive = RadixTooltipPrimitive3;
var Tooltip = forwardRef23(
  (_a, ref) => {
    var _b = _a, {
      align,
      avoidCollisions,
      children,
      className,
      content,
      css: css2,
      defaultOpen,
      onOpenChange,
      open,
      padding,
      side,
      sideOffset
    } = _b, props = __objRest(_b, [
      "align",
      "avoidCollisions",
      "children",
      "className",
      "content",
      "css",
      "defaultOpen",
      "onOpenChange",
      "open",
      "padding",
      "side",
      "sideOffset"
    ]);
    return /* @__PURE__ */ React42.createElement(
      RadixTooltipPrimitive3.Root,
      {
        open,
        defaultOpen,
        onOpenChange
      },
      /* @__PURE__ */ React42.createElement(RadixTooltipPrimitive3.Trigger, { asChild: true, className: "GDS-tooltip-trigger" }, children),
      /* @__PURE__ */ React42.createElement(
        TooltipContent,
        __spreadValues({
          align,
          avoidCollisions,
          className,
          css: css2,
          padding,
          ref,
          side,
          sideOffset
        }, props),
        content
      )
    );
  }
);
Tooltip.displayName = "Tooltip";

// src/components/tabs/tabs.tsx
import * as RadixTabsPrimitive5 from "@radix-ui/react-tabs";

// src/components/tabs/tabs-root.tsx
import React43 from "react";
import * as RadixTabsPrimitive from "@radix-ui/react-tabs";
var BaseTabsRoot = styled(RadixTabsPrimitive.Root, {
  width: "100%"
});
var TabsRoot = ({
  activationMode = "manual",
  children,
  className,
  css: css2,
  defaultValue,
  onValueChange,
  value
}) => /* @__PURE__ */ React43.createElement(
  BaseTabsRoot,
  {
    activationMode,
    className: [`GDS-tabs`, className].join(" "),
    css: css2,
    defaultValue,
    onValueChange,
    value
  },
  children
);

// src/components/tabs/tab-list.tsx
import React46, { forwardRef as forwardRef25 } from "react";
import * as RadixTabsPrimitive2 from "@radix-ui/react-tabs";

// src/components/tabs/use-tabs-scroll.tsx
import { useRef as useRef5, useEffect as useEffect5, useState as useState5, useCallback as useCallback5 } from "react";
import { throttle } from "lodash";
var useTabsScroll = () => {
  var _a;
  const [isScrolledStart, setIsScrolledStart] = useState5(true);
  const [isScrolledEnd, setIsScrolledEnd] = useState5(false);
  const [hasOverflow, setHasOverflow] = useState5(false);
  const tabsList = useRef5(null);
  const listWidth = (_a = tabsList.current) == null ? void 0 : _a.offsetWidth;
  const scrollAmount = listWidth ? listWidth / 2 : 0;
  const showScrollLeft = !isScrolledStart && hasOverflow;
  const showScrollRight = !isScrolledEnd && hasOverflow;
  const scrollLeft = useCallback5(() => {
    if (tabsList.current) {
      tabsList.current.scrollLeft += -scrollAmount;
    }
  }, [scrollAmount]);
  const scrollRight = useCallback5(() => {
    if (tabsList.current) {
      tabsList.current.scrollLeft += scrollAmount;
    }
  }, [scrollAmount]);
  const showHideControls = () => {
    if (tabsList.current && tabsList.current.scrollLeft < 1) {
      setIsScrolledStart(true);
    } else {
      setIsScrolledStart(false);
    }
    if (tabsList.current && Math.ceil(tabsList.current.scrollLeft) >= tabsList.current.scrollWidth - tabsList.current.offsetWidth) {
      setIsScrolledEnd(true);
    } else {
      setIsScrolledEnd(false);
    }
  };
  const showControlsOnOverflow = () => {
    const { innerWidth } = window;
    let offsetWidth = 0;
    let scrollWidth = 0;
    if (tabsList.current) {
      offsetWidth = tabsList.current.offsetWidth;
      scrollWidth = tabsList.current.scrollWidth;
    }
    return scrollWidth > offsetWidth || scrollWidth > innerWidth ? setHasOverflow(true) : setHasOverflow(false);
  };
  useEffect5(() => {
    const currentRef = tabsList == null ? void 0 : tabsList.current;
    const onScroll = throttle(() => {
      showHideControls();
    }, 500);
    const onResize = throttle(() => {
      showControlsOnOverflow();
    }, 500);
    currentRef == null ? void 0 : currentRef.addEventListener("scroll", onScroll);
    showControlsOnOverflow();
    window.addEventListener("resize", onResize);
    return () => {
      currentRef == null ? void 0 : currentRef.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      setHasOverflow(false);
      setIsScrolledEnd(false);
      setIsScrolledStart(true);
    };
  }, [tabsList]);
  return {
    scrollLeft,
    scrollRight,
    tabsList,
    showScrollLeft,
    showScrollRight
  };
};

// src/components/tabs/scroll-buttons.tsx
import React44, { forwardRef as forwardRef24 } from "react";
var ScrollableWrapper = styled("div", {
  position: "relative",
  maxWidth: "100%"
});
var ScrollableItemsWrapper = styled("div");
var ButtonWrapper = styled("div", {
  backgroundColor: "$surfaceBackgroundPrimary",
  position: "absolute",
  top: 0,
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
var ScrollLeft = forwardRef24(
  ({ onClick }, ref) => {
    const strings = useThemeStrings();
    return /* @__PURE__ */ React44.createElement(ButtonWrapper, { css: { left: 0 } }, /* @__PURE__ */ React44.createElement(
      Button,
      {
        className: "GDS-scroll-button GDS-scroll-left-button",
        size: "small",
        icon: "interfaceChevronLeft",
        priority: "tertiary",
        hideLabel: true,
        onClick,
        ref
      },
      strings.previous
    ));
  }
);
var ScrollRight = forwardRef24(
  ({ onClick }, ref) => {
    const strings = useThemeStrings();
    return /* @__PURE__ */ React44.createElement(ButtonWrapper, { css: { right: 0 } }, /* @__PURE__ */ React44.createElement(
      Button,
      {
        className: "GDS-scroll-button GDS-scroll-right-button",
        size: "small",
        icon: "interfaceChevronRight",
        priority: "tertiary",
        hideLabel: true,
        onClick,
        ref
      },
      strings.next
    ));
  }
);

// src/components/tabs/tablist-context.tsx
import React45, { createContext as createContext2, useContext as useContext2 } from "react";
var TabListContext = createContext2(null);
var useTablistContext = () => {
  const tabListContext = useContext2(TabListContext);
  if (!tabListContext) {
    throw new Error(
      "tabListContext has to be used within <TabListContext.Provider>"
    );
  }
  return tabListContext;
};
var TabListContextProvider = ({ tabListElements, children }) => /* @__PURE__ */ React45.createElement(TabListContext.Provider, { value: tabListElements }, children);

// src/components/tabs/tab-list.tsx
var BaseTablist = styled(RadixTabsPrimitive2.List, {
  display: "flex",
  gap: "$half",
  overflowX: "auto",
  scrollBehavior: "smooth",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
    width: "0px",
    background: "transparent"
  },
  variants: {
    tabDistribution: {
      distributeEvenly: {
        justifyContent: "stretch",
        "> .GDS-tab": {
          flex: "1 0 auto"
        }
      },
      hugContents: {
        justifyContent: "flex-start"
      }
    }
  }
});
var TabList = forwardRef25(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      divider,
      loop = false,
      tabDistribution = "distributeEvenly"
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "divider",
      "loop",
      "tabDistribution"
    ]);
    const responsiveTabDistribution = useResponsiveProp(tabDistribution);
    const responsiveDivider = useResponsiveProp(divider);
    const {
      scrollLeft,
      scrollRight,
      tabsList,
      showScrollLeft,
      showScrollRight
    } = useTabsScroll();
    const composedRefs = useComposedRefs(
      ref,
      tabsList
    );
    const tabListWrapperRef = React46.useRef(null);
    const scrollLeftButtonRef = React46.useRef(null);
    const scrollRightButtonRef = React46.useRef(null);
    const tabListElements = {
      tabListWrapper: tabListWrapperRef.current,
      scrollLeftButton: scrollLeftButtonRef.current,
      scrollRightButton: scrollRightButtonRef.current
    };
    return /* @__PURE__ */ React46.createElement(TabListContextProvider, { tabListElements }, /* @__PURE__ */ React46.createElement(Box, { css: css2 }, /* @__PURE__ */ React46.createElement(ScrollableWrapper, null, showScrollLeft && /* @__PURE__ */ React46.createElement(
      ScrollLeft,
      {
        ref: scrollLeftButtonRef,
        onClick: () => scrollLeft()
      }
    ), /* @__PURE__ */ React46.createElement(
      ScrollableItemsWrapper,
      {
        className: "GDS-tab-list-wrapper",
        ref: tabListWrapperRef,
        css: __spreadValues({}, responsiveDivider && {
          borderBlockEnd: "$borderWidths$thin solid $onSurfaceBorderSubdued"
        })
      },
      /* @__PURE__ */ React46.createElement(
        BaseTablist,
        __spreadValues({
          ref: composedRefs,
          className: [`GDS-tab-list`, className].join(" "),
          tabDistribution: responsiveTabDistribution,
          loop
        }, props),
        children
      )
    ), showScrollRight && /* @__PURE__ */ React46.createElement(
      ScrollRight,
      {
        ref: scrollRightButtonRef,
        onClick: () => scrollRight()
      }
    ))));
  }
);

// src/components/tabs/tab.tsx
import React47, { forwardRef as forwardRef26, useRef as useRef6, useMemo as useMemo4 } from "react";
import * as RadixTabsPrimitive3 from "@radix-ui/react-tabs";

// src/components/tabs/use-tab-element-is-in-view.tsx
var useTabElementIsInView = () => {
  const { tabListWrapper, scrollLeftButton, scrollRightButton } = useTablistContext();
  const tabScrollOptions = {
    behavior: "smooth",
    block: "nearest",
    inline: "center"
  };
  const elementIsInView = (tabElement) => {
    var _a;
    const scrollButtonWidth = (_a = scrollLeftButton || scrollRightButton) == null ? void 0 : _a.getBoundingClientRect().width;
    let leftOffset;
    let tablistWrapperWidth;
    const leftEdge = tabListWrapper == null ? void 0 : tabListWrapper.getBoundingClientRect();
    if (scrollLeftButton && scrollButtonWidth) {
      leftOffset = leftEdge.left + scrollButtonWidth;
    } else {
      leftOffset = leftEdge.left;
    }
    if (scrollRightButton && tabListWrapper && scrollButtonWidth) {
      tablistWrapperWidth = tabListWrapper.offsetWidth - scrollButtonWidth;
    } else {
      tablistWrapperWidth = tabListWrapper == null ? void 0 : tabListWrapper.offsetWidth;
    }
    const { left, right } = tabElement.current.getBoundingClientRect();
    return left >= leftOffset && right <= tablistWrapperWidth;
  };
  return {
    elementIsInView,
    tabScrollOptions
  };
};

// src/components/tabs/tab.tsx
var tabStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "$onSurfaceTextSubdued",
  padding: "$threeQuarters $half",
  border: "none",
  borderBottomStyle: "solid",
  borderBottomColor: "transparent",
  borderBottomWidth: "$borderWidths$thick",
  backgroundColor: "$surfaceBackgroundPrimary",
  cursor: "pointer",
  '&[aria-current="page"], &[data-state="active"], &.active': {
    color: "$interactiveActionPrimary",
    borderBottomColor: "$interactiveActionPrimary"
  },
  "&:hover": {
    color: "$interactiveActionHovered"
  },
  '&[class*="GDS"]:focus': {
    outlineOffset: "-$space$half"
  },
  typography: "$buttonTwo"
};
var BaseTab = styled(RadixTabsPrimitive3.Trigger, __spreadValues({}, tabStyles));
var TabIconLabelWrapper = styled("span", {
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "$half"
});
var Tab = forwardRef26(
  (_a, ref) => {
    var _b = _a, { children, className, css: css2, icon, iconLabel, width } = _b, props = __objRest(_b, ["children", "className", "css", "icon", "iconLabel", "width"]);
    const internalRef = useRef6(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    const tabWidth = useResponsiveProp(width);
    const tabIcon = useResponsiveProp(icon);
    const { elementIsInView, tabScrollOptions } = useTabElementIsInView();
    const { scrollLeftButton, scrollRightButton } = useTablistContext();
    const scrollElementIfNotInView = useMemo4(
      () => () => {
        if (!elementIsInView(internalRef) && (scrollLeftButton || scrollRightButton)) {
          internalRef.current.scrollIntoView(tabScrollOptions);
        }
      },
      [elementIsInView, tabScrollOptions, scrollLeftButton, scrollRightButton]
    );
    return /* @__PURE__ */ React47.createElement(
      BaseTab,
      __spreadValues({
        className: [`GDS-tab`, className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), width && {
          width: `${tabWidth}`
        }),
        ref: composedRefs,
        onFocus: () => scrollElementIfNotInView()
      }, props),
      /* @__PURE__ */ React47.createElement(TabIconLabelWrapper, null, tabIcon && /* @__PURE__ */ React47.createElement(Icon, { icon: tabIcon, label: iconLabel }), children)
    );
  }
);

// src/components/tabs/tab-panel.tsx
import React48, { forwardRef as forwardRef27 } from "react";
import * as RadixTabsPrimitive4 from "@radix-ui/react-tabs";
var BaseTabpanel = styled(RadixTabsPrimitive4.Content, {
  typography: "$bodyOne",
  color: "$onSurfaceTextPrimary",
  padding: "$threeQuarters $half",
  '&:focus, &[class*="GDS"]:focus': {
    boxShadow: "none",
    outline: "none"
  },
  '&[class*="GDS"]:focus-visible, &:focus-visible': __spreadValues({}, focusOutlineInner)
});
var TabPanel = forwardRef27(
  (_a, ref) => {
    var _b = _a, { children, className, css: css2, value } = _b, props = __objRest(_b, ["children", "className", "css", "value"]);
    return /* @__PURE__ */ React48.createElement(
      BaseTabpanel,
      __spreadValues({
        className: [`GDS-tab-panel`, className].join(" "),
        value,
        css: css2,
        ref
      }, props),
      children
    );
  }
);

// src/components/tabs/tabs.tsx
var GDSTabsPrimitive = RadixTabsPrimitive5;
var Tabs = {
  Root: TabsRoot,
  Tab,
  TabList,
  TabPanel
};
Tabs.Root.displayName = "Tabs.Root";
Tabs.Tab.displayName = "Tabs.Tab";
Tabs.TabList.displayName = "Tabs.TabList";
Tabs.TabPanel.displayName = "Tabs.TabPanel";

// src/components/scrollable/scrollable.tsx
import React49, { forwardRef as forwardRef28 } from "react";
var ScrollableWrapper2 = styled("div", {
  overflow: "hidden",
  '&:focus, &[class*="GDS"]:focus': {
    boxShadow: "none",
    outline: "none"
  },
  '&:focus-visible, &[class*="GDS"]:focus-visible': __spreadValues({}, focusOutlineOuter),
  variants: {
    orientation: {
      vertical: {
        overflowY: "auto"
      },
      horizontal: {
        overflowX: "auto"
      }
    }
  }
});
var Scrollable = forwardRef28(
  (_a, ref) => {
    var _b = _a, {
      children,
      orientation = "vertical",
      css: css2,
      width,
      height,
      className
    } = _b, props = __objRest(_b, [
      "children",
      "orientation",
      "css",
      "width",
      "height",
      "className"
    ]);
    const responsiveOrientation = useResponsiveProp(orientation);
    const responsiveHeight = useResponsiveProp(height);
    const responsiveWidth = useResponsiveProp(width);
    return /* @__PURE__ */ React49.createElement(
      ScrollableWrapper2,
      __spreadValues({
        className: ["GDS-scrollable", className].join(" "),
        ref,
        css: __spreadValues(__spreadValues(__spreadValues({}, css2), width && { width: `${responsiveWidth}` }), height && { height: `${responsiveHeight}` }),
        orientation: responsiveOrientation,
        tabIndex: 0
      }, props),
      children
    );
  }
);
Scrollable.displayName = "Scrollable";

// src/components/nav-list/nav-list.tsx
import React52, { forwardRef as forwardRef31 } from "react";

// src/components/nav-list/nav-link.tsx
import React50, {
  forwardRef as forwardRef29,
  useRef as useRef7,
  useMemo as useMemo5
} from "react";
var BaseNavLink = styled("a", __spreadValues({}, tabStyles));
var NavItem = styled("li", {
  listStyle: "none"
});
var Link = forwardRef29(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      href,
      icon,
      iconLabel,
      target,
      width
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "href",
      "icon",
      "iconLabel",
      "target",
      "width"
    ]);
    const internalRef = useRef7(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    const tabWidth = useResponsiveProp(width);
    const tabIcon = useResponsiveProp(icon);
    const { elementIsInView, tabScrollOptions } = useTabElementIsInView();
    const { scrollLeftButton, scrollRightButton } = useTablistContext();
    const scrollElementIfNotInView = useMemo5(
      () => () => {
        if (!elementIsInView(internalRef) && (scrollLeftButton || scrollRightButton)) {
          internalRef.current.scrollIntoView(tabScrollOptions);
        }
      },
      [elementIsInView, tabScrollOptions, scrollLeftButton, scrollRightButton]
    );
    return /* @__PURE__ */ React50.createElement(
      NavItem,
      {
        className: [`GDS-nav-item`, className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), width && {
          width: `${tabWidth}`
        })
      },
      /* @__PURE__ */ React50.createElement(
        BaseNavLink,
        __spreadValues({
          className: "GDS-nav-link",
          href,
          target,
          ref: composedRefs,
          onFocus: () => scrollElementIfNotInView()
        }, props),
        /* @__PURE__ */ React50.createElement(TabIconLabelWrapper, null, tabIcon && /* @__PURE__ */ React50.createElement(Icon, { icon: tabIcon, label: iconLabel }), children)
      )
    );
  }
);

// src/components/nav-list/router-link.tsx
import React51, { forwardRef as forwardRef30, useRef as useRef8, useMemo as useMemo6 } from "react";
import { NavLink } from "@leagueplatform/routing";
var BaseRouterLink = styled(NavLink, __spreadValues({}, tabStyles));
var RouterLink = forwardRef30(
  (_a, ref) => {
    var _b = _a, { children, className, css: css2, icon, iconLabel, id, path, width } = _b, props = __objRest(_b, ["children", "className", "css", "icon", "iconLabel", "id", "path", "width"]);
    const internalRef = useRef8(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    const tabWidth = useResponsiveProp(width);
    const tabIcon = useResponsiveProp(icon);
    const { elementIsInView, tabScrollOptions } = useTabElementIsInView();
    const { scrollLeftButton, scrollRightButton } = useTablistContext();
    const scrollElementIfNotInView = useMemo6(
      () => () => {
        if (!elementIsInView(internalRef) && (scrollLeftButton || scrollRightButton)) {
          internalRef.current.scrollIntoView(tabScrollOptions);
        }
      },
      [elementIsInView, tabScrollOptions, scrollLeftButton, scrollRightButton]
    );
    return /* @__PURE__ */ React51.createElement(
      NavItem,
      {
        className: [`GDS-nav-item`, className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), width && {
          width: `${tabWidth}`
        })
      },
      /* @__PURE__ */ React51.createElement(
        BaseRouterLink,
        __spreadValues({
          className: "GDS-nav-router-link",
          id,
          to: path,
          ref: composedRefs,
          onFocus: () => scrollElementIfNotInView()
        }, props),
        /* @__PURE__ */ React51.createElement(TabIconLabelWrapper, null, tabIcon && /* @__PURE__ */ React51.createElement(Icon, { icon: tabIcon, label: iconLabel }), children)
      )
    );
  }
);

// src/components/nav-list/nav-list.tsx
var BaseNav = styled("nav", {
  overflowX: "auto",
  scrollBehavior: "smooth",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
    width: "0px",
    background: "transparent"
  }
});
var BaseNavList = styled("ul", {
  display: "flex",
  gap: "$half",
  margin: 0,
  padding: 0,
  variants: {
    tabDistribution: {
      distributeEvenly: {
        justifyContent: "stretch",
        "> .GDS-nav-item": {
          flex: "1 0 auto"
        }
      },
      hugContents: {
        justifyContent: "flex-start"
      }
    }
  }
});
var List2 = forwardRef31(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      divider,
      tabDistribution = "distributeEvenly",
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "divider",
      "tabDistribution",
      "aria-label",
      "aria-labelledby"
    ]);
    const responsiveTabDistribution = useResponsiveProp(tabDistribution);
    const responsiveDivider = useResponsiveProp(divider);
    const {
      scrollLeft,
      scrollRight,
      tabsList,
      showScrollLeft,
      showScrollRight
    } = useTabsScroll();
    const composedRefs = useComposedRefs(
      ref,
      tabsList
    );
    const tabListWrapperRef = React52.useRef(null);
    const scrollLeftButtonRef = React52.useRef(null);
    const scrollRightButtonRef = React52.useRef(null);
    const tabListElements = {
      tabListWrapper: tabListWrapperRef.current,
      scrollLeftButton: scrollLeftButtonRef.current,
      scrollRightButton: scrollRightButtonRef.current
    };
    return /* @__PURE__ */ React52.createElement(TabListContextProvider, { tabListElements }, /* @__PURE__ */ React52.createElement(ScrollableWrapper, null, showScrollLeft && /* @__PURE__ */ React52.createElement(
      ScrollLeft,
      {
        ref: scrollLeftButtonRef,
        onClick: () => scrollLeft()
      }
    ), /* @__PURE__ */ React52.createElement(
      ScrollableItemsWrapper,
      {
        ref: tabListWrapperRef,
        className: "GDS-nav-list-wrapper"
      },
      /* @__PURE__ */ React52.createElement(
        BaseNav,
        {
          className: "GDS-nav",
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          ref: composedRefs
        },
        /* @__PURE__ */ React52.createElement(
          BaseNavList,
          __spreadValues({
            className: [`GDS-nav-list`, className].join(" "),
            tabDistribution: responsiveTabDistribution,
            tabIndex: 0,
            css: __spreadValues(__spreadValues({}, css2), responsiveDivider && {
              borderBlockEnd: "$borderWidths$thin solid $onSurfaceBorderSubdued"
            })
          }, props),
          children
        )
      )
    ), showScrollRight && /* @__PURE__ */ React52.createElement(
      ScrollRight,
      {
        ref: scrollRightButtonRef,
        onClick: () => scrollRight()
      }
    )));
  }
);
var NavList = {
  List: List2,
  Link,
  RouterLink
};
NavList.List.displayName = "NavList.List";
NavList.Link.displayName = "NavList.Link";
NavList.RouterLink.displayName = "NavList.RouterLink";

// src/components/forms/form-field/form-field.tsx
import React59, {
  forwardRef as forwardRef33,
  Children as Children3,
  cloneElement as cloneElement2,
  isValidElement as isValidElement6
} from "react";

// src/components/forms/component-generators.tsx
import React58, {
  cloneElement,
  isValidElement as isValidElement5
} from "react";

// src/components/forms/form-field-elements/input-label.tsx
import React54, { forwardRef as forwardRef32, isValidElement as isValidElement3 } from "react";

// src/components/forms/form-field-elements/label-text.tsx
import React53 from "react";
var OptionalFlag = styled("span", {
  typography: "$caption",
  color: "$onSurfaceTextSubdued",
  marginLeft: "$quarter"
});
var LabelText = ({
  children,
  required
}) => {
  const { optional } = useThemeStrings();
  return /* @__PURE__ */ React53.createElement(React53.Fragment, null, children, !required && /* @__PURE__ */ React53.createElement(OptionalFlag, null, `(${optional})`));
};

// src/components/forms/form-field-elements/input-label.tsx
var LabelBase = styled("label", labelLegendStyles);
var InputLabel = forwardRef32(
  (_a, ref) => {
    var _b = _a, {
      htmlFor,
      hideLabel,
      children,
      required,
      tooltip,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "htmlFor",
      "hideLabel",
      "children",
      "required",
      "tooltip",
      "className",
      "css"
    ]);
    const responsiveHideLabel = useResponsiveProp(hideLabel);
    if (responsiveHideLabel)
      return /* @__PURE__ */ React54.createElement(VisuallyHidden, null, /* @__PURE__ */ React54.createElement("label", __spreadValues({ htmlFor, ref }, props), /* @__PURE__ */ React54.createElement(LabelText, { required }, children)));
    return /* @__PURE__ */ React54.createElement(
      LabelBase,
      __spreadValues({
        htmlFor,
        ref,
        className: ["GDS-input-label", className].join(" "),
        css: css2
      }, props),
      /* @__PURE__ */ React54.createElement(LabelText, { required }, children),
      isValidElement3(tooltip) ? tooltip : null
    );
  }
);
InputLabel.displayName = "InputLabel";

// src/components/forms/form-field-elements/fieldset-legend.tsx
import React55, { isValidElement as isValidElement4 } from "react";
var LegendBase = styled("legend", labelLegendStyles);
var FieldsetLegend = (_a) => {
  var _b = _a, {
    hideLegend,
    children,
    required,
    tooltip,
    className,
    css: css2
  } = _b, props = __objRest(_b, [
    "hideLegend",
    "children",
    "required",
    "tooltip",
    "className",
    "css"
  ]);
  const responsiveHideLegend = useResponsiveProp(hideLegend);
  if (responsiveHideLegend)
    return /* @__PURE__ */ React55.createElement(VisuallyHidden, null, /* @__PURE__ */ React55.createElement("legend", __spreadValues({}, props), /* @__PURE__ */ React55.createElement(LabelText, { required }, children)));
  return /* @__PURE__ */ React55.createElement(
    LegendBase,
    __spreadValues({
      className: ["GDS-fieldset-legend", className].join(" "),
      css: css2
    }, props),
    /* @__PURE__ */ React55.createElement(LabelText, { required }, children),
    isValidElement4(tooltip) ? tooltip : null
  );
};
FieldsetLegend.displayName = "FieldsetLegend";

// src/components/forms/form-field-elements/input-hint.tsx
import React56 from "react";
var HintBase = styled("span", {
  display: "block",
  margin: 0,
  typography: "$caption",
  color: "$onSurfaceTextSubdued"
});
var InputHint = (_a) => {
  var _b = _a, {
    children,
    className,
    css: css2,
    id
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "css",
    "id"
  ]);
  return /* @__PURE__ */ React56.createElement(
    HintBase,
    __spreadValues({
      className: ["GDS-input-hint", className].join(" "),
      id,
      css: css2
    }, props),
    children
  );
};
InputHint.displayName = "InputHint";

// src/components/forms/form-field-elements/input-status-message.tsx
import React57 from "react";
var StatusMessageWrapper = styled("div", {
  marginTop: "$quarter",
  display: "flex",
  alignItems: "center"
});
var StatusMessageBase = styled("p", {
  margin: 0,
  typography: "$caption",
  variants: {
    status: {
      success: { color: "$onSurfaceTextSuccess" },
      warning: { color: "$onSurfaceTextWarning" },
      error: { color: "$onSurfaceTextCritical" }
    }
  }
});
var icons = {
  success: "tinyValidationCheck",
  warning: "tinyAlert",
  error: "tinyClear"
};
var tints = {
  success: "$inputBorderSuccess",
  warning: "$inputBorderWarning",
  error: "$inputBorderCritical"
};
var InputStatusMessage = (_a) => {
  var _b = _a, {
    children,
    className,
    css: css2,
    hideIcon = false,
    inputStatus,
    statusIconLabel
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "css",
    "hideIcon",
    "inputStatus",
    "statusIconLabel"
  ]);
  return /* @__PURE__ */ React57.createElement(
    StatusMessageWrapper,
    __spreadValues({
      className: ["GDS-input-status-message-wrapper", className].join(" "),
      css: css2
    }, props),
    !hideIcon && inputStatus && /* @__PURE__ */ React57.createElement(
      Icon,
      {
        icon: icons[inputStatus],
        tint: tints[inputStatus],
        size: 10,
        label: statusIconLabel,
        css: { marginRight: "$quarter" }
      }
    ),
    /* @__PURE__ */ React57.createElement(
      StatusMessageBase,
      {
        className: ["GDS-input-status-message", className].join(" "),
        status: inputStatus
      },
      children
    )
  );
};
InputStatusMessage.displayName = "InputStatusMessage";

// src/components/forms/component-generators.tsx
var generateInputLabel = ({
  label,
  htmlFor,
  required,
  hideLabel,
  tooltip
}) => {
  if (isReactElement(label)) {
    return cloneElement(label, {
      htmlFor,
      required,
      hideLabel,
      as: "label"
    });
  }
  return /* @__PURE__ */ React58.createElement(
    InputLabel,
    {
      htmlFor,
      required,
      hideLabel,
      tooltip
    },
    label
  );
};
var generateInputHint = ({
  hint,
  hintId,
  css: css2
}) => {
  if (isReactElement(hint)) {
    return cloneElement(hint, {
      id: hintId
    });
  }
  return /* @__PURE__ */ React58.createElement(InputHint, { id: hintId, css: css2 }, hint);
};
var generateLegend = ({
  legend,
  required,
  hideLegend,
  tooltip
}) => {
  if (isReactElement(legend)) {
    return cloneElement(legend, {
      required,
      hideLegend,
      as: "legend"
    });
  }
  return /* @__PURE__ */ React58.createElement(
    FieldsetLegend,
    {
      required,
      hideLegend,
      tooltip
    },
    legend
  );
};
var generateInputStatusMessage = ({
  css: css2,
  id,
  inputStatus,
  statusIconLabel,
  statusMessage
}) => {
  if (isValidElement5(statusMessage)) {
    if (statusMessage.type === InputStatusMessage) {
      return cloneElement(statusMessage, {
        css: css2,
        id,
        inputStatus,
        statusIconLabel
      });
    }
    return cloneElement(statusMessage, {
      css: css2,
      id
    });
  }
  return /* @__PURE__ */ React58.createElement(
    InputStatusMessage,
    {
      id,
      inputStatus,
      statusIconLabel,
      css: css2
    },
    statusMessage
  );
};

// src/components/forms/form-field/form-field.tsx
var FormFieldBase = styled("div", { width: "100%" });
var FormField = forwardRef33(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      hideLabel = false,
      hint,
      id,
      inputStatus,
      label,
      name,
      required = true,
      statusIconLabel,
      statusMessage,
      tooltip
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "hideLabel",
      "hint",
      "id",
      "inputStatus",
      "label",
      "name",
      "required",
      "statusIconLabel",
      "statusMessage",
      "tooltip"
    ]);
    const statusMessageId = `${id}-status-message`;
    const hintId = `${id}-hint`;
    const ariaDescribedBy = [];
    if (statusMessage)
      ariaDescribedBy.push(statusMessageId);
    if (hint)
      ariaDescribedBy.push(hintId);
    if (Children3.count(children) > 1)
      console.warn(
        "More than one child detected. FormField is a wrapper for a single input. For multiple inputs, use Fieldset."
      );
    return /* @__PURE__ */ React59.createElement(
      FormFieldBase,
      __spreadValues({
        className: ["GDS-form-field", className].join(" "),
        css: css2,
        ref
      }, props),
      label && generateInputLabel({
        label,
        htmlFor: id,
        required,
        hideLabel,
        tooltip
      }),
      hint && generateInputHint({
        hint,
        hintId,
        css: { marginBottom: "$quarter" }
      }),
      /* @__PURE__ */ React59.createElement("div", { className: "GDS-input-wrapper" }, Children3.map(children, (child) => {
        var _a2;
        if (isValidElement6(child)) {
          if ((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2["aria-describedby"])
            ariaDescribedBy.push(child.props["aria-describedby"]);
          return cloneElement2(child, __spreadValues(__spreadValues({
            id,
            name
          }, ariaDescribedBy.length > 0 && {
            "aria-describedby": ariaDescribedBy.join(" ")
          }), isReactElement(child) && { inputStatus }));
        }
        return child;
      })),
      inputStatus && statusMessage && generateInputStatusMessage({
        id: statusMessageId,
        inputStatus,
        statusIconLabel,
        statusMessage
      })
    );
  }
);
FormField.displayName = "FormField";

// src/components/forms/field-set/field-set.tsx
import React60 from "react";
var FieldsetBase = styled("fieldset", {
  border: 0,
  margin: 0,
  padding: 0,
  width: "100%"
});
var Fieldset = (_a) => {
  var _b = _a, {
    children,
    className,
    css: css2,
    hideLegend = false,
    hint,
    id,
    inputStatus,
    legend,
    required = true,
    statusMessage,
    tooltip
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "css",
    "hideLegend",
    "hint",
    "id",
    "inputStatus",
    "legend",
    "required",
    "statusMessage",
    "tooltip"
  ]);
  const statusMessageId = id ? `${id}-status-message` : "";
  const hintId = id ? `${id}-hint` : "";
  if ((hint || statusMessage) && !id)
    console.warn(
      "To use hint or statusMessage, you must also pass the id to Fieldset."
    );
  return /* @__PURE__ */ React60.createElement(
    FieldsetBase,
    __spreadValues(__spreadValues({
      className: ["GDS-fieldset", className].join(" "),
      css: css2
    }, id && { "aria-describedby": `${statusMessageId} ${hintId}` }), props),
    legend && generateLegend({
      legend,
      hideLegend,
      required,
      tooltip
    }),
    hint && id && generateInputHint({ hint, hintId, css: { marginBottom: "$quarter" } }),
    children,
    inputStatus && statusMessage && id && /* @__PURE__ */ React60.createElement(InputStatusMessage, { id: statusMessageId, inputStatus }, statusMessage)
  );
};
Fieldset.displayName = "Fieldset";

// src/components/forms/base-input/base-input.tsx
import React63, { forwardRef as forwardRef35 } from "react";

// src/components/forms/input-elements/add-on.tsx
import React61, { forwardRef as forwardRef34 } from "react";
var StyledAddOn = styled("div", {
  typography: "$bodyTwo",
  color: "$onSurfaceTextPrimary",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: "0",
  paddingTop: "$threeQuarters",
  paddingBottom: "$threeQuarters",
  backgroundColor: "$surfaceBackgroundSecondary",
  border: "$borderWidths$thin solid $inputBorderDefault",
  variants: {
    position: {
      start: {
        borderTopLeftRadius: "$medium",
        borderBottomLeftRadius: "$medium",
        borderRight: "none",
        paddingLeft: "$threeQuarters",
        paddingRight: "$half"
      },
      end: {
        borderTopRightRadius: "$medium",
        borderBottomRightRadius: "$medium",
        borderLeft: "none",
        paddingLeft: "$half",
        paddingRight: "$threeQuarters"
      }
    }
  }
});
var addonPositionByString = {
  start: "Start",
  end: "End"
};
var getStringForClassName = (position) => addonPositionByString[position];
var AddOn = forwardRef34(
  (_a, ref) => {
    var _b = _a, { position, icon, iconLabel, children, css: css2 } = _b, props = __objRest(_b, ["position", "icon", "iconLabel", "children", "css"]);
    return /* @__PURE__ */ React61.createElement(
      StyledAddOn,
      __spreadValues({
        className: `GDS-input-add-on GDS-input-addon-${getStringForClassName(
          position
        )}`,
        position,
        css: css2,
        ref
      }, props),
      icon ? /* @__PURE__ */ React61.createElement(Icon, { icon, label: iconLabel }) : children
    );
  }
);

// src/components/forms/input-elements/affix-content.tsx
import React62 from "react";
var AffixWrapper = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  typography: "$bodyTwo",
  marginBlockEnd: "0",
  color: "$onSurfaceTextPrimary"
});
var AffixContent = (_a) => {
  var _b = _a, {
    position,
    children,
    className,
    css: css2
  } = _b, props = __objRest(_b, [
    "position",
    "children",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ React62.createElement(
    AffixWrapper,
    __spreadValues({
      className: [
        "GDS-affix-wrapper",
        `GDS-affix-${position}-content`,
        className
      ].join(" "),
      css: __spreadValues(__spreadValues({}, position === "leading" ? { paddingInlineEnd: "$half" } : { paddingInlineStart: "$half" }), css2)
    }, props),
    typeof children === "string" ? /* @__PURE__ */ React62.createElement("span", null, children) : children
  );
};

// src/components/forms/input-elements/input-elements.tsx
var InputElements = {
  AddOn,
  AffixContent
};
InputElements.AffixContent.displayName = "InputElements.AffixContent";
InputElements.AddOn.displayName = "InputElements.AddOn";

// src/components/forms/input-styles.ts
var inputBorderStyles = {
  border: "$borderWidths$thin solid $interactiveBorderDefault",
  borderStartStartRadius: "$medium",
  borderEndStartRadius: "$medium",
  borderStartEndRadius: "$medium",
  borderEndEndRadius: "$medium"
};
var inputStyles = __spreadProps(__spreadValues({}, inputBorderStyles), {
  padding: "$threeQuarters $one",
  flex: "1 0 auto",
  '&:focus, &[class*="GDS"]:focus': __spreadValues({
    borderColor: "$interactiveFocusInner"
  }, focusOutlineInner)
});
var affixedStyles = {
  "&.GDS-affixed": __spreadProps(__spreadValues({}, inputStyles), {
    "&:hover": {
      borderColor: "$inputBorderHovered",
      backgroundColor: "$inputBackgroundHovered",
      input: {
        borderColor: "$inputBorderHovered",
        backgroundColor: "$inputBackgroundHovered"
      }
    },
    input: {
      border: "none",
      padding: "0"
    },
    '[class*="GDS"]:not(button):focus, &:focus-within:has(button:focus)': {
      outline: "none",
      boxShadow: "none",
      borderColor: "$interactiveBorderDefault"
    },
    "&:focus-within": __spreadValues({
      borderColor: "$interactiveFocusInner"
    }, focusOutlineInner),
    // override nested .GDS-affixed styles when BaseInput is rendered within TextInput or any other wrapper that uses .GDS-affixed styles
    "& .GDS-affixed-base": {
      border: "none",
      padding: "0",
      input: {
        "&:focus": {
          outline: "none",
          boxShadow: "none"
        }
      },
      "&:focus-within, &:focus": {
        borderColor: "$interactiveFocusInner",
        outline: "none",
        boxShadow: "none"
      }
    }
  })
};
var affixedBaseInputStyles = {
  "&.GDS-affixed-base": __spreadProps(__spreadValues({}, inputStyles), {
    "&:hover": {
      borderColor: "$inputBorderHovered",
      backgroundColor: "$inputBackgroundHovered",
      input: {
        borderColor: "$inputBorderHovered",
        backgroundColor: "$inputBackgroundHovered"
      }
    },
    input: {
      border: "none",
      padding: "0"
    },
    '[class*="GDS"]:not(button):focus': {
      outline: "none",
      boxShadow: "none"
    },
    "&:focus-within": __spreadValues({
      borderColor: "$interactiveFocusInner"
    }, focusOutlineInner),
    "&:focus-within:has(button:focus)": {
      outline: "none",
      boxShadow: "none"
    }
  })
};
var disabledInputStyles = {
  backgroundColor: "$inputBackgroundDisabled",
  color: "$onSurfaceTextSubdued",
  borderColor: "$onSurfaceTextSubdued"
};
var readOnlyInputStyles = {
  backgroundColor: "$inputBackgroundDisabled"
};

// src/components/forms/base-input/base-input.tsx
var Input = styled("input", __spreadProps(__spreadValues({}, inputStyles), {
  typography: "$bodyTwo",
  color: "$onSurfaceTextPrimary",
  backgroundColor: "$surfaceBackgroundPrimary",
  transition: "box-shadow $default ease-in-out",
  "&:focus": {
    borderColor: "$interactiveFocusInner"
  },
  "&:placeholder": {
    typography: "$bodyTwo",
    color: "$onSurfaceTextSubdued"
  },
  "&:hover:not(:focus):not([disabled])": {
    borderColor: "$inputBorderHovered",
    backgroundColor: "$inputBackgroundHovered"
  },
  '&:read-only, &[aria-readonly="true"]': __spreadValues({}, readOnlyInputStyles),
  '&:disabled, &[aria-disabled="true"]': __spreadValues({}, disabledInputStyles),
  variants: {
    inputStatus: {
      success: {
        borderColor: "$inputBorderSuccess",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderSuccess"
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderWarning"
        }
      },
      error: {
        borderColor: "$inputBorderCritical",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderCritical"
        }
      }
    }
  }
}));
var BaseInputWrapper = styled("div", __spreadProps(__spreadValues({
  position: "relative",
  display: "inline-flex",
  alignItems: "stretch",
  width: "100%"
}, affixedBaseInputStyles), {
  "&.GDS-readonly-input": __spreadValues({}, readOnlyInputStyles),
  "&.GDS-disabled-input": __spreadValues({}, disabledInputStyles),
  ".GDS-clear-input-button": {
    border: "none",
    backgroundColor: "$inputBackgroundDefault"
  },
  '[class*="GDS"]:focus': __spreadValues({}, focusOutlineInner),
  "&:hover": {
    ".GDS-clear-input-button": {
      color: "$secondaryTextDefault",
      backgroundColor: "$inputBackgroundHovered"
    }
  }
}));
var BaseInput = forwardRef35(
  (_a, ref) => {
    var _b = _a, {
      as: asElement,
      css: css2,
      id,
      name,
      autoComplete,
      required,
      type = "text",
      placeholder,
      inputStatus,
      disabled,
      "aria-disabled": ariaDisabled,
      value,
      ariaDescribedby,
      clearable,
      clearLabel,
      onClear,
      onClick,
      onChange,
      onBlur,
      onFocus,
      readOnly,
      maxLength,
      className
    } = _b, props = __objRest(_b, [
      "as",
      "css",
      "id",
      "name",
      "autoComplete",
      "required",
      "type",
      "placeholder",
      "inputStatus",
      "disabled",
      "aria-disabled",
      "value",
      "ariaDescribedby",
      "clearable",
      "clearLabel",
      "onClear",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "readOnly",
      "maxLength",
      "className"
    ]);
    const stringsMap = useThemeStrings();
    const defaultType = !type && !asElement ? "text" : void 0;
    return /* @__PURE__ */ React63.createElement(
      BaseInputWrapper,
      {
        className: `GDS-base-input-wrapper
        ${clearable ? "GDS-affixed-base" : ""}
        ${disabled && clearable ? "GDS-disabled-input" : ""}
        ${readOnly && clearable ? "GDS-readonly-input" : ""}
        ${inputStatus && clearable ? `GDS-input-status-${inputStatus}` : ""}
        `,
        css: css2
      },
      /* @__PURE__ */ React63.createElement(
        Input,
        __spreadValues(__spreadProps(__spreadValues({
          as: asElement,
          id,
          name,
          type: type || defaultType,
          className: `GDS-base-input ${className || ""}`,
          placeholder,
          required,
          readOnly,
          disabled,
          "aria-disabled": ariaDisabled,
          autoComplete,
          value
        }, inputStatus === "error" && { "aria-invalid": true }), {
          "aria-describedby": ariaDescribedby,
          inputStatus,
          onClick,
          onChange,
          onBlur,
          onFocus,
          maxLength,
          ref
        }), props)
      ),
      clearable && /* @__PURE__ */ React63.createElement(
        InputElements.AffixContent,
        {
          className: "GDS-clear-input",
          position: "trailing"
        },
        /* @__PURE__ */ React63.createElement(
          Button,
          {
            className: "GDS-clear-input-button",
            type: "button",
            icon: "tinyClear",
            hideLabel: true,
            quiet: true,
            priority: "secondary",
            size: "small",
            disabled,
            onClick: onClear
          },
          clearLabel || stringsMap.clear
        )
      )
    );
  }
);
BaseInput.displayName = "BaseInput";

// src/components/forms/text-input/text-input.tsx
import React64, { forwardRef as forwardRef36, useCallback as useCallback6, useRef as useRef9 } from "react";
var TextInputGroup = styled("div", {
  display: "flex",
  '[class*="GDS"]:focus': __spreadValues({}, focusOutlineInner)
});
var TextInputWrapper = styled("div", __spreadProps(__spreadValues({
  position: "relative",
  display: "flex",
  alignItems: "stretch",
  width: "100%"
}, affixedStyles), {
  "> .GDS-base-input-wrapper.GDS-affixed-base": {
    flex: "initial"
  },
  // Styles for input with add ons
  // Border style when input is not the first child, i.e. it has an AddOn at the start
  "&:where(.GDS-text-input-wrapper:not(:first-child)) > .GDS-base-input-wrapper > input": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0"
  },
  // Border style when input is not the last child, i.e. it has an AddOn at the end
  "&:where(.GDS-text-input-wrapper:not(:last-child)) > .GDS-base-input-wrapper > input": {
    borderStartStartRadius: "$medium",
    borderEndStartRadius: "$medium",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0"
  },
  // Border style when input is neither the first nor the last child, i.e. it has an AddOn on each end
  "&:where(.GDS-text-input-wrapper:not(:first-child):not(:last-child)) > .GDS-base-input-wrapper > input": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0"
  },
  // Border style when input has a affixed content and it is not the first child,
  // i.e. it has an AddOn at the start with trailing and/or leading content
  "&:is(.GDS-affixed:not(:first-child))": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0"
  },
  // Border style when input has a affixed content and it is not the last child,
  // i.e. it has an AddOn at the end with trailing and/or leading content
  "&:is(.GDS-affixed:not(:last-child))": {
    borderStartStartRadius: "$medium",
    borderEndStartRadius: "$medium",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0"
  },
  // Border style when input is neither the first nor the last child,
  // i.e. it has an AddOn on each end with trailing and/or leading content
  "&:is(.GDS-affixed:not(:first-child):not(:last-child))": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0",
    flex: "initial"
  },
  "&:is(.GDS-affixed.GDS-input-status-success)": {
    borderColor: "$inputBorderSuccess"
  },
  "&:is(.GDS-affixed.GDS-input-status-warning)": {
    borderColor: "$inputBorderWarning"
  },
  "&:is(.GDS-affixed.GDS-input-status-error)": {
    borderColor: "$inputBorderCritical"
  },
  "&.GDS-readonly-input": __spreadValues({}, readOnlyInputStyles),
  "&.GDS-disabled-input": __spreadProps(__spreadValues({}, disabledInputStyles), {
    // accounting for hover on disabled inputs when .GDS-disabled-input gets nested in TextInput from BaseInput
    "&:hover": {
      ".GDS-disabled-input": {
        backgroundColor: "$inputBackgroundHovered"
      }
    }
  })
}));
var TextInput = forwardRef36(
  (_a, ref) => {
    var _b = _a, {
      id,
      name,
      value,
      placeholder,
      autoComplete,
      disabled,
      readOnly,
      inputStatus,
      ariaDescribedby,
      enterkeyhint,
      clearable,
      onClear,
      clearLabel,
      leadingContent,
      trailingContent,
      addOnStart,
      addOnEnd,
      addOnStartIcon,
      addOnEndIcon,
      addOnStartIconLabel,
      addOnEndIconLabel,
      css: css2
    } = _b, props = __objRest(_b, [
      "id",
      "name",
      "value",
      "placeholder",
      "autoComplete",
      "disabled",
      "readOnly",
      "inputStatus",
      "ariaDescribedby",
      "enterkeyhint",
      "clearable",
      "onClear",
      "clearLabel",
      "leadingContent",
      "trailingContent",
      "addOnStart",
      "addOnEnd",
      "addOnStartIcon",
      "addOnEndIcon",
      "addOnStartIconLabel",
      "addOnEndIconLabel",
      "css"
    ]);
    const textInputGroup = useRef9(null);
    const isAffixed = leadingContent || trailingContent || clearable;
    const setInputFocus = useCallback6(() => {
      var _a2, _b2;
      (_b2 = (_a2 = textInputGroup.current) == null ? void 0 : _a2.querySelector("input")) == null ? void 0 : _b2.focus();
    }, []);
    return /* @__PURE__ */ React64.createElement(TextInputGroup, { className: "GDS-text-input-group", css: css2 }, typeof addOnStart === "string" ? /* @__PURE__ */ React64.createElement(InputElements.AddOn, { position: "start" }, addOnStart) : addOnStart, addOnStartIcon && /* @__PURE__ */ React64.createElement(
      InputElements.AddOn,
      {
        position: "start",
        icon: addOnStartIcon,
        iconLabel: addOnStartIconLabel
      }
    ), /* @__PURE__ */ React64.createElement(
      TextInputWrapper,
      {
        className: `GDS-text-input-wrapper
          ${isAffixed ? "GDS-affixed" : ""}
          ${disabled && clearable ? "GDS-disabled-input" : ""}
          ${readOnly && clearable ? "GDS-readonly-input" : ""}
          ${isAffixed && inputStatus ? `GDS-input-status-${inputStatus}` : ""}`,
        onClick: setInputFocus,
        ref: textInputGroup
      },
      leadingContent && /* @__PURE__ */ React64.createElement(InputElements.AffixContent, { position: "leading" }, leadingContent),
      /* @__PURE__ */ React64.createElement(
        BaseInput,
        __spreadValues({
          type: "text",
          id,
          name,
          value,
          placeholder,
          autoComplete,
          disabled,
          inputStatus,
          ariaDescribedby,
          clearable,
          clearLabel,
          onClear,
          enterkeyhint,
          readOnly,
          ref
        }, props)
      ),
      trailingContent && /* @__PURE__ */ React64.createElement(InputElements.AffixContent, { position: "trailing" }, trailingContent)
    ), typeof addOnEnd === "string" ? /* @__PURE__ */ React64.createElement(InputElements.AddOn, { position: "end" }, addOnEnd) : addOnEnd, addOnEndIcon && /* @__PURE__ */ React64.createElement(
      InputElements.AddOn,
      {
        position: "end",
        icon: addOnEndIcon,
        iconLabel: addOnEndIconLabel
      }
    ));
  }
);
TextInput.displayName = "TextInput";

// src/components/forms/selectable/checkbox/checkbox.tsx
import React67, { forwardRef as forwardRef38, isValidElement as isValidElement7 } from "react";

// src/components/forms/selectable/checkbox/checkbox-indicator.tsx
import React66, { forwardRef as forwardRef37, useRef as useRef10, useEffect as useEffect6 } from "react";

// src/components/forms/selectable/selectable-loader.tsx
import React65 from "react";
var BaseSelectableLoader = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderDefault",
  backgroundColor: "$inputBackgroundDefault",
  width: "$oneAndHalf",
  height: "$oneAndHalf",
  position: "absolute",
  top: "0",
  bottom: "0",
  right: "0",
  pointerEvents: "none"
});
var SelectableLoaderWrapper = styled("span", {
  display: "flex",
  position: "relative"
});
var SelectableLoader = (_a) => {
  var _b = _a, {
    inputType,
    loading,
    css: css2
  } = _b, props = __objRest(_b, [
    "inputType",
    "loading",
    "css"
  ]);
  return /* @__PURE__ */ React65.createElement(
    BaseSelectableLoader,
    __spreadValues({
      className: "GDS-selectable-loader",
      css: {
        borderRadius: inputType === "radio" ? "$circle" : "$medium"
      }
    }, props),
    /* @__PURE__ */ React65.createElement(Spinner, { loading, size: "$one" })
  );
};

// src/components/forms/selectable/checkbox/checkbox-indicator.tsx
var getCheckmarkUri = (color) => `"data:image/svg+xml;charset=UTF-8,%3csvg id='interfaceCheckmark' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='${encodeURIComponent(
  color
)}' fill-rule='evenodd' d='M19.507 6.448a.75.75 0 0 1 .045 1.06l-9.187 10a.75.75 0 0 1-1.105 0l-4.812-5.239a.75.75 0 1 1 1.104-1.014l4.26 4.636 8.636-9.398a.75.75 0 0 1 1.06-.045Z' clip-rule='evenodd'/%3e%3c/svg%3e"`;
var getDashUri = (color) => `"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 2'%3e%3cpath fill='${encodeURIComponent(
  color
)}' fill-rule='evenodd' d='M0 .75A.75.75 0 0 1 .75 0h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 .75Z' clip-rule='evenodd'/%3e%3c/svg%3e"`;
var disabledStyles = {
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$inputBorderDisabled",
  backgroundColor: "$inputBackgroundDisabled"
};
var CheckboxBase = styled("input", {
  appearance: "none",
  margin: 0,
  height: "$oneAndHalf",
  width: "$oneAndHalf",
  minWidth: "$oneAndHalf",
  backgroundColor: "$interactiveIconDefault",
  borderColor: "$onSurfaceBorderDefault",
  borderStyle: "solid",
  borderWidth: "$thin",
  borderRadius: "$medium",
  transition: "background $defaultTime ease-in-out, border $defaultTime ease-in-out",
  "&:checked, &:indeterminate": {
    borderColor: "$interactiveActionPrimary",
    backgroundColor: "$interactiveActionPrimary",
    "&:before": {
      content: "",
      height: "100%"
    }
  },
  "&:indeterminate": {
    paddingLeft: "3px",
    paddingRight: "3px"
  },
  '&:disabled,&[aria-disabled="true"]': __spreadProps(__spreadValues({}, disabledStyles), {
    pointerEvents: "none"
  }),
  ' &[aria-readonly="true"]': disabledStyles,
  "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
    borderColor: "$interactiveActionPrimary",
    backgroundColor: "$interactiveActionPrimary",
    "& svg": {
      color: "$onSurfaceTextReversed"
    }
  },
  variants: {
    inputStatus: {
      error: {
        borderColor: "$inputBorderCritical",
        "&:checked:not([disabled]), &:indeterminate:not([disabled])": {
          backgroundColor: "$inputBorderCritical",
          borderColor: "$inputBorderCritical"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          "& svg": {
            color: "$inputBorderCritical"
          }
        },
        "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          backgroundColor: "$inputBorderCritical",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:checked:not([disabled]), &:indeterminate:not([disabled])": {
          backgroundColor: "$inputBorderWarning",
          borderColor: "$inputBorderWarning"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          "& svg": {
            color: "$inputBorderWarning"
          }
        },
        "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          backgroundColor: "$inputBorderWarning",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      success: {
        borderColor: "$inputBorderSuccess",
        "&:checked:not([disabled]), &:indeterminate:not([disabled])": {
          borderColor: "$inputBorderSuccess",
          backgroundColor: "$inputBorderSuccess"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          "& svg": {
            color: "$inputBorderSuccess"
          }
        },
        "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          backgroundColor: "$inputBorderSuccess",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      }
    }
  }
});
var CheckboxIndicator = forwardRef37(
  (_a, ref) => {
    var _b = _a, {
      id,
      name,
      indeterminate = false,
      inputStatus,
      loading,
      value,
      checked,
      disabled,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "aria-readonly": ariaReadonly,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className = "",
      css: css2
    } = _b, props = __objRest(_b, [
      "id",
      "name",
      "indeterminate",
      "inputStatus",
      "loading",
      "value",
      "checked",
      "disabled",
      "aria-disabled",
      "aria-describedby",
      "aria-readonly",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "css"
    ]);
    const inputRef = useRef10(null);
    useEffect6(() => {
      if (inputRef.current) {
        inputRef.current.indeterminate = indeterminate;
      }
    }, [inputRef, indeterminate]);
    const theme2 = useTheme();
    return /* @__PURE__ */ React66.createElement(SelectableLoaderWrapper, null, /* @__PURE__ */ React66.createElement(
      CheckboxBase,
      __spreadValues(__spreadProps(__spreadValues({
        type: "checkbox",
        id,
        value,
        name,
        checked,
        className: ["GDS-checkbox-input", className].join(" "),
        inputStatus
      }, inputStatus === "error" && { "aria-invalid": true }), {
        disabled,
        "aria-disabled": ariaDisabled,
        "aria-describedby": ariaDescribedby,
        "aria-readonly": ariaReadonly,
        onClick,
        onChange,
        onBlur,
        onFocus,
        ref: ref || inputRef,
        css: __spreadProps(__spreadValues({}, css2), {
          "&:checked": {
            "&:before": {
              content: `url(${getCheckmarkUri(
                theme2.colors.interactiveIconDefault.value
              )})`
            }
          },
          '&:checked:disabled, &:checked[aria-disabled="true"]': {
            "&:before": {
              content: `url(${getCheckmarkUri(
                theme2.colors.onSurfaceTextSubdued.value
              )})`
            }
          },
          '&:checked[aria-readonly="true"]': {
            "&:before": {
              content: `url(${getCheckmarkUri(
                theme2.colors.onSurfaceTextPrimary.value
              )})`
            }
          },
          "&:indeterminate": {
            "&:before": {
              content: `url(${getDashUri(
                theme2.colors.interactiveIconDefault.value
              )})`
            }
          },
          '&:indeterminate:disabled, &:indeterminate[aria-disabled="true"]': {
            "&:before": {
              content: `url(${getDashUri(
                theme2.colors.onSurfaceTextSubdued.value
              )})`
            }
          },
          '&:indeterminate[aria-readonly="true"]': {
            "&:before": {
              content: `url(${getDashUri(
                theme2.colors.onSurfaceTextPrimary.value
              )})`
            }
          }
        })
      }), props)
    ), loading && /* @__PURE__ */ React66.createElement(SelectableLoader, { inputType: "checkbox", loading }));
  }
);
CheckboxIndicator.displayName = "CheckboxIndicator";

// src/components/forms/selectable/checkbox/checkbox.tsx
var LabelText2 = styled("span", {
  typography: "$bodyOne",
  variants: {
    disabled: {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    },
    "aria-disabled": {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    }
  }
});
var labelPadding = "$half";
var CheckboxLabel = styled("label", {
  gap: "$half",
  borderRadius: "$medium",
  padding: labelPadding,
  "&:hover": {
    backgroundColor: "$inputBackgroundHovered"
  },
  "&:active": {
    backgroundColor: "$inputBackgroundPressed"
  },
  variants: {
    layout: {
      inline: {
        display: "inline-flex",
        "&:focus-within": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      },
      row: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        "&:focus-within:has(input:focus)": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      }
    },
    disabled: {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    },
    "aria-disabled": {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  }
});
var Wrapper = styled("div");
var Checkbox = forwardRef38(
  (_a, ref) => {
    var _b = _a, {
      label,
      layout = "inline",
      css: css2,
      id,
      name,
      required,
      hint,
      checked,
      inputStatus,
      disabled,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      value,
      indeterminate,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className,
      loading
    } = _b, props = __objRest(_b, [
      "label",
      "layout",
      "css",
      "id",
      "name",
      "required",
      "hint",
      "checked",
      "inputStatus",
      "disabled",
      "aria-disabled",
      "aria-describedby",
      "value",
      "indeterminate",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "loading"
    ]);
    const hintId = `${id}-hint`;
    return layout === "row" ? /* @__PURE__ */ React67.createElement(Wrapper, { className: "GDS-checkbox-row", css: __spreadProps(__spreadValues({}, css2), { width: "100%" }) }, /* @__PURE__ */ React67.createElement(
      CheckboxLabel,
      {
        className: "GDS-checkbox-label",
        layout,
        htmlFor: id,
        disabled,
        "aria-disabled": ariaDisabled
      },
      /* @__PURE__ */ React67.createElement("span", null, /* @__PURE__ */ React67.createElement(
        LabelText2,
        {
          disabled,
          "aria-disabled": ariaDisabled,
          className: "GDS-checkbox-label-text"
        },
        label
      ), /* @__PURE__ */ React67.createElement("span", { className: "GDS-checkbox-hint" }, hint && generateInputHint({
        hintId,
        hint,
        css: { marginTop: "$quarter" }
      }))),
      /* @__PURE__ */ React67.createElement(
        CheckboxIndicator,
        __spreadValues({
          id,
          name,
          indeterminate,
          inputStatus,
          loading,
          value,
          checked,
          disabled,
          "aria-disabled": ariaDisabled,
          "aria-describedby": ariaDescribedby,
          onClick,
          onChange,
          onBlur,
          onFocus,
          className,
          ref,
          css: {
            marginLeft: "$half"
          }
        }, props)
      )
    )) : /* @__PURE__ */ React67.createElement(Wrapper, { className: "GDS-checkbox-inline", css: css2 }, /* @__PURE__ */ React67.createElement(
      CheckboxLabel,
      {
        className: "GDS-checkbox-label",
        layout,
        htmlFor: id,
        disabled,
        "aria-disabled": ariaDisabled
      },
      /* @__PURE__ */ React67.createElement(
        CheckboxIndicator,
        __spreadValues({
          id,
          name,
          indeterminate,
          inputStatus,
          loading,
          value,
          checked,
          disabled,
          "aria-disabled": ariaDisabled,
          "aria-describedby": `${hintId}${ariaDescribedby ? ` ${ariaDescribedby}` : ""}`,
          onClick,
          onChange,
          onBlur,
          onFocus,
          className,
          ref
        }, props)
      ),
      isValidElement7(label) ? label : /* @__PURE__ */ React67.createElement(
        LabelText2,
        {
          disabled,
          "aria-disabled": ariaDisabled,
          className: "GDS-checkbox-label-text"
        },
        label
      )
    ), hint && /* @__PURE__ */ React67.createElement(
      Wrapper,
      {
        className: "GDS-checkbox-hint",
        css: {
          // CheckboxIndicator width + labelPadding + spacing margin CheckboxIndicator and label
          marginLeft: `calc($oneAndHalf + ${labelPadding} + $half)`
        }
      },
      generateInputHint({ hint, hintId })
    ));
  }
);
Checkbox.displayName = "Checkbox";

// src/components/forms/selectable/radio/radio.tsx
import React69, { forwardRef as forwardRef40, isValidElement as isValidElement8 } from "react";

// src/components/forms/selectable/radio/radio-indicator.tsx
import React68, { forwardRef as forwardRef39 } from "react";
var RadioBase = styled("input", {
  appearance: "none",
  borderRadius: "$circle",
  borderWidth: "$thin",
  borderColor: "$onSurfaceBorderDefault",
  borderStyle: "solid",
  backgroundColor: "$inputBackgroundDefault",
  margin: 0,
  width: "$oneAndHalf",
  height: "$oneAndHalf",
  display: "inline-block",
  "vertical-align": "text-bottom",
  position: "relative",
  transition: "box-shadow $defaultTime ease-in-out",
  "&::before": {
    content: "",
    position: "absolute",
    margin: "auto",
    height: 0,
    width: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
    top: 0,
    transition: "opacity $defaultTime ease-in-out",
    opacity: 0
  },
  "&:checked": {
    borderColor: "$interactiveActionPrimary",
    background: "$interactiveActionPrimary"
  },
  "&:checked::before": {
    border: "4px solid transparent",
    "border-radius": "$circle",
    "outline-offset": "-6px",
    background: "$inputBackgroundDefault",
    opacity: 1
  },
  "&:checked ~ .GDS-selectable-loader": {
    borderColor: "$interactiveActionPrimary",
    backgroundColor: "$interactiveActionPrimary",
    "& svg": {
      color: "$onSurfaceTextReversed"
    }
  },
  '&:disabled, &[aria-disabled], &[aria-readonly="true"]': {
    backgroundColor: "$inputBackgroundDisabled",
    borderColor: "$inputBorderDisabled"
  },
  "&:disabled:checked::before, &[aria-disabled]:checked::before": {
    background: "$onSurfaceTextSubdued"
  },
  '&[aria-readonly="true"]:checked:before': {
    background: "$onSurfaceTextPrimary"
  },
  variants: {
    inputStatus: {
      success: {
        borderColor: "$inputBorderSuccess",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderSuccess"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          "& svg": {
            color: "$inputBorderSuccess"
          }
        },
        "&:checked": {
          borderColor: "$inputBorderSuccess",
          background: "$inputBorderSuccess"
        },
        "&:checked ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          backgroundColor: "$inputBorderSuccess",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderWarning"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          "& svg": {
            color: "$inputBorderWarning"
          }
        },
        "&:checked": {
          borderColor: "$inputBorderWarning",
          background: "$inputBorderWarning"
        },
        "&:checked ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          backgroundColor: "$inputBorderWarning",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      error: {
        borderColor: "$inputBorderCritical",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderCritical"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          "& svg": {
            color: "$inputBorderCritical"
          }
        },
        "&:checked": {
          borderColor: "$inputBorderCritical",
          background: "$inputBorderCritical"
        },
        "&:checked ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          backgroundColor: "$inputBorderCritical",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      }
    }
  }
});
var RadioIndicator = forwardRef39(
  (_a, ref) => {
    var _b = _a, {
      id,
      name,
      value,
      required,
      checked,
      inputStatus,
      loading,
      disabled,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "aria-readonly": ariaReadonly,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className = "",
      css: css2
    } = _b, props = __objRest(_b, [
      "id",
      "name",
      "value",
      "required",
      "checked",
      "inputStatus",
      "loading",
      "disabled",
      "aria-disabled",
      "aria-describedby",
      "aria-readonly",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "css"
    ]);
    return /* @__PURE__ */ React68.createElement(SelectableLoaderWrapper, null, /* @__PURE__ */ React68.createElement(
      RadioBase,
      __spreadValues(__spreadProps(__spreadValues({
        type: "radio",
        id,
        value,
        name,
        checked,
        className: ["GDS-radio", className].join(" "),
        inputStatus
      }, inputStatus === "error" && { "aria-invalid": true }), {
        disabled,
        "aria-disabled": ariaDisabled,
        "aria-describedby": ariaDescribedby,
        "aria-readonly": ariaReadonly,
        onClick,
        onChange,
        onBlur,
        onFocus,
        css: css2,
        ref
      }), props)
    ), loading && /* @__PURE__ */ React68.createElement(SelectableLoader, { inputType: "radio", loading }));
  }
);
RadioIndicator.displayName = "RadioIndicator";

// src/components/forms/selectable/radio/radio.tsx
var SelectableInputLabel = styled("label", {
  typography: "$bodyOne",
  color: "$onSurfaceTextPrimary",
  gap: "$one",
  borderRadius: "$medium",
  padding: "$half",
  "&:hover": {
    backgroundColor: "$inputBackgroundHovered"
  },
  "&:active": {
    backgroundColor: "$inputBackgroundPressed"
  },
  variants: {
    layout: {
      inline: {
        display: "inline-flex",
        "&:focus-within": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      },
      row: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "&:focus-within:has(input:focus)": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      }
    },
    disabled: {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    },
    "aria-disabled": {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  }
});
var RadioLabelText = styled("span", {
  variants: {
    disabled: {
      true: { color: "$onSurfaceTextSubdued" }
    },
    "aria-disabled": {
      true: { color: "$onSurfaceTextSubdued" }
    }
  }
});
var RadioWrapper = styled("div");
var StyledRadioHint = styled("span", { display: "block" });
var Radio = forwardRef40(
  (_a, ref) => {
    var _b = _a, {
      label,
      layout = "inline",
      css: css2,
      id,
      name,
      required,
      hint,
      checked,
      inputStatus,
      disabled,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "aria-readonly": ariaReadonly,
      value,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className,
      loading
    } = _b, props = __objRest(_b, [
      "label",
      "layout",
      "css",
      "id",
      "name",
      "required",
      "hint",
      "checked",
      "inputStatus",
      "disabled",
      "aria-disabled",
      "aria-describedby",
      "aria-readonly",
      "value",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "loading"
    ]);
    const hintId = `${id}-hint`;
    return layout === "inline" ? /* @__PURE__ */ React69.createElement(RadioWrapper, { className: "GDS-radio-inline", css: css2 }, /* @__PURE__ */ React69.createElement(
      SelectableInputLabel,
      {
        htmlFor: id,
        className: "GDS-radio-label",
        layout,
        disabled,
        "aria-disabled": ariaDisabled
      },
      /* @__PURE__ */ React69.createElement(
        RadioIndicator,
        __spreadValues({
          value,
          name,
          id,
          inputStatus,
          checked,
          loading,
          disabled,
          "aria-disabled": ariaDisabled,
          "aria-describedby": `${hintId}${ariaDescribedby ? ` ${ariaDescribedby}` : ""}`,
          "aria-readonly": ariaReadonly,
          onClick,
          onChange,
          onBlur,
          onFocus,
          ref
        }, props)
      ),
      isValidElement8(label) ? label : /* @__PURE__ */ React69.createElement(RadioLabelText, { disabled, "aria-disabled": ariaDisabled }, label)
    ), hint && /* @__PURE__ */ React69.createElement(
      StyledRadioHint,
      {
        className: "GDS-radio-hint",
        css: {
          // calc hint margin to include input size, padding and spacing values
          marginLeft: `calc($one + $oneAndHalf + $half)`
        }
      },
      generateInputHint({ hint, hintId })
    )) : /* @__PURE__ */ React69.createElement(RadioWrapper, { className: "GDS-radio-row", css: css2 }, /* @__PURE__ */ React69.createElement(
      SelectableInputLabel,
      {
        htmlFor: id,
        className: "GDS-radio-label-hint",
        layout,
        disabled,
        "aria-disabled": ariaDisabled
      },
      /* @__PURE__ */ React69.createElement("span", null, isValidElement8(label) ? label : /* @__PURE__ */ React69.createElement(
        RadioLabelText,
        {
          disabled,
          "aria-disabled": ariaDisabled,
          className: "GDS-radio-label"
        },
        label
      ), hint && /* @__PURE__ */ React69.createElement(
        StyledRadioHint,
        {
          className: "GDS-radio-hint",
          css: { marginTop: "$quarter" }
        },
        generateInputHint({ hint, hintId })
      )),
      /* @__PURE__ */ React69.createElement(
        RadioIndicator,
        __spreadValues({
          value,
          name,
          id,
          inputStatus,
          checked,
          loading,
          disabled,
          "aria-disabled": ariaDisabled,
          "aria-describedby": ariaDescribedby,
          "aria-readonly": ariaReadonly,
          onClick,
          onChange,
          onBlur,
          onFocus,
          ref
        }, props)
      )
    ));
  }
);
Radio.displayName = "Radio";

// src/components/forms/select/select.tsx
import React70, { forwardRef as forwardRef41, useState as useState6 } from "react";
var BaseSelect = styled("select", __spreadProps(__spreadValues({
  appearance: "none"
}, inputBorderStyles), {
  typography: "$bodyTwo",
  width: "100%",
  paddingTop: "$threeQuarters",
  paddingBottom: "$threeQuarters",
  paddingRight: "calc($one + $oneAndHalf)",
  backgroundColor: "$inputBackgroundDefault",
  "&:hover": {
    borderColor: "$inputBorderHovered",
    backgroundColor: "$inputBackgroundHovered"
  },
  '&[class*="GDS"]:focus, &:active': __spreadValues({
    borderColor: "transparent"
  }, focusOutlineInner),
  '&:disabled, &[aria-disabled="true"]': __spreadValues({}, disabledInputStyles),
  variants: {
    inputStatus: {
      success: {
        borderColor: "$inputBorderSuccess",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderSuccess"
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderWarning"
        }
      },
      error: {
        borderColor: "$inputBorderCritical",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderCritical"
        }
      }
    }
  }
}));
var SelectWrapper = styled("div", {
  position: "relative"
});
var sharedIconWrapperStyles = {
  display: "flex",
  position: "absolute",
  pointerEvents: "none",
  transformOrigin: "center",
  transform: "translateY(-50%)",
  top: "50%"
};
var LeadingIconWrapper = styled("div", __spreadProps(__spreadValues({}, sharedIconWrapperStyles), {
  left: "$one"
}));
var TrailingIconWrapper = styled("div", __spreadProps(__spreadValues({}, sharedIconWrapperStyles), {
  right: "$one"
}));
var generateOptionElement = ({
  key,
  value,
  label,
  disabled
}) => /* @__PURE__ */ React70.createElement("option", { key: key || value, value, disabled }, label || value);
var LeadingIcon = ({ icon }) => {
  const icons2 = useThemeIcons();
  if (isGDSIconToken(icon, icons2))
    return /* @__PURE__ */ React70.createElement(Icon, { icon, tint: "$onSurfaceIconPrimary" });
  if (React70.isValidElement(icon)) {
    if (isIcon(icon)) {
      return icon;
    }
  }
  return null;
};
var Select = forwardRef41(
  (_a, ref) => {
    var _b = _a, {
      id,
      value,
      defaultValue = "",
      className,
      leadingIcon,
      loading,
      disabled,
      placeholder,
      options,
      children,
      inputStatus,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      autoComplete,
      css: css2,
      onClick,
      onChange: onChangeProp = (e) => e,
      onBlur,
      onFocus
    } = _b, props = __objRest(_b, [
      "id",
      "value",
      "defaultValue",
      "className",
      "leadingIcon",
      "loading",
      "disabled",
      "placeholder",
      "options",
      "children",
      "inputStatus",
      "aria-disabled",
      "aria-describedby",
      "autoComplete",
      "css",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus"
    ]);
    const [hasValue, setHasValue] = useState6(Boolean(value || defaultValue));
    const onChange = (evt) => {
      var _a2;
      const eventValue = (_a2 = evt == null ? void 0 : evt.currentTarget) == null ? void 0 : _a2.value;
      setHasValue(Boolean(eventValue));
      onChangeProp(evt);
    };
    if (options && children) {
      console.warn(
        "The Select component accepts either the options props or child option elements, not both."
      );
    }
    return /* @__PURE__ */ React70.createElement(SelectWrapper, { className: ["GDS-select", className].join(" "), css: css2 }, leadingIcon && /* @__PURE__ */ React70.createElement(LeadingIconWrapper, { className: "GDS-select-leading-icon" }, /* @__PURE__ */ React70.createElement(LeadingIcon, { icon: leadingIcon })), /* @__PURE__ */ React70.createElement(
      BaseSelect,
      __spreadValues(__spreadProps(__spreadValues({
        id,
        value,
        defaultValue,
        className: "GDS-select-menu",
        disabled,
        autoComplete,
        inputStatus
      }, inputStatus === "error" && { "aria-invalid": true }), {
        "aria-disabled": ariaDisabled,
        "aria-describedby": ariaDescribedby,
        css: __spreadValues(__spreadValues({}, leadingIcon ? { paddingLeft: "calc($one + $oneAndHalf + $half)" } : { paddingLeft: "$one" }), hasValue ? { color: "$onSurfaceTextPrimary" } : { color: "$onSurfaceTextSubdued" }),
        ref,
        onClick,
        onChange,
        onBlur,
        onFocus
      }), props),
      placeholder && /* @__PURE__ */ React70.createElement("option", { value: "", disabled: true }, placeholder),
      (options == null ? void 0 : options.length) ? options.map((option) => {
        if ("value" in option)
          return generateOptionElement(option);
        if ("options" in option)
          return /* @__PURE__ */ React70.createElement(
            "optgroup",
            {
              key: option.key || option.label,
              label: option.label
            },
            option.options.map(
              (element) => generateOptionElement(element)
            )
          );
        console.warn(
          "Incorrectly formatted options array. Please refer to Genesis Core Select documentation for correct formatting."
        );
        return null;
      }) : children
    ), /* @__PURE__ */ React70.createElement(TrailingIconWrapper, { className: "GDS-select-trailing-icon" }, loading ? /* @__PURE__ */ React70.createElement(Spinner, { loading }) : /* @__PURE__ */ React70.createElement(Icon, { icon: "interfaceChevronDown", tint: "$onSurfaceIconPrimary" })));
  }
);
Select.displayName = "Select";

// src/components/forms/selectable/choice-button/choice-button.tsx
import React71, { forwardRef as forwardRef42, isValidElement as isValidElement9 } from "react";
var ChoiceButtonWrapper = styled("div");
var getStatusCheckedStyle = (token) => ({
  "&:checked + label": {
    backgroundColor: token,
    borderColor: "transparent",
    transition: "all $defaultTime ease-in-out, border $defaultTime ease-in-out",
    "&:hover": { backgroundColor: token },
    "&:active": { backgroundColor: token }
  }
});
var disabledStyle2 = {
  backgroundColor: "$interactiveActionDisabled",
  border: "transparent",
  color: "$onSurfaceTextSubdued",
  pointerEvents: "none"
};
var InvisibleInput = styled("input", __spreadProps(__spreadValues({}, visuallyHiddenStyle), {
  // Style the label and Icon as siblings of input
  "&:checked + label": {
    color: "$onSurfaceTextReversed",
    backgroundColor: "$interactiveActionPrimary",
    borderColor: "transparent",
    transition: "all $defaultTime ease-in-out, border $defaultTime ease-in-out",
    "&:hover": { backgroundColor: "$interactiveActionHovered" },
    "&:active": { backgroundColor: "$interactiveActionPressed" },
    ".internal-icon": {
      opacity: 1,
      transition: "opacity $defaultTime ease-in-out, border $defaultTime ease-in-out"
    }
  },
  "&:disabled + label": disabledStyle2,
  '&[aria-disabled="true"] + label': disabledStyle2,
  '&[aria-readonly="true"] + label': {
    backgroundColor: "$interactiveActionDisabled",
    border: "transparent",
    color: "$onSurfaceTextReversed"
  },
  "&:focus + label": __spreadValues({
    borderColor: "transparent"
  }, focusOutlineInner),
  "&:checked:focus + label": __spreadProps(__spreadValues({
    borderColor: "transparent"
  }, focusOutlineOuter), {
    boxShadow: "none"
  }),
  variants: {
    inputStatus: {
      success: getStatusCheckedStyle("$successIcon"),
      warning: getStatusCheckedStyle("$warningIcon"),
      error: getStatusCheckedStyle("$criticalIcon")
    }
  }
}));
var Label = styled("label", {
  tabIndex: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: "$threeQuarters",
  paddingBottom: "$threeQuarters",
  paddingRight: "$one",
  paddingLeft: "$one",
  borderRadius: "$inputField",
  border: "$borderWidths$thin solid $inputBorderDefault",
  backgroundColor: "$inputBackgroundDefault",
  color: "$onSurfaceTextPrimary",
  "&:hover": { backgroundColor: "$inputBackgroundHovered" },
  "&:active": { backgroundColor: "$inputBackgroundPressed" },
  variants: {
    inputStatus: {
      success: { borderColor: "$inputBorderSuccess" },
      warning: { borderColor: "$inputBorderWarning" },
      error: { borderColor: "$inputBorderCritical" }
    },
    disabled: {
      true: disabledStyle2
    },
    "aria-disabled": {
      true: disabledStyle2
    }
  }
});
var LabelText3 = styled("span", {
  typography: "$buttonTwo"
});
var ChoiceButton = forwardRef42(
  (_a, ref) => {
    var _b = _a, {
      label,
      id,
      name,
      inputType,
      checked,
      required,
      hint,
      inputStatus,
      disabled,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      value,
      onClick,
      onChange,
      onBlur,
      onFocus,
      loading,
      css: css2
    } = _b, props = __objRest(_b, [
      "label",
      "id",
      "name",
      "inputType",
      "checked",
      "required",
      "hint",
      "inputStatus",
      "disabled",
      "aria-disabled",
      "aria-describedby",
      "value",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "loading",
      "css"
    ]);
    if (!inputType) {
      console.warn(
        'No "inputType" prop detected. Please pass either "checkbox" or "radio".'
      );
      return null;
    }
    const hintId = `${id}-hint`;
    const ariaDescribedbyArray = [];
    if (hint)
      ariaDescribedbyArray.push(hintId);
    if (ariaDescribedby)
      ariaDescribedbyArray.push(ariaDescribedby);
    return /* @__PURE__ */ React71.createElement(ChoiceButtonWrapper, { className: "GDS-choicebutton", css: css2 }, /* @__PURE__ */ React71.createElement(
      InvisibleInput,
      __spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({
        type: inputType,
        id,
        name,
        checked,
        disabled,
        "aria-disabled": ariaDisabled
      }, ariaDescribedbyArray.length > 0 && {
        "aria-describedby": ariaDescribedbyArray.join(" ")
      }), {
        inputStatus,
        value
      }), inputStatus === "error" && { "aria-invalid": true }), {
        ref,
        onClick,
        onChange,
        onBlur,
        onFocus
      }), props)
    ), /* @__PURE__ */ React71.createElement(
      Label,
      {
        className: "GDS-choicebutton-label",
        htmlFor: id,
        disabled,
        "aria-disabled": ariaDisabled,
        inputStatus
      },
      isValidElement9(label) ? label : /* @__PURE__ */ React71.createElement(LabelText3, { className: "GDS-choicebutton-label-text" }, label),
      loading ? /* @__PURE__ */ React71.createElement(Spinner, { loading, css: { marginLeft: "$one" } }) : /* @__PURE__ */ React71.createElement(
        Icon,
        {
          className: "internal-icon",
          icon: "interfaceCheckmark",
          size: 20,
          css: { opacity: 0, marginLeft: "$half", minWidth: 20 }
        }
      )
    ), hint && generateInputHint({ hint, css: { marginTop: "$half" }, hintId }));
  }
);
ChoiceButton.displayName = "ChoiceButton";
export {
  BaseInput,
  Box,
  Button,
  Card,
  Checkbox,
  CheckboxIndicator,
  ChoiceButton,
  Column,
  ColumnLayout,
  Divider,
  Fieldset,
  FieldsetLegend,
  FormField,
  GDSModalPrimitive,
  GDSPopoverPrimitive,
  GDSTabsPrimitive,
  GDSThemeProvider,
  GDSTooltipPrimitive,
  HeadingBar,
  HeadingText,
  Icon,
  ImageMessage,
  InputElements,
  InputHint,
  InputLabel,
  InputStatusMessage,
  Modal,
  NavList,
  ParagraphText,
  Popover,
  Portal,
  Radio,
  RadioIndicator,
  Responsive,
  Scrollable,
  Select,
  SkeletonCircle,
  SkeletonRectangle,
  SkeletonText,
  Spinner,
  StackItem,
  StackLayout,
  StatusBadge,
  StatusBanner,
  StatusBannerEmoji,
  Tabs,
  TextAction,
  TextInput,
  Tooltip,
  UtilityText,
  VisuallyHidden,
  archetypeDarkTheme,
  archetypeLightTheme,
  css,
  focusOutlineInner,
  focusOutlineOuter,
  getFallbackValues,
  getFontWeightNumberByName,
  getFontWeightTokenByNumber,
  getNegativeSpacing,
  keyframes,
  loadTheme,
  queryHelpers,
  styled,
  toPx,
  toRem,
  useClickableCard,
  useMediaQuery,
  useTheme,
  useThemeIcons,
  useThemeRawValues,
  useThemeStrings
};
//# sourceMappingURL=index.js.map